(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireea59"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireea59"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4LPvH", function(module, exports) {
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if (module.exports) module.exports = lazySizes;
})(typeof window != 'undefined' ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    'use strict';
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: 'lazyload',
            loadedClass: 'lazyloaded',
            loadingClass: 'lazyloading',
            preloadClass: 'lazypreload',
            errorClass: 'lazyerror',
            //strictClass: 'lazystrict',
            autosizesClass: 'lazyautosizes',
            fastLoadedClass: 'ls-is-cached',
            iframeLoadMode: 0,
            srcAttr: 'data-src',
            srcsetAttr: 'data-srcset',
            sizesAttr: 'data-sizes',
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = 'addEventListener';
    var _getAttribute = 'getAttribute';
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        'load',
        'error',
        'lazyincluded',
        '_lazyloaded'
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
    };
    var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : 'removeEventListener';
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent('Event');
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]('srcset')) el.setAttribute('srcset', full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
            timeout = null;
            func();
        };
        var later = function() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = 'onscroll' in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
            return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
        };
        var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, 'opacity') || 1) > 0;
                if (visible && getCSS(parent, 'overflow') != 'visible') {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto'))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, 'lazyloaded');
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function(elem, src) {
            var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) source.setAttribute('media', customMedia);
            if (sourceSrcset) source.setAttribute('srcset', sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute('sizes', sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || '');
                }
                firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName('source'), handleSources);
                if (srcset) elem.setAttribute('srcset', srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ('_lazyCache' in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == 'lazy') isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
            var isAuto = sizes == 'auto';
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, 'lazyunveilread').detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener('scroll', altLoadmodeScrollListner, true);
        };
        return {
            _: function() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);
                addEventListener('scroll', throttledCheckElements, true);
                addEventListener('resize', throttledCheckElements, true);
                addEventListener('pageshow', function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                    docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener('hashchange', throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    'focus',
                    'mouseover',
                    'click',
                    'load',
                    'transitionend',
                    'animationend'
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener('load', onload);
                    document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += 'px';
            elem.setAttribute('sizes', width);
            if (regPicture.test(parent.nodeName || '')) {
                sources = parent.getElementsByTagName('source');
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute('sizes', width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, 'lazybeforesizes', {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener('resize', debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});

});

parcelRegister("1PrgP", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "filter", function () { return filter; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $apdun = parcelRequire("apdun");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === 'number') super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $apdun.getWindow)();
    const document = (0, $apdun.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        const html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            let toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf('data-') >= 0) dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(' ');
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(' ');
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $apdun.getWindow)();
    const events = args[0].split(' ');
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionstart', fireCallBack);
    }
    if (callback) dom.on('transitionstart', fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    const window = (0, $apdun.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $apdun.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $apdun.getWindow)();
        const document = (0, $apdun.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    const window = (0, $apdun.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    const window = (0, $apdun.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $apdun.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $apdun.getWindow)();
    const document = (0, $apdun.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $apdun.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $apdun.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $apdun.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $apdun.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === 'undefined') {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut('click');
const blur = shortcut('blur');
const focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const scroll = shortcut('scroll');
var $154fb5342bbf77aa$export$2e2bcd8739ae039 = $;

});
parcelRegister("apdun", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $7936b3cc81c15f7a$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $7936b3cc81c15f7a$export$38b2d434cce3ea22; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $7936b3cc81c15f7a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $7936b3cc81c15f7a$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($7936b3cc81c15f7a$var$isObject(src[key]) && $7936b3cc81c15f7a$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $7936b3cc81c15f7a$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $7936b3cc81c15f7a$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $7936b3cc81c15f7a$export$f65ca476c09acec0() {
    const doc = typeof document !== 'undefined' ? document : {};
    $7936b3cc81c15f7a$export$8b58be045bf06082(doc, $7936b3cc81c15f7a$export$3fdcb9b4d81368d8);
    return doc;
}
const $7936b3cc81c15f7a$export$8582633f185c62bb = {
    document: $7936b3cc81c15f7a$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $7936b3cc81c15f7a$export$38b2d434cce3ea22() {
    const win = typeof window !== 'undefined' ? window : {};
    $7936b3cc81c15f7a$export$8b58be045bf06082(win, $7936b3cc81c15f7a$export$8582633f185c62bb);
    return win;
}

});


parcelRegister("eY55m", function(module, exports) {
const elements = document.querySelectorAll('.js-metaobject-notice');
if (!elements.length > 0) return;
let currentIndex = 0;
function switchElements() {
    if (elements[currentIndex]) elements[currentIndex].classList.remove('active');
    currentIndex = (currentIndex + 1) % elements.length;
    if (elements[currentIndex]) elements[currentIndex].classList.add('active');
}
setInterval(switchElements, 2800);

});

parcelRegister("izvSC", function(module, exports) {
const elements2 = document.querySelectorAll('.js-metaobject-notice-cart');
if (!elements2.length > 0) return;
let currentIndex2 = 0;
function switchElements2() {
    if (elements2[currentIndex2]) elements2[currentIndex2].classList.remove('active');
    currentIndex2 = (currentIndex2 + 1) % elements2.length;
    if (elements2[currentIndex2]) elements2[currentIndex2].classList.add('active');
}
setInterval(switchElements2, 2800);

});

parcelRequire("4LPvH");
var $fb39fc6caf3e5e2a$exports = {};

(function(window1, factory) {
    var globalInstall = function() {
        factory(window1.lazySizes);
        window1.removeEventListener('lazyunveilread', globalInstall, true);
    };
    factory = factory.bind(null, window1, window1.document);
    if ($fb39fc6caf3e5e2a$exports) factory((parcelRequire("4LPvH")));
    else if (typeof define == 'function' && define.amd) define([
        'lazysizes'
    ], factory);
    else if (window1.lazySizes) globalInstall();
    else window1.addEventListener('lazyunveilread', globalInstall, true);
})(window, function(window1, document, lazySizes) {
    /*jshint eqnull:true */ 'use strict';
    var config, riasCfg;
    var lazySizesCfg = lazySizes.cfg;
    var replaceTypes = {
        string: 1,
        number: 1
    };
    var regNumber = /^\-*\+*\d+\.*\d*$/;
    var regPicture = /^picture$/i;
    var regWidth = /\s*\{\s*width\s*\}\s*/i;
    var regHeight = /\s*\{\s*height\s*\}\s*/i;
    var regPlaceholder = /\s*\{\s*([a-z0-9]+)\s*\}\s*/ig;
    var regObj = /^\[.*\]|\{.*\}$/;
    var regAllowedSizes = /^(?:auto|\d+(px)?)$/;
    var anchor = document.createElement('a');
    var img = document.createElement('img');
    var buggySizes = 'srcset' in img && !('sizes' in img);
    var supportPicture = !!window1.HTMLPictureElement && !buggySizes;
    (function() {
        var prop;
        var noop = function() {};
        var riasDefaults = {
            prefix: '',
            postfix: '',
            srcAttr: 'data-src',
            absUrl: false,
            modifyOptions: noop,
            widthmap: {},
            ratio: false,
            traditionalRatio: false,
            aspectratio: false
        };
        config = lazySizes && lazySizes.cfg;
        if (!config.supportsType) config.supportsType = function(type /*, elem*/ ) {
            return !type;
        };
        if (!config.rias) config.rias = {};
        riasCfg = config.rias;
        if (!('widths' in riasCfg)) {
            riasCfg.widths = [];
            (function(widths) {
                var width;
                var i = 0;
                while(!width || width < 3000){
                    i += 5;
                    if (i > 30) i += 1;
                    width = 36 * i;
                    widths.push(width);
                }
            })(riasCfg.widths);
        }
        for(prop in riasDefaults)if (!(prop in riasCfg)) riasCfg[prop] = riasDefaults[prop];
    })();
    function getElementOptions(elem, src, options) {
        var attr, parent, setOption, prop, opts;
        var elemStyles = window1.getComputedStyle(elem);
        if (!options) {
            parent = elem.parentNode;
            options = {
                isPicture: !!(parent && regPicture.test(parent.nodeName || ''))
            };
        } else {
            opts = {};
            for(prop in options)opts[prop] = options[prop];
            options = opts;
        }
        setOption = function(attr, run) {
            var attrVal = elem.getAttribute('data-' + attr);
            if (!attrVal) {
                // no data- attr, get value from the CSS
                var styles = elemStyles.getPropertyValue('--ls-' + attr);
                // at least Safari 9 returns null rather than
                // an empty string for getPropertyValue causing
                // .trim() to fail
                if (styles) attrVal = styles.trim();
            }
            if (attrVal) {
                if (attrVal == 'true') attrVal = true;
                else if (attrVal == 'false') attrVal = false;
                else if (regNumber.test(attrVal)) attrVal = parseFloat(attrVal);
                else if (typeof riasCfg[attr] == 'function') attrVal = riasCfg[attr](elem, attrVal);
                else if (regObj.test(attrVal)) try {
                    attrVal = JSON.parse(attrVal);
                } catch (e) {}
                options[attr] = attrVal;
            } else if (attr in riasCfg && typeof riasCfg[attr] != 'function' && !options[attr]) options[attr] = riasCfg[attr];
            else if (run && typeof riasCfg[attr] == 'function') options[attr] = riasCfg[attr](elem, attrVal);
        };
        for(attr in riasCfg)setOption(attr);
        src.replace(regPlaceholder, function(full, match) {
            if (!(match in options)) setOption(match, true);
        });
        return options;
    }
    function replaceUrlProps(url, options) {
        var candidates = [];
        var replaceFn = function(full, match) {
            return replaceTypes[typeof options[match]] ? options[match] : full;
        };
        candidates.srcset = [];
        if (options.absUrl) {
            anchor.setAttribute('href', url);
            url = anchor.href;
        }
        url = ((options.prefix || '') + url + (options.postfix || '')).replace(regPlaceholder, replaceFn);
        options.widths.forEach(function(width) {
            var widthAlias = options.widthmap[width] || width;
            var ratio = options.aspectratio || options.ratio;
            var traditionalRatio = !options.aspectratio && riasCfg.traditionalRatio;
            var candidate = {
                u: url.replace(regWidth, widthAlias).replace(regHeight, ratio ? traditionalRatio ? Math.round(width * ratio) : Math.round(width / ratio) : ''),
                w: width
            };
            candidates.push(candidate);
            candidates.srcset.push(candidate.c = candidate.u + ' ' + width + 'w');
        });
        return candidates;
    }
    function setSrc(src, opts, elem) {
        var elemW = 0;
        var elemH = 0;
        var sizeElement = elem;
        if (!src) return;
        if (opts.ratio === 'container') {
            // calculate image or parent ratio
            elemW = sizeElement.scrollWidth;
            elemH = sizeElement.scrollHeight;
            while((!elemW || !elemH) && sizeElement !== document){
                sizeElement = sizeElement.parentNode;
                elemW = sizeElement.scrollWidth;
                elemH = sizeElement.scrollHeight;
            }
            if (elemW && elemH) opts.ratio = opts.traditionalRatio ? elemH / elemW : elemW / elemH;
        }
        src = replaceUrlProps(src, opts);
        src.isPicture = opts.isPicture;
        if (buggySizes && elem.nodeName.toUpperCase() == 'IMG') elem.removeAttribute(config.srcsetAttr);
        else elem.setAttribute(config.srcsetAttr, src.srcset.join(', '));
        Object.defineProperty(elem, '_lazyrias', {
            value: src,
            writable: true
        });
    }
    function createAttrObject(elem, src) {
        var opts = getElementOptions(elem, src);
        riasCfg.modifyOptions.call(elem, {
            target: elem,
            details: opts,
            detail: opts
        });
        lazySizes.fire(elem, 'lazyriasmodifyoptions', opts);
        return opts;
    }
    function getSrc(elem) {
        return elem.getAttribute(elem.getAttribute('data-srcattr') || riasCfg.srcAttr) || elem.getAttribute(config.srcsetAttr) || elem.getAttribute(config.srcAttr) || elem.getAttribute('data-pfsrcset') || '';
    }
    addEventListener('lazybeforesizes', function(e) {
        if (e.detail.instance != lazySizes) return;
        var elem, src, elemOpts, sourceOpts, parent, sources, i, len, sourceSrc, sizes, detail, hasPlaceholder, modified, emptyList;
        elem = e.target;
        if (!e.detail.dataAttr || e.defaultPrevented || riasCfg.disabled || !((sizes = elem.getAttribute(config.sizesAttr) || elem.getAttribute('sizes')) && regAllowedSizes.test(sizes))) return;
        src = getSrc(elem);
        elemOpts = createAttrObject(elem, src);
        hasPlaceholder = regWidth.test(elemOpts.prefix) || regWidth.test(elemOpts.postfix);
        if (elemOpts.isPicture && (parent = elem.parentNode)) {
            sources = parent.getElementsByTagName('source');
            for(i = 0, len = sources.length; i < len; i++)if (hasPlaceholder || regWidth.test(sourceSrc = getSrc(sources[i]))) {
                sourceOpts = getElementOptions(sources[i], sourceSrc, elemOpts);
                setSrc(sourceSrc, sourceOpts, sources[i]);
                modified = true;
            }
        }
        if (hasPlaceholder || regWidth.test(src)) {
            setSrc(src, elemOpts, elem);
            modified = true;
        } else if (modified) {
            emptyList = [];
            emptyList.srcset = [];
            emptyList.isPicture = true;
            Object.defineProperty(elem, '_lazyrias', {
                value: emptyList,
                writable: true
            });
        }
        if (modified) {
            if (supportPicture) elem.removeAttribute(config.srcAttr);
            else if (sizes != 'auto') {
                detail = {
                    width: parseInt(sizes, 10)
                };
                polyfill({
                    target: elem,
                    detail: detail
                });
            }
        }
    }, true);
    // partial polyfill
    var polyfill = function() {
        var ascendingSort = function(a, b) {
            return a.w - b.w;
        };
        var reduceCandidate = function(srces) {
            var lowerCandidate, bonusFactor;
            var len = srces.length;
            var candidate = srces[len - 1];
            var i = 0;
            for(i; i < len; i++){
                candidate = srces[i];
                candidate.d = candidate.w / srces.w;
                if (candidate.d >= srces.d) {
                    if (!candidate.cached && (lowerCandidate = srces[i - 1]) && lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)) {
                        bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);
                        if (lowerCandidate.cached) lowerCandidate.d += 0.15 * bonusFactor;
                        if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) candidate = lowerCandidate;
                    }
                    break;
                }
            }
            return candidate;
        };
        var getWSet = function(elem, testPicture) {
            var src;
            if (!elem._lazyrias && lazySizes.pWS && (src = lazySizes.pWS(elem.getAttribute(config.srcsetAttr || ''))).length) {
                Object.defineProperty(elem, '_lazyrias', {
                    value: src,
                    writable: true
                });
                if (testPicture && elem.parentNode) src.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';
            }
            return elem._lazyrias;
        };
        var getX = function(elem) {
            var dpr = window1.devicePixelRatio || 1;
            var optimum = lazySizes.getX && lazySizes.getX(elem);
            return Math.min(optimum || dpr, 2.4, dpr);
        };
        var getCandidate = function(elem, width) {
            var sources, i, len, media, srces, src;
            srces = elem._lazyrias;
            if (srces.isPicture && window1.matchMedia) {
                for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++)if (getWSet(sources[i]) && !sources[i].getAttribute('type') && (!(media = sources[i].getAttribute('media')) || (matchMedia(media) || {}).matches)) {
                    srces = sources[i]._lazyrias;
                    break;
                }
            }
            if (!srces.w || srces.w < width) {
                srces.w = width;
                srces.d = getX(elem);
                src = reduceCandidate(srces.sort(ascendingSort));
            }
            return src;
        };
        var polyfill = function(e) {
            if (e.detail.instance != lazySizes) return;
            var candidate;
            var elem = e.target;
            if (!buggySizes && (window1.respimage || window1.picturefill || lazySizesCfg.pf)) {
                document.removeEventListener('lazybeforesizes', polyfill);
                return;
            }
            if (!('_lazyrias' in elem) && (!e.detail.dataAttr || !getWSet(elem, true))) return;
            candidate = getCandidate(elem, e.detail.width);
            if (candidate && candidate.u && elem._lazyrias.cur != candidate.u) {
                elem._lazyrias.cur = candidate.u;
                candidate.cached = true;
                lazySizes.rAF(function() {
                    elem.setAttribute(config.srcAttr, candidate.u);
                    elem.setAttribute('src', candidate.u);
                });
            }
        };
        if (!supportPicture) addEventListener('lazybeforesizes', polyfill);
        else polyfill = function() {};
        return polyfill;
    }();
});


var $19dab4fe84dd7a64$exports = {};

/*
This plugin extends lazySizes to lazyLoad:
background images, videos/posters and scripts

Background-Image:
For background images, use data-bg attribute:
<div class="lazyload" data-bg="bg-img.jpg"></div>

 Video:
 For video/audio use data-poster and preload="none":
 <video class="lazyload" preload="none" data-poster="poster.jpg" src="src.mp4">
 <!-- sources -->
 </video>

 For video that plays automatically if in view:
 <video
	class="lazyload"
	preload="none"
	muted=""
	data-autoplay=""
	data-poster="poster.jpg"
	src="src.mp4">
</video>

 Scripts:
 For scripts use data-script:
 <div class="lazyload" data-script="module-name.js"></div>


 Script modules using require:
 For modules using require use data-require:
 <div class="lazyload" data-require="module-name"></div>
*/ (function(window1, factory) {
    var globalInstall = function() {
        factory(window1.lazySizes);
        window1.removeEventListener('lazyunveilread', globalInstall, true);
    };
    factory = factory.bind(null, window1, window1.document);
    if ($19dab4fe84dd7a64$exports) factory((parcelRequire("4LPvH")));
    else if (typeof define == 'function' && define.amd) define([
        'lazysizes'
    ], factory);
    else if (window1.lazySizes) globalInstall();
    else window1.addEventListener('lazyunveilread', globalInstall, true);
})(window, function(window1, document, lazySizes) {
    /*jshint eqnull:true */ 'use strict';
    var bgLoad, regBgUrlEscape;
    var uniqueUrls = {};
    if (document.addEventListener) {
        regBgUrlEscape = /\(|\)|\s|'/;
        bgLoad = function(url, cb) {
            var img = document.createElement('img');
            img.onload = function() {
                img.onload = null;
                img.onerror = null;
                img = null;
                cb();
            };
            img.onerror = img.onload;
            img.src = url;
            if (img && img.complete && img.onload) img.onload();
        };
        addEventListener('lazybeforeunveil', function(e) {
            if (e.detail.instance != lazySizes) return;
            var tmp, load, bg, poster;
            if (!e.defaultPrevented) {
                var target = e.target;
                if (target.preload == 'none') target.preload = target.getAttribute('data-preload') || 'auto';
                if (target.getAttribute('data-autoplay') != null) {
                    if (target.getAttribute('data-expand') && !target.autoplay) try {
                        target.play();
                    } catch (er) {}
                    else requestAnimationFrame(function() {
                        target.setAttribute('data-expand', '-10');
                        lazySizes.aC(target, lazySizes.cfg.lazyClass);
                    });
                }
                tmp = target.getAttribute('data-link');
                if (tmp) addStyleScript(tmp, true);
                // handle data-script
                tmp = target.getAttribute('data-script');
                if (tmp) {
                    e.detail.firesLoad = true;
                    load = function() {
                        e.detail.firesLoad = false;
                        lazySizes.fire(target, '_lazyloaded', {}, true, true);
                    };
                    addStyleScript(tmp, null, load);
                }
                // handle data-require
                tmp = target.getAttribute('data-require');
                if (tmp) {
                    if (lazySizes.cfg.requireJs) lazySizes.cfg.requireJs([
                        tmp
                    ]);
                    else addStyleScript(tmp);
                }
                // handle data-bg
                bg = target.getAttribute('data-bg');
                if (bg) {
                    e.detail.firesLoad = true;
                    load = function() {
                        target.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg) + ')';
                        e.detail.firesLoad = false;
                        lazySizes.fire(target, '_lazyloaded', {}, true, true);
                    };
                    bgLoad(bg, load);
                }
                // handle data-poster
                poster = target.getAttribute('data-poster');
                if (poster) {
                    e.detail.firesLoad = true;
                    load = function() {
                        target.poster = poster;
                        e.detail.firesLoad = false;
                        lazySizes.fire(target, '_lazyloaded', {}, true, true);
                    };
                    bgLoad(poster, load);
                }
            }
        }, false);
    }
    function addStyleScript(src, style, cb) {
        if (uniqueUrls[src]) return;
        var elem = document.createElement(style ? 'link' : 'script');
        var insertElem = document.getElementsByTagName('script')[0];
        if (style) {
            elem.rel = 'stylesheet';
            elem.href = src;
        } else {
            elem.onload = function() {
                elem.onerror = null;
                elem.onload = null;
                cb();
            };
            elem.onerror = elem.onload;
            elem.src = src;
        }
        uniqueUrls[src] = true;
        uniqueUrls[elem.src || elem.href] = true;
        insertElem.parentNode.insertBefore(elem, insertElem);
    }
});


var $43e391a139e05df5$var$n = function(n) {
    if ("object" != typeof (t = n) || Array.isArray(t)) throw "state should be an object";
    var t;
}, $43e391a139e05df5$var$t = function(n, t, r, e) {
    var o;
    return (o = n, o.reduce(function(n, t, r) {
        return n.indexOf(t) > -1 ? n : n.concat(t);
    }, [])).reduce(function(n, r) {
        return n.concat(t[r] || []);
    }, []).map(function(n) {
        return n(r, e);
    });
};
function $43e391a139e05df5$var$r(r) {
    void 0 === r && (r = {});
    var e = {};
    return {
        getState: function() {
            return Object.assign({}, r);
        },
        hydrate: function(o) {
            return $43e391a139e05df5$var$n(o), Object.assign(r, o), function() {
                var n = [
                    "*"
                ].concat(Object.keys(o));
                $43e391a139e05df5$var$t(n, e, r);
            };
        },
        on: function(n, t) {
            return (n = [].concat(n)).map(function(n) {
                return e[n] = (e[n] || []).concat(t);
            }), function() {
                return n.map(function(n) {
                    return e[n].splice(e[n].indexOf(t), 1);
                });
            };
        },
        emit: function(o, u, c) {
            var i = ("*" === o ? [] : [
                "*"
            ]).concat(o);
            (u = "function" == typeof u ? u(r) : u) && ($43e391a139e05df5$var$n(u), Object.assign(r, u), i = i.concat(Object.keys(u))), $43e391a139e05df5$var$t(i, e, r, c);
        }
    };
}
$43e391a139e05df5$var$r();
var $43e391a139e05df5$var$e = function(n) {
    return "object" == typeof n && !Array.isArray(n);
}, $43e391a139e05df5$var$o = function(n) {
    return "function" == typeof n;
};
function $43e391a139e05df5$export$d8556a2a8f973135(n) {
    return function(t, r) {
        var e = [];
        return {
            subs: e,
            unmount: n(t, Object.assign({}, r, {
                on: function(n, t) {
                    var o = r.on(n, t);
                    return e.push(o), o;
                }
            })),
            node: t
        };
    };
}
function $43e391a139e05df5$export$a69fbfbaf4cc7edc(n, t, u) {
    void 0 === n && (n = {}), void 0 === t && (t = {}), void 0 === u && (u = []);
    var c = $43e391a139e05df5$var$r(t), i = [];
    return {
        on: c.on,
        emit: c.emit,
        getState: function() {
            return c.getState();
        },
        add: function(t) {
            if (!$43e391a139e05df5$var$e(t)) throw "components should be an object";
            Object.assign(n, t);
        },
        use: function(n) {
            if (!$43e391a139e05df5$var$o(n)) throw "plugins should be a function";
            u.push(n);
        },
        hydrate: function(n) {
            return c.hydrate(n);
        },
        mount: function(t) {
            void 0 === t && (t = "data-component"), t = [].concat(t);
            for(var r = 0; r < t.length; r++){
                for(var a = t[r], f = [].slice.call(document.querySelectorAll("[" + a + "]")), s = function() {
                    for(var t = f.pop(), r = t.getAttribute(a).split(/\s/), s = 0; s < r.length; s++){
                        var v = n[r[s]];
                        if (v) {
                            t.removeAttribute(a);
                            try {
                                var d = u.reduce(function(n, r) {
                                    var o = r(t, c);
                                    return $43e391a139e05df5$var$e(o) ? Object.assign(n, o) : n;
                                }, {}), m = v(t, Object.assign({}, d, c));
                                $43e391a139e05df5$var$o(m.unmount) && i.push(m);
                            } catch (n) {
                                console.error(n), c.emit("error", {
                                    error: n
                                }), c.hydrate({
                                    error: void 0
                                });
                            }
                        }
                    }
                }; f.length;)s();
                c.emit("mount");
            }
        },
        unmount: function() {
            for(var n = i.length - 1; n > -1; n--){
                var t = i[n], r = t.subs;
                (0, t.unmount)(t.node), r.map(function(n) {
                    return n();
                }), i.splice(n, 1);
            }
            c.emit("unmount");
        }
    };
}


const $c0bd171aae5be854$var$Ready = (callback)=>{
    if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(callback, 1);
    else document.addEventListener('DOMContentLoaded', callback, {
        once: true
    });
};
var $c0bd171aae5be854$export$2e2bcd8739ae039 = $c0bd171aae5be854$var$Ready;



var $09568495150d846b$export$2e2bcd8739ae039 = ()=>{
    /**
   * Data + elements
   */ const scrollTriggerSections = document.querySelectorAll('[data-scroll-trigger]');
    const sectionsInView = [];
    /** Functions */ const updateSectionsInView = ()=>{
        scrollTriggerSections.forEach((section)=>{
            const rect = section.getBoundingClientRect();
            const inView = rect.top <= window.innerHeight / 2 && rect.top >= 0 || window.innerHeight - rect.bottom <= window.innerHeight / 2 && window.innerHeight - rect.bottom >= 0 // eslint-disable-line
             || rect.top < 0 && rect.bottom > window.innerHeight;
            const index = sectionsInView.indexOf(section);
            if (inView && index === -1) sectionsInView.push(section);
            else if (!inView && index >= 0) sectionsInView.splice(index, 1);
        });
    };
    const updateBackground = (section)=>{
        if (section && section.dataset.background === 'dark') {
            document.body.classList.remove('light');
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
            document.body.classList.add('light');
        }
    };
    const update = ()=>{
        updateSectionsInView();
        const current = sectionsInView[0];
        updateBackground(current);
        (0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).emit('scrollTrigger', {
            triggeredSection: current
        });
    };
    const init = ()=>{
        if (scrollTriggerSections.length) {
            update();
            (0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).on('window:scroll', update);
        }
    };
    /**
   * Init
   */ init();
};


var $3dbe8f0854ba3ec5$exports = {};
var $a3d7992b95643302$exports = {};
var $47aa665e1d998020$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $47aa665e1d998020$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$47aa665e1d998020$exports = $47aa665e1d998020$var$isObject;


var $936624c9da9da906$exports = {};
var $0a3e71d7ecc97ee9$exports = {};
var $99a2017ae6786c3d$exports = {};
/** Detect free variable `global` from Node.js. */ var $99a2017ae6786c3d$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$99a2017ae6786c3d$exports = $99a2017ae6786c3d$var$freeGlobal;


/** Detect free variable `self`. */ var $0a3e71d7ecc97ee9$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $0a3e71d7ecc97ee9$var$root = $99a2017ae6786c3d$exports || $0a3e71d7ecc97ee9$var$freeSelf || Function('return this')();
$0a3e71d7ecc97ee9$exports = $0a3e71d7ecc97ee9$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $936624c9da9da906$var$now = function() {
    return $0a3e71d7ecc97ee9$exports.Date.now();
};
$936624c9da9da906$exports = $936624c9da9da906$var$now;


var $13558e32c77b0d40$exports = {};
var $92c9e0039bd74bf0$exports = {};
var $658ff43e21e89a94$exports = {};
/** Used to match a single whitespace character. */ var $658ff43e21e89a94$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $658ff43e21e89a94$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $658ff43e21e89a94$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$658ff43e21e89a94$exports = $658ff43e21e89a94$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $92c9e0039bd74bf0$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $92c9e0039bd74bf0$var$baseTrim(string) {
    return string ? string.slice(0, $658ff43e21e89a94$exports(string) + 1).replace($92c9e0039bd74bf0$var$reTrimStart, '') : string;
}
$92c9e0039bd74bf0$exports = $92c9e0039bd74bf0$var$baseTrim;



var $b348c06a8f4ff6d9$exports = {};
var $e5cc99a0715617ef$exports = {};
var $380a42073106e409$exports = {};

/** Built-in value references. */ var $380a42073106e409$var$Symbol = $0a3e71d7ecc97ee9$exports.Symbol;
$380a42073106e409$exports = $380a42073106e409$var$Symbol;


var $d6af9108adb38ae4$exports = {};

/** Used for built-in method references. */ var $d6af9108adb38ae4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d6af9108adb38ae4$var$hasOwnProperty = $d6af9108adb38ae4$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d6af9108adb38ae4$var$nativeObjectToString = $d6af9108adb38ae4$var$objectProto.toString;
/** Built-in value references. */ var $d6af9108adb38ae4$var$symToStringTag = $380a42073106e409$exports ? $380a42073106e409$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d6af9108adb38ae4$var$getRawTag(value) {
    var isOwn = $d6af9108adb38ae4$var$hasOwnProperty.call(value, $d6af9108adb38ae4$var$symToStringTag), tag = value[$d6af9108adb38ae4$var$symToStringTag];
    try {
        value[$d6af9108adb38ae4$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d6af9108adb38ae4$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d6af9108adb38ae4$var$symToStringTag] = tag;
        else delete value[$d6af9108adb38ae4$var$symToStringTag];
    }
    return result;
}
$d6af9108adb38ae4$exports = $d6af9108adb38ae4$var$getRawTag;


var $b32957c0f0b16bf5$exports = {};
/** Used for built-in method references. */ var $b32957c0f0b16bf5$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b32957c0f0b16bf5$var$nativeObjectToString = $b32957c0f0b16bf5$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b32957c0f0b16bf5$var$objectToString(value) {
    return $b32957c0f0b16bf5$var$nativeObjectToString.call(value);
}
$b32957c0f0b16bf5$exports = $b32957c0f0b16bf5$var$objectToString;


/** `Object#toString` result references. */ var $e5cc99a0715617ef$var$nullTag = '[object Null]', $e5cc99a0715617ef$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $e5cc99a0715617ef$var$symToStringTag = $380a42073106e409$exports ? $380a42073106e409$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e5cc99a0715617ef$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e5cc99a0715617ef$var$undefinedTag : $e5cc99a0715617ef$var$nullTag;
    return $e5cc99a0715617ef$var$symToStringTag && $e5cc99a0715617ef$var$symToStringTag in Object(value) ? $d6af9108adb38ae4$exports(value) : $b32957c0f0b16bf5$exports(value);
}
$e5cc99a0715617ef$exports = $e5cc99a0715617ef$var$baseGetTag;


var $6bf9c5bd8aa3a8c5$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6bf9c5bd8aa3a8c5$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$6bf9c5bd8aa3a8c5$exports = $6bf9c5bd8aa3a8c5$var$isObjectLike;


/** `Object#toString` result references. */ var $b348c06a8f4ff6d9$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b348c06a8f4ff6d9$var$isSymbol(value) {
    return typeof value == 'symbol' || $6bf9c5bd8aa3a8c5$exports(value) && $e5cc99a0715617ef$exports(value) == $b348c06a8f4ff6d9$var$symbolTag;
}
$b348c06a8f4ff6d9$exports = $b348c06a8f4ff6d9$var$isSymbol;


/** Used as references for various `Number` constants. */ var $13558e32c77b0d40$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $13558e32c77b0d40$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $13558e32c77b0d40$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $13558e32c77b0d40$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $13558e32c77b0d40$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $13558e32c77b0d40$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($b348c06a8f4ff6d9$exports(value)) return $13558e32c77b0d40$var$NAN;
    if ($47aa665e1d998020$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $47aa665e1d998020$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $92c9e0039bd74bf0$exports(value);
    var isBinary = $13558e32c77b0d40$var$reIsBinary.test(value);
    return isBinary || $13558e32c77b0d40$var$reIsOctal.test(value) ? $13558e32c77b0d40$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $13558e32c77b0d40$var$reIsBadHex.test(value) ? $13558e32c77b0d40$var$NAN : +value;
}
$13558e32c77b0d40$exports = $13558e32c77b0d40$var$toNumber;


/** Error message constants. */ var $a3d7992b95643302$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a3d7992b95643302$var$nativeMax = Math.max, $a3d7992b95643302$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $a3d7992b95643302$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($a3d7992b95643302$var$FUNC_ERROR_TEXT);
    wait = $13558e32c77b0d40$exports(wait) || 0;
    if ($47aa665e1d998020$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $a3d7992b95643302$var$nativeMax($13558e32c77b0d40$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $a3d7992b95643302$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $936624c9da9da906$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($936624c9da9da906$exports());
    }
    function debounced() {
        var time = $936624c9da9da906$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$a3d7992b95643302$exports = $a3d7992b95643302$var$debounce;



/** Error message constants. */ var $3dbe8f0854ba3ec5$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $3dbe8f0854ba3ec5$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($3dbe8f0854ba3ec5$var$FUNC_ERROR_TEXT);
    if ($47aa665e1d998020$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $a3d7992b95643302$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$3dbe8f0854ba3ec5$exports = $3dbe8f0854ba3ec5$var$throttle;



var $0a3f002302d1a4d7$export$2e2bcd8739ae039 = ()=>{
    const scroll = ()=>(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).emit('window:scroll');
    const resize = ()=>(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).emit('window:resize');
    window.addEventListener('scroll', (0, (/*@__PURE__*/$parcel$interopDefault($3dbe8f0854ba3ec5$exports)))(scroll, 100));
    window.addEventListener('resize', (0, (/*@__PURE__*/$parcel$interopDefault($3dbe8f0854ba3ec5$exports)))(resize, 100));
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
};



/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ /* eslint no-param-reassign: "off" */ 
var $apdun = parcelRequire("apdun");

var $1PrgP = parcelRequire("1PrgP");
const $5b8bbfefff87cf90$var$Methods = {
    addClass: $1PrgP.addClass,
    removeClass: $1PrgP.removeClass,
    hasClass: $1PrgP.hasClass,
    toggleClass: $1PrgP.toggleClass,
    attr: $1PrgP.attr,
    removeAttr: $1PrgP.removeAttr,
    transform: $1PrgP.transform,
    transition: $1PrgP.transition,
    on: $1PrgP.on,
    off: $1PrgP.off,
    trigger: $1PrgP.trigger,
    transitionEnd: $1PrgP.transitionEnd,
    outerWidth: $1PrgP.outerWidth,
    outerHeight: $1PrgP.outerHeight,
    styles: $1PrgP.styles,
    offset: $1PrgP.offset,
    css: $1PrgP.css,
    each: $1PrgP.each,
    html: $1PrgP.html,
    text: $1PrgP.text,
    is: $1PrgP.is,
    index: $1PrgP.index,
    eq: $1PrgP.eq,
    append: $1PrgP.append,
    prepend: $1PrgP.prepend,
    next: $1PrgP.next,
    nextAll: $1PrgP.nextAll,
    prev: $1PrgP.prev,
    prevAll: $1PrgP.prevAll,
    parent: $1PrgP.parent,
    parents: $1PrgP.parents,
    closest: $1PrgP.closest,
    find: $1PrgP.find,
    children: $1PrgP.children,
    filter: $1PrgP.filter,
    remove: $1PrgP.remove
};
Object.keys($5b8bbfefff87cf90$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $1PrgP.$).fn, methodName, {
        value: $5b8bbfefff87cf90$var$Methods[methodName],
        writable: true
    });
});
var $5b8bbfefff87cf90$export$2e2bcd8739ae039 = (0, $1PrgP.$);



var $apdun = parcelRequire("apdun");
function $b1fc45f015e34439$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $b1fc45f015e34439$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $b1fc45f015e34439$export$461939dd4422153() {
    return Date.now();
}
function $b1fc45f015e34439$export$3735103072e4a80(el) {
    const window1 = (0, $apdun.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $b1fc45f015e34439$export$5ec402b7fcf74398(el, axis = 'x') {
    const window1 = (0, $apdun.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $b1fc45f015e34439$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $b1fc45f015e34439$export$a6cdc56e425d0d0a(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $b1fc45f015e34439$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $b1fc45f015e34439$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$b1fc45f015e34439$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($b1fc45f015e34439$export$a6cdc56e425d0d0a(to[nextKey]) && $b1fc45f015e34439$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $b1fc45f015e34439$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$b1fc45f015e34439$export$a6cdc56e425d0d0a(to[nextKey]) && $b1fc45f015e34439$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $b1fc45f015e34439$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $b1fc45f015e34439$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $b1fc45f015e34439$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $apdun.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}



var $apdun = parcelRequire("apdun");
let $a1afafdb2aa4ebee$var$support;
function $a1afafdb2aa4ebee$var$calcSupport() {
    const window = (0, $apdun.getWindow)();
    const document = (0, $apdun.getDocument)();
    return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $a1afafdb2aa4ebee$export$d61c7b85ff180578() {
    if (!$a1afafdb2aa4ebee$var$support) $a1afafdb2aa4ebee$var$support = $a1afafdb2aa4ebee$var$calcSupport();
    return $a1afafdb2aa4ebee$var$support;
}



var $apdun = parcelRequire("apdun");

let $c598c284fd9d88af$var$deviceCached;
function $c598c284fd9d88af$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $a1afafdb2aa4ebee$export$d61c7b85ff180578)();
    const window = (0, $apdun.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel'; // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $c598c284fd9d88af$export$30c823bc834d6ab4(overrides = {}) {
    if (!$c598c284fd9d88af$var$deviceCached) $c598c284fd9d88af$var$deviceCached = $c598c284fd9d88af$var$calcDevice(overrides);
    return $c598c284fd9d88af$var$deviceCached;
}



var $apdun = parcelRequire("apdun");
let $07d884031f320b90$var$browser;
function $07d884031f320b90$var$calcBrowser() {
    const window = (0, $apdun.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $07d884031f320b90$export$89e15fc796a4a429() {
    if (!$07d884031f320b90$var$browser) $07d884031f320b90$var$browser = $07d884031f320b90$var$calcBrowser();
    return $07d884031f320b90$var$browser;
}



var $apdun = parcelRequire("apdun");
function $347ecab42cc91dc7$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $apdun.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
}



var $apdun = parcelRequire("apdun");
function $99c65bdb029a5c2b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $apdun.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}


/* eslint-disable no-underscore-dangle */ var $e78728b4b8cb61af$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};


function $3b4b5da8d7b76ba1$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $d456cf59ee5f6872$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $b1fc45f015e34439$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        (0, $b1fc45f015e34439$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $b1fc45f015e34439$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $b1fc45f015e34439$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}



function $da7d8c5d6db77eb6$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}


function $8280cff715dafa0e$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $00b402b7786ecd93$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(swiper.visibleSlides);
}


function $8b644e67c286b1f3$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}


function $e0bfd12215d93cc4$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}


function $3396c9cf688b1039$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}



function $c68b660b90599626$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $466821de9b501737$export$2e2bcd8739ae039 = {
    updateSize: $3b4b5da8d7b76ba1$export$2e2bcd8739ae039,
    updateSlides: $d456cf59ee5f6872$export$2e2bcd8739ae039,
    updateAutoHeight: $da7d8c5d6db77eb6$export$2e2bcd8739ae039,
    updateSlidesOffset: $8280cff715dafa0e$export$2e2bcd8739ae039,
    updateSlidesProgress: $00b402b7786ecd93$export$2e2bcd8739ae039,
    updateProgress: $8b644e67c286b1f3$export$2e2bcd8739ae039,
    updateSlidesClasses: $e0bfd12215d93cc4$export$2e2bcd8739ae039,
    updateActiveIndex: $3396c9cf688b1039$export$2e2bcd8739ae039,
    updateClickedSlide: $c68b660b90599626$export$2e2bcd8739ae039
};



function $bffbadf162ddd659$export$2e2bcd8739ae039(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $b1fc45f015e34439$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $3183c83d0abd7caa$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}


function $3139286ec29411f4$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $c084279293c41d05$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



function $e09fbb9274659e41$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $b1fc45f015e34439$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $84661589b8effa06$export$2e2bcd8739ae039 = {
    getTranslate: $bffbadf162ddd659$export$2e2bcd8739ae039,
    setTranslate: $3183c83d0abd7caa$export$2e2bcd8739ae039,
    minTranslate: $3139286ec29411f4$export$2e2bcd8739ae039,
    maxTranslate: $c084279293c41d05$export$2e2bcd8739ae039,
    translateTo: $e09fbb9274659e41$export$2e2bcd8739ae039
};


function $362d51a736a5d47d$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}


function $efe6959f44dba966$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}


function $c5fdc30b6ce69255$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $efe6959f44dba966$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}



function $846e73751fc85015$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $efe6959f44dba966$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}


var $cb8ad3413079009c$export$2e2bcd8739ae039 = {
    setTransition: $362d51a736a5d47d$export$2e2bcd8739ae039,
    transitionStart: $c5fdc30b6ce69255$export$2e2bcd8739ae039,
    transitionEnd: $846e73751fc85015$export$2e2bcd8739ae039
};



function $68a52fa4a20e42e5$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $b1fc45f015e34439$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $7f6319fcef640463$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $11a23f1aa7d8fcf6$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $034ebf5fd486cf96$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $7c41d1f75d2effdd$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $d425b89d45138550$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $ad173e1dd3b6eaf5$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $b1fc45f015e34439$export$bdd553fddd433dcb)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $b1fc45f015e34439$export$bdd553fddd433dcb)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $d2543b9699844344$export$2e2bcd8739ae039 = {
    slideTo: $68a52fa4a20e42e5$export$2e2bcd8739ae039,
    slideToLoop: $7f6319fcef640463$export$2e2bcd8739ae039,
    slideNext: $11a23f1aa7d8fcf6$export$2e2bcd8739ae039,
    slidePrev: $034ebf5fd486cf96$export$2e2bcd8739ae039,
    slideReset: $7c41d1f75d2effdd$export$2e2bcd8739ae039,
    slideToClosest: $d425b89d45138550$export$2e2bcd8739ae039,
    slideToClickedSlide: $ad173e1dd3b6eaf5$export$2e2bcd8739ae039
};



var $apdun = parcelRequire("apdun");

function $ca0be4a46a3ac334$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $apdun.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $9132f7f07c0fdad8$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit('beforeLoopFix');
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}


function $28aa27d672544ba9$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr('data-swiper-slide-index');
}


var $3c14655d2dea8908$export$2e2bcd8739ae039 = {
    loopCreate: $ca0be4a46a3ac334$export$2e2bcd8739ae039,
    loopFix: $9132f7f07c0fdad8$export$2e2bcd8739ae039,
    loopDestroy: $28aa27d672544ba9$export$2e2bcd8739ae039
};


function $493eb532c72c28fe$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}


function $87b007eb485c9175$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}


var $cd2e3fb54312b476$export$2e2bcd8739ae039 = {
    setGrabCursor: $493eb532c72c28fe$export$2e2bcd8739ae039,
    unsetGrabCursor: $87b007eb485c9175$export$2e2bcd8739ae039
};



var $apdun = parcelRequire("apdun");

var $apdun = parcelRequire("apdun");


function $2b17b42c193076b9$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $apdun.getDocument)() || el === (0, $apdun.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $2b17b42c193076b9$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $apdun.getDocument)();
    const window = (0, $apdun.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $2b17b42c193076b9$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $b1fc45f015e34439$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === 'SELECT') data.isTouched = false;
        }
        if (document.activeElement && (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}



var $apdun = parcelRequire("apdun");


function $7f5d81826b2a1479$export$2e2bcd8739ae039(event) {
    const document = (0, $apdun.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $b1fc45f015e34439$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $e927900d72ad7ce3$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $b1fc45f015e34439$export$461939dd4422153)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $b1fc45f015e34439$export$461939dd4422153)();
    (0, $b1fc45f015e34439$export$bdd553fddd433dcb)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $5e6d22f858a9c277$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $ad72fac9be93d551$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $f7584af5c2964218$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}


let $af0a1181bcca1d89$var$dummyEventAttached = false;
function $af0a1181bcca1d89$var$dummyEventListener() {}
const $af0a1181bcca1d89$var$events = (swiper, method)=>{
    const document = (0, $apdun.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $5e6d22f858a9c277$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]('observerUpdate', (0, $5e6d22f858a9c277$export$2e2bcd8739ae039), true);
};
function $af0a1181bcca1d89$var$attachEvents() {
    const swiper = this;
    const document = (0, $apdun.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $2b17b42c193076b9$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $7f5d81826b2a1479$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $e927900d72ad7ce3$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $f7584af5c2964218$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $ad72fac9be93d551$export$2e2bcd8739ae039).bind(swiper);
    if (support.touch && !$af0a1181bcca1d89$var$dummyEventAttached) {
        document.addEventListener('touchstart', $af0a1181bcca1d89$var$dummyEventListener);
        $af0a1181bcca1d89$var$dummyEventAttached = true;
    }
    $af0a1181bcca1d89$var$events(swiper, 'on');
}
function $af0a1181bcca1d89$var$detachEvents() {
    const swiper = this;
    $af0a1181bcca1d89$var$events(swiper, 'off');
}
var $af0a1181bcca1d89$export$2e2bcd8739ae039 = {
    attachEvents: $af0a1181bcca1d89$var$attachEvents,
    detachEvents: $af0a1181bcca1d89$var$detachEvents
};



const $f0fbf24a8ab5ffe3$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $f0fbf24a8ab5ffe3$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $f0fbf24a8ab5ffe3$var$isGridEnabled(swiper, params);
    const isMultiRow = $f0fbf24a8ab5ffe3$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $b1fc45f015e34439$export$8b58be045bf06082)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}



var $apdun = parcelRequire("apdun");
function $5a7089f7658e0a0c$export$2e2bcd8739ae039(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $apdun.getWindow)();
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}


var $399029ffcc199aed$export$2e2bcd8739ae039 = {
    setBreakpoint: $f0fbf24a8ab5ffe3$export$2e2bcd8739ae039,
    getBreakpoint: $5a7089f7658e0a0c$export$2e2bcd8739ae039
};


function $b785d143858cf583$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $b785d143858cf583$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $b785d143858cf583$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': !support.touch
        },
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(' '));
    swiper.emitContainerClasses();
}


function $dcb270f5d612cb8e$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}


var $938584d890fc96be$export$2e2bcd8739ae039 = {
    addClasses: $b785d143858cf583$export$2e2bcd8739ae039,
    removeClasses: $dcb270f5d612cb8e$export$2e2bcd8739ae039
};



var $apdun = parcelRequire("apdun");

function $589c03878d6c5b12$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $apdun.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $a7415dc9276b5ffd$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}


var $fb417c3c295f3ee1$export$2e2bcd8739ae039 = {
    loadImage: $589c03878d6c5b12$export$2e2bcd8739ae039,
    preloadImages: $a7415dc9276b5ffd$export$2e2bcd8739ae039
};


function $a39f11fa9e1eb4d6$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $a39f11fa9e1eb4d6$export$2e2bcd8739ae039 = {
    checkOverflow: $a39f11fa9e1eb4d6$var$checkOverflow
};


var $815e167237994b8a$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $48ee5ce383a06aed$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $b1fc45f015e34439$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            'navigation',
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $b1fc45f015e34439$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $b1fc45f015e34439$export$8b58be045bf06082)(allModulesParams, obj);
    };
}


const $6a915eceb75a44a6$var$prototypes = {
    eventsEmitter: $e78728b4b8cb61af$export$2e2bcd8739ae039,
    update: $466821de9b501737$export$2e2bcd8739ae039,
    translate: $84661589b8effa06$export$2e2bcd8739ae039,
    transition: $cb8ad3413079009c$export$2e2bcd8739ae039,
    slide: $d2543b9699844344$export$2e2bcd8739ae039,
    loop: $3c14655d2dea8908$export$2e2bcd8739ae039,
    grabCursor: $cd2e3fb54312b476$export$2e2bcd8739ae039,
    events: $af0a1181bcca1d89$export$2e2bcd8739ae039,
    breakpoints: $399029ffcc199aed$export$2e2bcd8739ae039,
    checkOverflow: $a39f11fa9e1eb4d6$export$2e2bcd8739ae039,
    classes: $938584d890fc96be$export$2e2bcd8739ae039,
    images: $fb417c3c295f3ee1$export$2e2bcd8739ae039
};
const $6a915eceb75a44a6$var$extendedDefaults = {};
class $6a915eceb75a44a6$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $b1fc45f015e34439$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(params.el).length > 1) {
            const swipers = [];
            (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(params.el).each((containerEl)=>{
                const newParams = (0, $b1fc45f015e34439$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new $6a915eceb75a44a6$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $a1afafdb2aa4ebee$export$d61c7b85ff180578)();
        swiper.device = (0, $c598c284fd9d88af$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $07d884031f320b90$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $48ee5ce383a06aed$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $b1fc45f015e34439$export$8b58be045bf06082)({}, (0, $815e167237994b8a$export$2e2bcd8739ae039), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $b1fc45f015e34439$export$8b58be045bf06082)({}, swiperParams, $6a915eceb75a44a6$var$extendedDefaults, params);
        swiper.originalParams = (0, $b1fc45f015e34439$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $b1fc45f015e34439$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                const desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $b1fc45f015e34439$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $apdun.getDocument)();
            const wrapper = document.createElement('div');
            $wrapperEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $b1fc45f015e34439$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $b1fc45f015e34439$export$8b58be045bf06082)($6a915eceb75a44a6$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $6a915eceb75a44a6$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $815e167237994b8a$export$2e2bcd8739ae039;
    }
    static installModule(mod) {
        if (!$6a915eceb75a44a6$var$Swiper.prototype.__modules__) $6a915eceb75a44a6$var$Swiper.prototype.__modules__ = [];
        const modules = $6a915eceb75a44a6$var$Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$6a915eceb75a44a6$var$Swiper.installModule(m));
            return $6a915eceb75a44a6$var$Swiper;
        }
        $6a915eceb75a44a6$var$Swiper.installModule(module);
        return $6a915eceb75a44a6$var$Swiper;
    }
}
Object.keys($6a915eceb75a44a6$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($6a915eceb75a44a6$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $6a915eceb75a44a6$var$Swiper.prototype[protoMethod] = $6a915eceb75a44a6$var$prototypes[prototypeGroup][protoMethod];
    });
});
$6a915eceb75a44a6$var$Swiper.use([
    (0, $347ecab42cc91dc7$export$2e2bcd8739ae039),
    (0, $99c65bdb029a5c2b$export$2e2bcd8739ae039)
]);
var $6a915eceb75a44a6$export$2e2bcd8739ae039 = $6a915eceb75a44a6$var$Swiper;




function $ecdceba5b27a97ce$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $b1fc45f015e34439$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 
var $apdun = parcelRequire("apdun");

function $c7e68a7b2947627d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $apdun.getDocument)();
    const window = (0, $apdun.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(document).on('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(document).off('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 
var $apdun = parcelRequire("apdun");


function $643f9592e9d1a79d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $apdun.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $b1fc45f015e34439$export$461939dd4422153)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $b1fc45f015e34439$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $b1fc45f015e34439$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $b1fc45f015e34439$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $b1fc45f015e34439$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $b1fc45f015e34439$export$bdd553fddd433dcb)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $b1fc45f015e34439$export$bdd553fddd433dcb)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $apdun = parcelRequire("apdun");
function $e27509e92567c30c$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $apdun.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement('div');
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $a9e908ce9608037f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(el);
            if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
            if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $e27509e92567c30c$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    });
    on('click', (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



function $eba7e0a9cc2902de$export$2e2bcd8739ae039(classes = '') {
    return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}



function $604711bfadd9afec$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main'
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(' '));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets($bullet, 'next');
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, 'prev');
                            setSideBullets($lastDisplayedBullet, 'next');
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, 'prev');
                        setSideBullets($lastDisplayedBullet, 'next');
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $eba7e0a9cc2902de$export$2e2bcd8739ae039)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $eba7e0a9cc2902de$export$2e2bcd8739ae039)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $eba7e0a9cc2902de$export$2e2bcd8739ae039)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit('paginationRender', $el[0]);
        } else emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $eba7e0a9cc2902de$export$2e2bcd8739ae039)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') emit('paginationRender', swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $e27509e92567c30c$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(el).parents('.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $eba7e0a9cc2902de$export$2e2bcd8739ae039)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $eba7e0a9cc2902de$export$2e2bcd8739ae039)(params.bulletClass));
    }
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        if (!swiper.params.loop) update();
    });
    on('slidesLengthChange', ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on('snapGridLengthChange', ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $apdun = parcelRequire("apdun");



function $c130e49b9c62b958$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $apdun.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $b1fc45f015e34439$export$bdd553fddd433dcb)(()=>{
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $e27509e92567c30c$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $146206ed74014553$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr('data-swiper-parallax') || '0';
        let x = $el.attr('data-swiper-parallax-x');
        let y = $el.attr('data-swiper-parallax-y');
        const scale = $el.attr('data-swiper-parallax-scale');
        const opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((parallaxEl)=>{
            const $parallaxEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $apdun = parcelRequire("apdun");


function $555f615991c70813$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $apdun.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $b1fc45f015e34439$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, $b1fc45f015e34439$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures('on');
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures('off');
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



var $apdun = parcelRequire("apdun");

function $b07fcda47a7bc11c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr('data-background');
            const src = $imageEl.attr('data-src');
            const srcset = $imageEl.attr('data-srcset');
            const sizes = $imageEl.attr('data-sizes');
            const $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', `url("${background}")`);
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each((sourceEl)=>{
                        const $source = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index');
            return (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index') : (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $apdun.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
        }
    }
    on('beforeInit', ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on('init', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('scroll', ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on('scrollbarDragMove resize _freeModeNoMomentumRelease', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('transitionStart', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on('transitionEnd', ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('slideChange', ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on('destroy', ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $5b832addad210f14$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $b1fc45f015e34439$export$bdd553fddd433dcb)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $a108c65b108edd88$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
    }
    function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
    }
    function addElRole($el, role) {
        $el.attr('role', role);
    }
    function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
    }
    function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
    }
    function addElLabel($el, label) {
        $el.attr('aria-label', label);
    }
    function addElId($el, id) {
        $el.attr('id', id);
    }
    function addElLive($el, live) {
        $el.attr('aria-live', live);
    }
    function disableEl($el) {
        $el.attr('aria-disabled', true);
    }
    function enableEl($el) {
        $el.attr('aria-disabled', false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $eba7e0a9cc2902de$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, 'button');
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr('aria-current', 'true');
            else $bulletEl.removeAttr('aria-current');
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== 'BUTTON') {
            addElRole($el, 'button');
            $el.on('keydown', onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on('keydown', (0, $eba7e0a9cc2902de$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on('focus', handleFocus, true);
        swiper.$el.on('pointerdown', handlePointerDown, true);
        swiper.$el.on('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off('keydown', (0, $eba7e0a9cc2902de$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off('focus', handleFocus, true);
        swiper.$el.off('pointerdown', handlePointerDown, true);
        swiper.$el.off('pointerup', handlePointerUp, true);
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



var $apdun = parcelRequire("apdun");
function $af9bd128a2ad22aa$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $apdun.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $apdun.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $apdun.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $apdun.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}



var $apdun = parcelRequire("apdun");

function $293b497da002d551$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $apdun.getDocument)();
    const window = (0, $apdun.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
            emit('hashSet');
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(window).on('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(window).off('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $apdun = parcelRequire("apdun");

function $43bfed812a048812$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $b1fc45f015e34439$export$bdd553fddd433dcb)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit('autoplay');
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit('autoplay');
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $apdun.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit('autoplayPause');
            pause();
        }
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit('autoplayResume');
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', onMouseEnter);
            swiper.$el.on('mouseleave', onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
    }
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $apdun.getDocument)();
            document.addEventListener('visibilitychange', onVisibilityChange);
            attachMouseEvents();
        }
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on('sliderFirstMove', ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on('touchEnd', ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on('destroy', ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $apdun.getDocument)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}




function $b1f942b564c81b85$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $b1fc45f015e34439$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $f50dfe8e30483b7d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $b1fc45f015e34439$export$461939dd4422153)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $b1fc45f015e34439$export$461939dd4422153)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $b1fc45f015e34439$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $e410f732fd5d7434$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                '-webkit-order': newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && `${spaceBetween}px` : '');
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel('width')]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $343844199a82715a$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}


function $47bdb29947845ae0$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $97de73c3666169b5$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $055e5c6170ebec68$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $69098e6e1bdc76de$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $cecf50442eddb724$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $343844199a82715a$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $47bdb29947845ae0$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $97de73c3666169b5$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $055e5c6170ebec68$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $69098e6e1bdc76de$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $73680e20a8067c80$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}


function $a878033838893b22$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden'
    });
    return $slideEl;
}


function $facba3996b784138$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                'webkitTransitionEnd',
                'transitionend'
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}


function $df5991495afe6b72$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $a878033838893b22$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $facba3996b784138$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $73680e20a8067c80$export$2e2bcd8739ae039)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $5938baa72b16a441$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
            'transform-origin': `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    };
    (0, $73680e20a8067c80$export$2e2bcd8739ae039)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}




function $ca3a263cc8c808e4$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}





function $840d8745189283b2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) shadowBefore = (0, $ca3a263cc8c808e4$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (shadowAfter.length === 0) shadowAfter = (0, $ca3a263cc8c808e4$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $5b8bbfefff87cf90$export$2e2bcd8739ae039)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $a878033838893b22$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        (0, $facba3996b784138$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $73680e20a8067c80$export$2e2bcd8739ae039)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}





function $f207be3268003ebb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $a878033838893b22$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $ca3a263cc8c808e4$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'left' : 'top');
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $ca3a263cc8c808e4$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'right' : 'bottom');
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    };
    (0, $73680e20a8067c80$export$2e2bcd8739ae039)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}






function $89fa27846e388c6c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children('.swiper-slide-shadow');
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $ca3a263cc8c808e4$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $a878033838893b22$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css('transform-origin', data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $facba3996b784138$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $73680e20a8067c80$export$2e2bcd8739ae039)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $e7e6b7ca2991fc73$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find('.swiper-slide-shadow');
                if ($shadowEl.length === 0) $shadowEl = (0, $ca3a263cc8c808e4$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $a878033838893b22$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $facba3996b784138$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $73680e20a8067c80$export$2e2bcd8739ae039)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




var $fe0026821a8a8535$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Elements
   */ const sliderElement = node.querySelector('.js-slider');
    const sliderWrapper = node.querySelector('.js-sliderWrapper');
    /**
   * Functions
   */ const initSlider = ()=>{
        let slider;
        const reset = ()=>{
            if (slider?.destroy) slider.destroy();
            const isOverflowing = sliderElement.scrollWidth > sliderElement.getBoundingClientRect().width;
            sliderWrapper.classList[isOverflowing ? 'remove' : 'add']('justify-center');
            slider = new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(sliderElement, {
                modules: [
                    (0, $df5991495afe6b72$export$2e2bcd8739ae039),
                    (0, $43bfed812a048812$export$2e2bcd8739ae039)
                ],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                slidesPerView: 1,
                speed: 1000,
                loop: true
            });
        };
        reset();
    // window.addEventListener('resize', reset);
    };
    const init = ()=>{
        initSlider();
    };
    init();
});




var $12b38cc5b301d542$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)((node, ctx)=>{
    const children = node.querySelectorAll('.appear');
    /**
   * Functions
   */ const init = ()=>{
        const update = (rect)=>{
            const inView = rect.top <= window.innerHeight * 0.75;
            if (inView) children.forEach((child, index)=>{
                setTimeout(()=>{
                    child.classList.add('appear--settled');
                }, index * 300);
            });
        };
        (0, $c0bd171aae5be854$export$2e2bcd8739ae039)(()=>{
            update(node.getBoundingClientRect());
            ctx.on('window:scroll', ()=>{
                update(node.getBoundingClientRect());
            });
        });
    };
    /**
   * Init
   */ init();
});



var $a147a642930fb863$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Functions
   */ const init = ()=>{
        if (document.referrer.includes(window.theme.storeUrl)) node.href = document.referrer;
    };
    /**
   * Init
   */ init();
});



/*!
* focus-trap 7.6.5
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ /*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $081b3ab108166404$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $081b3ab108166404$var$candidateSelector = /* #__PURE__ */ $081b3ab108166404$var$candidateSelectors.join(',');
var $081b3ab108166404$var$NoElement = typeof Element === 'undefined';
var $081b3ab108166404$var$matches = $081b3ab108166404$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $081b3ab108166404$var$getRootNode = !$081b3ab108166404$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $081b3ab108166404$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $081b3ab108166404$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $081b3ab108166404$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($081b3ab108166404$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($081b3ab108166404$var$candidateSelector));
    if (includeContainer && $081b3ab108166404$var$matches.call(el, $081b3ab108166404$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $081b3ab108166404$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($081b3ab108166404$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $081b3ab108166404$var$matches.call(element, $081b3ab108166404$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$081b3ab108166404$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $081b3ab108166404$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $081b3ab108166404$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $081b3ab108166404$var$isContentEditable(node)) && !$081b3ab108166404$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $081b3ab108166404$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $081b3ab108166404$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$081b3ab108166404$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $081b3ab108166404$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $081b3ab108166404$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $081b3ab108166404$var$isHiddenInput = function isHiddenInput(node) {
    return $081b3ab108166404$var$isInput(node) && node.type === 'hidden';
};
var $081b3ab108166404$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $081b3ab108166404$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $081b3ab108166404$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $081b3ab108166404$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $081b3ab108166404$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $081b3ab108166404$var$isRadio = function isRadio(node) {
    return $081b3ab108166404$var$isInput(node) && node.type === 'radio';
};
var $081b3ab108166404$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $081b3ab108166404$var$isRadio(node) && !$081b3ab108166404$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $081b3ab108166404$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $081b3ab108166404$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $081b3ab108166404$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $081b3ab108166404$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $081b3ab108166404$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $081b3ab108166404$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($081b3ab108166404$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $081b3ab108166404$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $081b3ab108166404$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($081b3ab108166404$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $081b3ab108166404$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $081b3ab108166404$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $081b3ab108166404$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $081b3ab108166404$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $081b3ab108166404$var$isInert(node) || $081b3ab108166404$var$isHiddenInput(node) || $081b3ab108166404$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $081b3ab108166404$var$isDetailsWithSummary(node) || $081b3ab108166404$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $081b3ab108166404$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($081b3ab108166404$var$isNonTabbableRadio(node) || $081b3ab108166404$export$a4672efddb4181b8(node) < 0 || !$081b3ab108166404$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $081b3ab108166404$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $081b3ab108166404$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $081b3ab108166404$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($081b3ab108166404$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $081b3ab108166404$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $081b3ab108166404$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $081b3ab108166404$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $081b3ab108166404$var$isValidShadowRootTabbable
    });
    else candidates = $081b3ab108166404$var$getCandidates(container, options.includeContainer, $081b3ab108166404$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $081b3ab108166404$var$sortByOrder(candidates);
};
var $081b3ab108166404$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $081b3ab108166404$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $081b3ab108166404$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $081b3ab108166404$var$getCandidates(container, options.includeContainer, $081b3ab108166404$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $081b3ab108166404$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($081b3ab108166404$var$matches.call(node, $081b3ab108166404$var$candidateSelector) === false) return false;
    return $081b3ab108166404$var$isNodeMatchingSelectorTabbable(options, node);
};
var $081b3ab108166404$var$focusableCandidateSelector = /* #__PURE__ */ $081b3ab108166404$var$candidateSelectors.concat('iframe').join(',');
var $081b3ab108166404$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($081b3ab108166404$var$matches.call(node, $081b3ab108166404$var$focusableCandidateSelector) === false) return false;
    return $081b3ab108166404$var$isNodeMatchingSelectorFocusable(options, node);
};


function $842b4b591686e255$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $842b4b591686e255$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $842b4b591686e255$var$_arrayLikeToArray(r);
}
function $842b4b591686e255$var$_defineProperty(e, r, t) {
    return (r = $842b4b591686e255$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $842b4b591686e255$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $842b4b591686e255$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $842b4b591686e255$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $842b4b591686e255$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $842b4b591686e255$var$ownKeys(Object(t), true).forEach(function(r) {
            $842b4b591686e255$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $842b4b591686e255$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $842b4b591686e255$var$_toConsumableArray(r) {
    return $842b4b591686e255$var$_arrayWithoutHoles(r) || $842b4b591686e255$var$_iterableToArray(r) || $842b4b591686e255$var$_unsupportedIterableToArray(r) || $842b4b591686e255$var$_nonIterableSpread();
}
function $842b4b591686e255$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $842b4b591686e255$var$_toPropertyKey(t) {
    var i = $842b4b591686e255$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $842b4b591686e255$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $842b4b591686e255$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $842b4b591686e255$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $842b4b591686e255$var$activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap._setPausedState(true);
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0 && !trapStack[trapStack.length - 1]._isManuallyPaused()) trapStack[trapStack.length - 1]._setPausedState(false);
    }
};
var $842b4b591686e255$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var $842b4b591686e255$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Escape' || (e === null || e === void 0 ? void 0 : e.key) === 'Esc' || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $842b4b591686e255$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Tab' || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $842b4b591686e255$var$isKeyForward = function isKeyForward(e) {
    return $842b4b591686e255$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $842b4b591686e255$var$isKeyBackward = function isKeyBackward(e) {
    return $842b4b591686e255$var$isTabEvent(e) && e.shiftKey;
};
var $842b4b591686e255$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $842b4b591686e255$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var $842b4b591686e255$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $842b4b591686e255$var$internalTrapStack = [];
var $842b4b591686e255$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $842b4b591686e255$var$internalTrapStack;
    var config = $842b4b591686e255$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: $842b4b591686e255$var$isKeyForward,
        isKeyBackward: $842b4b591686e255$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        manuallyPaused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === 'function' ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @param {Object} options
   * @param {boolean} [options.hasFallback] True if the option could be a selector string
   *  and the option allows for a fallback scenario in the case where the selector is
   *  valid but does not match a node (i.e. the queried node doesn't exist in the DOM).
   * @param {Array} [options.params] Params to pass to the option if it's a function.
   * @returns {undefined | null | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `null` if the option didn't resolve
   *  to a node but `options.hasFallback=true`, `false` if the option resolved to `false`
   *  (node explicitly not given); otherwise, the resolved DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node, unless the option is a selector string and `options.hasFallback=true`.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$hasFallback = _ref2.hasFallback, hasFallback = _ref2$hasFallback === void 0 ? false : _ref2$hasFallback, _ref2$params = _ref2.params, params = _ref2$params === void 0 ? [] : _ref2$params;
        var optionValue = config[optionName];
        if (typeof optionValue === 'function') optionValue = optionValue.apply(void 0, $842b4b591686e255$var$_toConsumableArray(params));
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === 'string') {
            try {
                node = doc.querySelector(optionValue); // resolve to node, or null if fails
            } catch (err) {
                throw new Error("`".concat(optionName, "` appears to be an invalid selector; error=\"").concat(err.message, "\""));
            }
            if (!node) {
                if (!hasFallback) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            // else, `node` MUST be `null` because that's what `Document.querySelector()` returns
            //  if the selector is valid but doesn't match anything
            }
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption('initialFocus', {
            hasFallback: true
        });
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || node && !(0, $081b3ab108166404$export$4c063cf1350e6fed)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption('fallbackFocus');
            }
        } else if (node === null) // option is a VALID selector string that doesn't yield a node: use the `fallbackFocus`
        //  option instead of the default behavior when the option isn't specified at all
        node = getNodeForOption('fallbackFocus');
        if (!node) throw new Error('Your focus-trap needs to have at least one focusable element');
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $081b3ab108166404$export$17100aea90429aa7)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $081b3ab108166404$export$ecc6d1fcdff4f700)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $081b3ab108166404$export$bebd5a1431fec25d)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $081b3ab108166404$export$bebd5a1431fec25d)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $081b3ab108166404$export$a4672efddb4181b8)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $081b3ab108166404$export$bebd5a1431fec25d)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $081b3ab108166404$export$bebd5a1431fec25d)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
        ) throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var _getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return _getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var _tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === _getActiveElement(document)) return;
        if (!node || !node.focus) {
            _tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($842b4b591686e255$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption('setReturnFocus', {
            params: [
                previousActiveElement
            ]
        });
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref3) {
        var target = _ref3.target, event = _ref3.event, _ref3$isBackward = _ref3.isBackward, isBackward = _ref3$isBackward === void 0 ? false : _ref3$isBackward;
        target = target || $842b4b591686e255$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = state.tabbableGroups.findIndex(function(_ref4) {
                    var firstTabbableNode = _ref4.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $081b3ab108166404$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $081b3ab108166404$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $081b3ab108166404$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$842b4b591686e255$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = state.tabbableGroups.findIndex(function(_ref5) {
                    var lastTabbableNode = _ref5.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $081b3ab108166404$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $081b3ab108166404$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $081b3ab108166404$export$a4672efddb4181b8)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$842b4b591686e255$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption('fallbackFocus');
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $842b4b591686e255$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($842b4b591686e255$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($842b4b591686e255$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $842b4b591686e255$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $081b3ab108166404$export$a4672efddb4181b8)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $081b3ab108166404$export$a4672efddb4181b8)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) _tryFocus(nextNode);
            else _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($842b4b591686e255$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            _tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkTabKey = function checkTabKey(event) {
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    // we use a different event phase for the Escape key to allow canceling the event and checking for this in escapeDeactivates
    var checkEscapeKey = function checkEscapeKey(event) {
        if ($842b4b591686e255$var$isEscapeEvent(event) && $842b4b591686e255$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
        }
    };
    var checkClick = function checkClick(e) {
        var target = $842b4b591686e255$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($842b4b591686e255$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($842b4b591686e255$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $842b4b591686e255$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $842b4b591686e255$var$delay(function() {
            _tryFocus(getInitialFocusNode());
        }) : _tryFocus(getInitialFocusNode());
        doc.addEventListener('focusin', checkFocusIn, true);
        doc.addEventListener('mousedown', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('touchstart', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('click', checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkTabKey, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkEscapeKey);
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener('focusin', checkFocusIn, true);
        doc.removeEventListener('mousedown', checkPointerDown, true);
        doc.removeEventListener('touchstart', checkPointerDown, true);
        doc.removeEventListener('click', checkClick, true);
        doc.removeEventListener('keydown', checkTabKey, true);
        doc.removeEventListener('keydown', checkEscapeKey);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) _tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, 'onActivate');
            var onPostActivate = getOption(activateOptions, 'onPostActivate');
            var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = _getActiveElement(doc);
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $842b4b591686e255$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $842b4b591686e255$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, 'onDeactivate');
            var onPostDeactivate = getOption(options, 'onPostDeactivate');
            var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
            var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $842b4b591686e255$var$delay(function() {
                    if (returnFocus) _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = true;
            return this._setPausedState(true, pauseOptions);
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = false;
            if (trapStack[trapStack.length - 1] !== this) return this;
            return this._setPausedState(false, unpauseOptions);
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === 'string' ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    Object.defineProperties(trap, {
        _isManuallyPaused: {
            value: function value() {
                return state.manuallyPaused;
            }
        },
        _setPausedState: {
            value: function value(paused, options) {
                if (state.paused === paused) return this;
                state.paused = paused;
                if (paused) {
                    var onPause = getOption(options, 'onPause');
                    var onPostPause = getOption(options, 'onPostPause');
                    onPause === null || onPause === void 0 || onPause();
                    removeListeners();
                    updateObservedNodes();
                    onPostPause === null || onPostPause === void 0 || onPostPause();
                } else {
                    var onUnpause = getOption(options, 'onUnpause');
                    var onPostUnpause = getOption(options, 'onPostUnpause');
                    onUnpause === null || onUnpause === void 0 || onUnpause();
                    updateTabbableNodes();
                    addListeners();
                    updateObservedNodes();
                    onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
                }
                return this;
            }
        }
    });
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};


const $581e6c1bb6c96527$export$42ffd38884aecdac = (node)=>{
    while(node.firstChild)node.removeChild(node.firstChild);
};
const $581e6c1bb6c96527$export$472761e5909fca2d = (node)=>{
    // eslint-disable-next-line no-void
    node.offsetHeight;
};
var $581e6c1bb6c96527$export$2e2bcd8739ae039 = {
    clear: $581e6c1bb6c96527$export$42ffd38884aecdac,
    repaint: $581e6c1bb6c96527$export$472761e5909fca2d
};



class $eddcbc136a01aca6$var$Overlay {
    constructor(){
        this.classes = {
            active: 'overlay--active'
        };
        this.isActive = false;
        this.element = document.createElement('div');
        this.element.innerHTML = '&nbsp;';
        this.element.hidden = true;
        this.element.classList.add('overlay');
        document.body.appendChild(this.element);
        this.toggle = this.toggle.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }
    toggle() {
        if (this.element.classList.contains(this.classes.active)) this.hide();
        else this.show();
    }
    show(index = null) {
        this.isActive = true;
        this.element.hidden = false;
        (0, $581e6c1bb6c96527$export$472761e5909fca2d)(this.element);
        this.element.style.zIndex = index;
        this.element.classList.add(this.classes.active);
    }
    hide() {
        this.isActive = false;
        this.element.style.zIndex = null;
        this.element.classList.remove(this.classes.active);
        const transitionDuration = parseFloat(getComputedStyle(this.element).getPropertyValue('transition-duration')) || 0;
        if (transitionDuration === 0) this.element.hidden = true;
        else {
            this.element.addEventListener('transitionend', ()=>{
                if (this.isActive === false) this.element.hidden = true;
            }, {
                once: true
            });
            if (this.isActive === false) this.element.hidden = true;
        }
    }
}
const $eddcbc136a01aca6$var$overlay = new $eddcbc136a01aca6$var$Overlay();
const { show: $eddcbc136a01aca6$export$57bf213be019eeb0, hide: $eddcbc136a01aca6$export$fe8985bb6374093c, toggle: $eddcbc136a01aca6$export$e03c1c3201ee8bb7 } = $eddcbc136a01aca6$var$overlay;


var $64460de2c96a6acf$export$2e2bcd8739ae039 = (element, callback, options = false)=>{
    const hasDuration = parseFloat(getComputedStyle(element).getPropertyValue('transition-duration') || '0') !== 0;
    if (hasDuration) element.addEventListener('transitionend', (event)=>{
        callback(event);
    }, options);
    else callback();
};


class $574a33c97073f263$var$Openable {
    constructor(element, useOverlay = true){
        this.isActive = false;
        this.useOverlay = useOverlay;
        if (typeof element === 'string' || element instanceof String) this.container = document.querySelector(element);
        else this.container = element;
        this.container.hidden = true;
        this.setState(false);
        this.focusTrap = $842b4b591686e255$export$360440dfcba94c00(this.container, {
            allowOutsideClick: true
        });
        this.clickEvent = this.clickEvent.bind(this);
        this.keydownEvent = this.keydownEvent.bind(this);
        this.addEventListeners = this.addEventListeners.bind(this);
        this.on = this.on.bind(this);
    }
    addEventListeners() {
        document.addEventListener('touchstart', this.clickEvent);
        document.addEventListener('click', this.clickEvent);
        document.addEventListener('keydown', this.keydownEvent);
        this.focusTrap.activate();
    }
    removeEventListeners() {
        document.removeEventListener('touchstart', this.clickEvent);
        document.removeEventListener('click', this.clickEvent);
        document.removeEventListener('keydown', this.keydownEvent);
        this.focusTrap.deactivate();
    }
    clickEvent(event) {
        if (!this.container.contains(event.target)) {
            event.stopPropagation();
            this.close();
        }
    }
    keydownEvent(event) {
        if (event.key === 'Escape') this.close();
    }
    setState(state) {
        this.isActive = state;
        this.container.setAttribute('aria-hidden', state ? 'false' : 'true');
    }
    toggle() {
        if (this.isActive) this.close();
        else this.open();
    }
    open() {
        document.documentElement.style.overflow = 'hidden';
        this.setState(true);
        this.container.hidden = false;
        (0, $581e6c1bb6c96527$export$472761e5909fca2d)(this.container);
        this.container.classList.add(this.classes.active);
        if (this.useOverlay) (0, $eddcbc136a01aca6$export$57bf213be019eeb0)();
        setTimeout(()=>{
            this.addEventListeners();
        }, 0);
        if (this.onOpen) this.onOpen();
    }
    close() {
        document.documentElement.style.overflow = '';
        this.setState(false);
        this.container.classList.remove(this.classes.active);
        if (this.useOverlay) (0, $eddcbc136a01aca6$export$fe8985bb6374093c)();
        this.removeEventListeners();
        (0, $64460de2c96a6acf$export$2e2bcd8739ae039)(this.container, ()=>{
            if (!this.isActive) {
                this.container.hidden = true;
                if (this.onClosed) this.onClosed();
            }
        }, {
            once: true
        });
        if (this.onClose) this.onClose();
    }
    on(event, func) {
        if (event === 'close') this.onClose = func;
        if (event === 'closed') this.onClosed = func;
        if (event === 'open') this.onOpen = func;
    }
}
var $574a33c97073f263$export$2e2bcd8739ae039 = $574a33c97073f263$var$Openable;


class $7d34f06a6f1944e4$var$Drawer extends (0, $574a33c97073f263$export$2e2bcd8739ae039) {
    constructor(element){
        super(element);
        this.classes = {
            active: 'drawer--active'
        };
    }
}
var $7d34f06a6f1944e4$export$2e2bcd8739ae039 = (element)=>new $7d34f06a6f1944e4$var$Drawer(element);



var $b4e54990fb45238d$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const mobileList = node.querySelector('.js-mobileList');
    const mobileListBtn = node.querySelector('.js-mobileListBtn');
    const mobileListCloseBtn = node.querySelector('.js-mobileListCloseBtn');
    /**
   * Functions
   */ const init = ()=>{
        const mobileListDrawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(mobileList);
        mobileListBtn.addEventListener('click', ()=>mobileListDrawer.open());
        mobileListCloseBtn.addEventListener('click', ()=>mobileListDrawer.close());
    };
    /**
   * Init
   */ (0, $c0bd171aae5be854$export$2e2bcd8739ae039)(init);
});





var $e77226b17f738052$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    const triggers = document.querySelectorAll(`[data-trigger=${node.id}]`);
    const campaignBanner = document.querySelector('[data-campaign]');
    (0, $c0bd171aae5be854$export$2e2bcd8739ae039)(()=>{
        document.documentElement.style.setProperty('--campaign', `${campaignBanner.scrollHeight}px`);
    });
    const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(node);
    triggers.forEach((trigger)=>{
        trigger.addEventListener('click', ()=>{
            if (!trigger.hasAttribute('data-clicked')) drawer.open();
            trigger.setAttribute('data-clicked', 'true');
        });
    });
    const toggleChildren = ()=>{
        triggers.forEach((trigger)=>{
            trigger.childNodes.forEach((child)=>{
                child.hidden = !child.hidden;
            });
        });
    };
    drawer.on('open', ()=>{
        campaignBanner.style.zIndex = '9999';
        toggleChildren();
        // Hacky scroll fix, because of repaint
        setTimeout(()=>{
            node.firstElementChild.scrollTop = 0;
        }, 50);
    });
    drawer.on('close', ()=>{
        toggleChildren();
    });
    drawer.on('closed', ()=>{
        campaignBanner.style.zIndex = 'auto';
        triggers.forEach((trigger)=>{
            trigger.removeAttribute('data-clicked');
        });
    });
});




var $17438218f14aff15$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const itemCountOutput = node.querySelector('.js-itemCount');
    /**
   * Functions
   */ const updateItemCount = (count)=>{
        itemCountOutput.textContent = `(${count})`;
    };
    const handleClick = (event)=>{
        event.preventDefault();
        if (document.querySelector('header.header').classList.contains('header--megamenu-open')) document.querySelector('header.header').classList.remove('header--megamenu-open');
        document.querySelectorAll('.header__megamenu').forEach((el)=>{
            if (el.classList.contains('header__megamenu--active')) el.classList.remove('header__megamenu--active');
        });
        (0, $eddcbc136a01aca6$export$57bf213be019eeb0)();
        ctx.emit('cart:toggle');
    };
    const init = ()=>{
        ctx.on('cart:updated', ({ itemCount: itemCount })=>updateItemCount(itemCount));
        node.addEventListener('click', handleClick);
    };
    /**
   * Init
   */ init();
});




/**
 * Fetch cart
 * @returns {object} cart
 */ const $92d139db6aba612b$export$4c0e529601ca5c3b = ()=>fetch('/cart?view=data', {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then((response)=>response.json());
/**
 * Add item to cart based on variant ID
 * @param {int} variantId
 * @param {int} quantity
 * @param {function} callback
 */ const $92d139db6aba612b$export$509a42920845e675 = ({ variantId: variantId, quantity: quantity, callback: callback })=>new Promise((resolve)=>{
        (0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).emit('cart:disable');
        const formData = {
            id: variantId,
            quantity: quantity,
            sections: 'cart-drawer'
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then((response)=>response.json()).then(async ({ sections: sections })=>{
            const { itemCount: itemCount, items: items, cartTotal: cartTotal } = await $92d139db6aba612b$export$4c0e529601ca5c3b();
            const cartDrawerMarkup = sections['cart-drawer'];
            (0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).emit('cart:updated', {
                itemCount: itemCount,
                items: items,
                cartDrawerMarkup: cartDrawerMarkup,
                cartTotal: cartTotal
            });
            if (callback) callback();
            resolve((0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).emit('cart:enable'));
        });
    });
/**
 * Change cart item
 * @param {string} key - can either be line item key or variant ID
 * @param {int} quantity
 * @param {function} callback
 */ const $92d139db6aba612b$export$af6dc614fffa1a5c = ({ key: key, quantity: quantity, callback: callback })=>new Promise((resolve)=>{
        (0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).emit('cart:disable');
        const formData = {
            id: key,
            quantity: quantity,
            sections: 'cart-drawer'
        };
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then((response)=>response.json()).then(async (data)=>{
            const { itemCount: itemCount, items: items, cartTotal: cartTotal } = await $92d139db6aba612b$export$4c0e529601ca5c3b();
            const cartDrawerMarkup = data.sections['cart-drawer'];
            (0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).emit('cart:updated', {
                itemCount: itemCount,
                items: items,
                cartDrawerMarkup: cartDrawerMarkup,
                cartTotal: cartTotal
            });
            if (callback) callback();
            resolve((0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).emit('cart:enable'));
        });
    });


var $09ca314239692cf2$export$2e2bcd8739ae039 = (title)=>{
    let markup = '';
    const splitTitle = title.split(' ');
    const titleFirst = splitTitle[0].toLowerCase();
    if (titleFirst === 'the') markup += `<span class="the text-[0.75em] mr-[0.3em]">${splitTitle.splice(0, 1)}</span>`;
    if (splitTitle.length) markup += `<span class="font-serif font-semibold">${splitTitle.join(' ')}</span>`;
    return markup;
};


var $35e8efbb4fe4d154$export$2e2bcd8739ae039 = (image, aspect = image.width / image.height)=>{
    const sizes = [];
    const widths = [
        30,
        60,
        90,
        120,
        150,
        180,
        210,
        240,
        270,
        300,
        330,
        360,
        390,
        420,
        450,
        480,
        510,
        540,
        570,
        600,
        630,
        660,
        690,
        720,
        750,
        780,
        810,
        840,
        870,
        900,
        930,
        960,
        1020,
        1080,
        1140,
        1200,
        1260,
        1320,
        1380,
        1440,
        1500,
        1560,
        1620,
        1680,
        1740,
        1800,
        1860,
        1920,
        2040,
        2160,
        2280,
        2400,
        2520,
        2640,
        2760,
        2880
    ];
    for(let i = 0; i < widths.length; i += 1){
        const width = widths[i];
        const height = width / aspect;
        if (image.width <= width) break;
        if (image.height <= height) break;
        sizes.push(width);
    }
    return `
  <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
     data-src="${Shopify.Image.getSizedImageUrl(image.src ?? image.url, '{width}x{height}_crop_center')}"
     data-aspectratio="${aspect}"
     data-sizes="auto"
     data-widths="[${sizes.join(',')}]"
     alt="${image.alt ?? ''}"
     class="lazyload">
  `;
};


var $c0e8b6328a3855c8$export$2e2bcd8739ae039 = (item, config)=>{
    const getDetail = ()=>{
        const { color: color, detail: detail } = item;
        let markup = '';
        if (detail) markup = `<span class="p-[6px] font-sans text-[9px] leading-none uppercase font-bold bg-grey-700 text-white whitespace-nowrap">${item.detail}</span>`;
        else if (color) markup = `<p class="text-sm capitalize text-grey-400 empty:hidden">${color}</p>`;
        return markup;
    };
    const getDiscountString = ()=>{
        const beforePrice = item.compare_at_price;
        if (beforePrice && beforePrice > item.price) {
            let discount = Math.floor((beforePrice - item.price) / beforePrice * 100);
            if (discount == 0) discount = 1;
            const discountString = config.discountType === 'percent' ? `-${discount}%` : `-${Shopify.formatMoney(discount)}`;
            return discountString;
        }
        return '';
    };
    const getBeforePrice = ()=>{
        const beforePrice = item.compare_at_price;
        if (beforePrice && beforePrice > item.price) return Shopify.formatMoney(beforePrice, window.theme.moneyFormat);
        else return '';
    };
    const getPrice = ()=>{
        const discount = 0;
        let price;
        if (config.discountType === 'percent') price = item.price - item.price / 100 * discount;
        else if (config.discountType === 'cents') price = item.price - discount;
        return Shopify.formatMoney(price, window.theme.moneyFormat);
    };
    const getPriceInfo = ()=>{
        if (item.available) return `<p class="text-red-discount empty:hidden">${getDiscountString()}</p>
        <p class="text-grey-400 line-through empty:hidden">${getBeforePrice()}</p>
        <p class="text-xs">${getPrice()}</p>`;
        return '';
    };
    const getBtn = ()=>{
        if (item.available) return window.theme.templates.upsellItemAddBtn;
        return `<a href="${item.url}" class="button button--small button--outlined-dark">
        ${window.theme.strings.cart.upsell.signUp}
      </a>`;
    };
    function getItemLengthValue(itemLength) {
        if (itemLength !== null && itemLength !== "Standard") return `<span class="upsell_item__size font-medium text-white px-2 py-1 rounded-sm bg-grey-400 ml-2 lg:ml-4">${itemLength}</span>`;
        else return '';
    }
    function getSize(itemSize) {
        return getItemLengthValue(item.length) ? `${itemSize}` : itemSize;
    }
    return window.theme.templates.upsellItem.replace('%variantId%', item.id).replaceAll('%url%', item.url).replace('%img%', (0, $35e8efbb4fe4d154$export$2e2bcd8739ae039)(item.image)).replaceAll('%title%', item.productTitle).replace('%productTitle%', (0, $09ca314239692cf2$export$2e2bcd8739ae039)(item.productTitle)).replace('%detail%', getDetail()).replace('%fit%', item.fit).replace('%size%', getSize(item.size)).replace('%length%', getItemLengthValue(item.length)).replace('%priceInfo%', getPriceInfo()).replace('%button%', getBtn());
};




class $e5534614b8cb7f69$export$2e2bcd8739ae039 {
    constructor(element, ctx){
        this.element = element;
        this.ctx = ctx;
        this.trigger = this.element.querySelector('[data-add-gift]');
        this.isEnabled = !!this.trigger;
        if (this.isEnabled) {
            this.config = JSON.parse(this.trigger.dataset.giftConfig);
            this.visibility();
            this.ctx.on('cart:updated', (data)=>{
                this.data = data;
                this.visibility();
            });
            this.addItem = this.addItem.bind(this);
            this.trigger.addEventListener('click', this.addItem);
        }
    }
    async addItem() {
        const { variantId: variantId } = this.config;
        const quantity = await this.getQuantity();
        await (0, $92d139db6aba612b$export$509a42920845e675)({
            variantId: variantId,
            quantity: quantity,
            callback: ()=>{
                this.trigger.hidden = true;
            }
        });
    }
    visibility() {
        if (!this.data) return;
        const { productId: productId } = this.config;
        const ids = this.data.items.map((item)=>item.productId);
        if (ids.includes(productId)) this.trigger.hidden = true;
        else this.trigger.hidden = false;
    }
    async getQuantity() {
        const { productId: productId } = this.config;
        const cart = this.data ?? await $e5534614b8cb7f69$export$2e2bcd8739ae039.getCart();
        const validProducts = cart.items.filter((item)=>!item.excludeGiftBag && !item.gift_card && item.productId !== parseInt(productId, 10));
        const quantities = validProducts.map((item)=>item.quantity);
        if (quantities.length) {
            const totalQuantity = quantities.reduce((value, total)=>value + total);
            return totalQuantity;
        }
        return 0;
    }
    static getCart() {
        return (0, $92d139db6aba612b$export$4c0e529601ca5c3b)();
    }
}



class $9eb1f8cc1de8b697$var$Modal extends (0, $574a33c97073f263$export$2e2bcd8739ae039) {
    constructor(element, useOverlay = true){
        super(element, useOverlay);
        this.classes = {
            active: 'modal--active'
        };
    }
}
var $9eb1f8cc1de8b697$export$2e2bcd8739ae039 = (element, useOverlay = true)=>new $9eb1f8cc1de8b697$var$Modal(element, useOverlay);



var $9333d437a18e3e69$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const itemCountOutput = node.querySelector('.js-itemCount');
    const closeBtns = node.querySelectorAll('.js-closeBtn');
    const mainContents = node.querySelector('.js-mainContents');
    const itemList = node.querySelector('.js-itemList');
    const discountsInfo = node.querySelector('.js-discountsInfo');
    const discountsLine = node.querySelector('.js-discountsLine');
    const totalPrice = node.querySelector('.js-totalPrice');
    const form = node.querySelector('.js-form');
    const termsInput = node.querySelector('.js-termsInput');
    const termsModal = node.querySelector('.js-termsModal');
    const termsAcceptBtn = node.querySelector('.js-termsAcceptBtn');
    const termsDeclineBtn = node.querySelector('.js-termsDeclineBtn');
    const empty = node.querySelector('.js-empty');
    const upsellDrawer = node.querySelector('.js-upsellDrawer');
    const upsellDrawerBtn = node.querySelector('.js-upsellDrawerBtn');
    const upsellDrawerCloseBtn = node.querySelector('.js-upsellDrawerCloseBtn');
    const upsellList = node.querySelector('.js-upsellList');
    const triggerChat = node.querySelector('.js-triggerChat');
    const campaign = node.querySelector('.js-campaign');
    const freeShippingTarget = Number(document.querySelector('[data-free-shipping-target]')?.dataset.freeShippingTarget);
    const freeShippingMissing = document.querySelector('#free_shipping_left');
    const upsellDrawerActiveClass = 'cart-drawer__upsell--active';
    const config = JSON.parse(node.dataset.config);
    const toggleChatWidget = ()=>{
        if (!window.GorgiasChat) return false;
        const chat = document.querySelector('#chat-button');
        if (window.GorgiasChat.isOpen()) {
            chat.classList.remove('is-open');
            window.GorgiasChat.close();
        } else {
            chat.classList.add('is-open');
            window.GorgiasChat.open();
            chat.classList.remove('is-open');
            ctx.emit('cart:toggle');
        }
        return true;
    };
    if (triggerChat) triggerChat.addEventListener('click', toggleChatWidget);
    /**
   * Functions
   */ const addRemoveUpsellDrawer = (open)=>{
        upsellDrawer.classList[open ? 'add' : 'remove'](upsellDrawerActiveClass);
    };
    const toggleUpsellDrawer = ()=>{
        upsellDrawer.classList.toggle(upsellDrawerActiveClass);
    };
    const initDrawers = ()=>{
        const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(node);
        ctx.on('cart:toggle', ()=>drawer.toggle());
        ctx.on('cart:updated', ()=>{
            drawer.open();
            if (window.matchMedia('(min-width: 1024px)').matches) addRemoveUpsellDrawer(true);
        });
        closeBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>drawer.close());
        });
        const params = new URLSearchParams(window.location.search);
        if (params.get('cart') !== null) drawer.open();
        upsellDrawerBtn.addEventListener('click', ()=>toggleUpsellDrawer());
        ctx.on('cart:toggle', ()=>{
            if (window.matchMedia('(min-width: 1024px)').matches) addRemoveUpsellDrawer(true);
        });
        upsellDrawerCloseBtn.addEventListener('click', ()=>addRemoveUpsellDrawer(false));
        drawer.on('close', ()=>addRemoveUpsellDrawer(false));
    };
    const update = ({ itemCount: itemCount, cartDrawerMarkup: cartDrawerMarkup })=>{
        const temp = document.createElement('div');
        temp.innerHTML = cartDrawerMarkup;
        const itemCountContent = temp.querySelector('.js-itemCount').textContent;
        itemCountOutput.textContent = itemCountContent;
        const itemListContent = temp.querySelector('.js-itemList').innerHTML;
        itemList.innerHTML = itemListContent;
        const totalPriceContent = temp.querySelector('.js-totalPrice')?.textContent;
        totalPrice.textContent = totalPriceContent;
        // const discountsInfoContent = temp.querySelector('.js-discountsInfo')?.innerHTML;
        // discountsInfo.innerHTML = discountsInfoContent;
        // const discountsLineContent = temp.querySelector('.js-discountsLine')?.innerHTML;
        // discountsLine.innerHTML = discountsLineContent;
        if (campaign) {
            const campaignContent = temp.querySelector('.js-campaign')?.innerHTML;
            campaign.innerHTML = campaignContent;
        }
        if (itemCount > 0) {
            mainContents.hidden = false;
            form.hidden = false;
            empty.hidden = true;
        } else {
            mainContents.hidden = true;
            form.hidden = true;
            empty.hidden = false;
            upsellDrawer.classList.remove(upsellDrawerActiveClass);
        }
        (0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).mount();
    };
    const updateUpsell = async (cart)=>{
        cart.items.forEach((cartItem)=>{
            const cartItemEl = node?.querySelector('[data-config*="' + cartItem.variantId + '"]');
            const cartItemLength = cartItemEl.querySelector('.js-cartItemLengthOption');
            cartItem.length = cartItemLength ? cartItemLength.innerHTML : 'Standard';
        });
        const fetches = cart.items.map((item)=>fetch(`/recommendations/products?product_id=${item.productId}&limit=10&section_id=recommendations`).then((response)=>response.text()));
        const fetchesProductsJson = cart.items.map((item)=>fetch(`/recommendations/products.json?product_id=${item.productId}`).then((response)=>response.json()));
        const recommendations = await Promise.all(fetches).then((markups)=>markups.map((markup)=>{
                const temp = document.createElement('div');
                temp.innerHTML = markup;
                const scriptTag = temp.querySelector('.js-script');
                return JSON.parse(scriptTag.innerHTML);
            }).flat());
        const recommendationsList = await Promise.all(fetchesProductsJson).then((results)=>results.map((res)=>res));
        const uniqueRecommendations = [];
        recommendations.forEach((item)=>{
            if (!uniqueRecommendations.find((otherItem)=>otherItem.handle === item.handle)) uniqueRecommendations.push(item);
        });
        const matchingVariants = [];
        uniqueRecommendations.forEach((item)=>{
            if (!item.sizeOption) return;
            const matches = item.variants.filter((variant)=>{
                const matchingCartItem = cart.items.find((cartItem)=>{
                    const matchesFit = cartItem.fit === variant.fit;
                    const matchesSize = cartItem.size?.includes(variant.size) || variant.size.includes(cartItem.size); // eslint-disable-line
                    const matchesLength = cartItem.length === 'Standard' ? variant.length === "Standard" || variant.length === null : cartItem.length === variant.length;
                    return matchesFit && matchesSize && matchesLength;
                });
                const alreadyInCart = cart.items.find((cartItem)=>cartItem.variantId === variant.id);
                return matchingCartItem && !alreadyInCart && !item.tags.includes('__prelaunch');
            });
            if (matches.length) matchingVariants.push(...matches);
        });
        matchingVariants.sort((a, b)=>{
            if (a.available && !b.available) return -1;
            if (b.available && !a.available) return 1;
            return 0;
        });
        matchingVariants.forEach((variant)=>{
            for (const item of recommendationsList){
                // Search for the product containing the variant
                const product = item.products.find((product)=>product.variants.find((v)=>v.id === variant.id));
                if (product && product.compare_at_price) {
                    variant.compare_at_price = product.compare_at_price;
                    break;
                }
            }
        });
        upsellList.innerHTML = matchingVariants.map((item)=>(0, $c0e8b6328a3855c8$export$2e2bcd8739ae039)(item, {
                ...config,
                cart: cart
            })).join('');
        (0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).mount();
    };
    function formatMoney(cents, format) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        cents = Math.max(0, cents);
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        function formatWithDelimiters(number, decimals = 2, thousands = '.', decimal = ',') {
            number = (number / 100).toFixed(decimals);
            const parts = number.split('.');
            const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            const fraction = parts[1] ? decimal + parts[1] : '';
            return whole + fraction;
        }
        const formats = {
            'amount': formatWithDelimiters(cents, 2, ',', '.'),
            'amount_no_decimals': formatWithDelimiters(cents, 0, ',', '.'),
            'amount_with_comma_separator': formatWithDelimiters(cents, 2, '.', ','),
            'amount_no_decimals_with_comma_separator': formatWithDelimiters(cents, 0, '.', ','),
            'amount_with_apostrophe_separator': formatWithDelimiters(cents, 2, "'", '.')
        };
        return format.replace(placeholderRegex, (match, key)=>formats[key] || '');
    }
    const updateShippingBar = async ({ cartTotal: cartTotal })=>{
        // Calculate percentage
        const percentage = cartTotal / freeShippingTarget * 100;
        // Select elements
        const messageWrapper = document.querySelector(".free-shipping_message-wrapper");
        const progressBar = document.querySelector(".free-shipping_progress-bar");
        const missingAmount = freeShippingTarget - cartTotal;
        freeShippingMissing.innerHTML = formatMoney(missingAmount, window.theme.moneyFormat);
        // Update class based on percentage
        if (percentage < 100) {
            messageWrapper.classList.add("missing");
            messageWrapper.classList.remove("success");
        } else {
            messageWrapper.classList.add("success");
            messageWrapper.classList.remove("missing");
        }
        // Update progress bar width
        progressBar.style.width = `${Math.min(percentage, 100)}%`; // Ensures it doesn’t exceed 100%
    };
    const initUpsell = async ()=>{
        const cart = await (0, $92d139db6aba612b$export$4c0e529601ca5c3b)();
        updateUpsell(cart);
    };
    const initGiftProduct = async ()=>{
        // eslint-disable-next-line no-new
        new (0, $e5534614b8cb7f69$export$2e2bcd8739ae039)(node, ctx);
    };
    const initForm = ()=>{
        document.body.appendChild(termsModal);
        const modal = (0, $9eb1f8cc1de8b697$export$2e2bcd8739ae039)(termsModal, false);
        form.addEventListener('submit', (event)=>{
            if (!termsInput.checked) {
                event.preventDefault();
                modal.open();
            }
        });
        termsModal.addEventListener('click', (event)=>{
            event.stopPropagation();
            if (event.target === termsModal) modal.close();
        });
        termsAcceptBtn.addEventListener('click', ()=>{
            modal.close();
            termsInput.checked = true;
            form.submit();
        });
        termsDeclineBtn.addEventListener('click', ()=>{
            modal.close();
        });
    };
    const init = async ()=>{
        initDrawers();
        initUpsell();
        initGiftProduct();
        ctx.on('cart:updated', (data)=>{
            update(data);
            updateUpsell(data);
            updateShippingBar(data);
        });
        initForm();
    };
    /**
   * Init
   */ init();
});





var $7724971723f47526$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)((node)=>{
    /**
   * Data + elements
   */ const decreaseBtn = node.querySelector('.js-decreaseBtn');
    const increaseBtn = node.querySelector('.js-increaseBtn');
    const qtyInput = node.querySelector('.js-qtyInput');
    const removeBtn = node.querySelector('.js-removeBtn');
    const config = JSON.parse(node.dataset.config);
    const { key: key } = config;
    /**
   * Functions
   */ const updateQty = (qty)=>{
        (0, $92d139db6aba612b$export$af6dc614fffa1a5c)({
            key: key,
            quantity: qty
        });
    };
    const clickQtyBtn = (updatedQty)=>{
        qtyInput.value = updatedQty;
        qtyInput.dispatchEvent(new Event('change'));
    };
    const removeItem = ()=>{
        removeBtn.classList.add('cart-item__remove-button--active');
        updateQty(0);
    };
    const init = ()=>{
        qtyInput.addEventListener('change', (0, (/*@__PURE__*/$parcel$interopDefault($a3d7992b95643302$exports)))(()=>updateQty(qtyInput.value), 500));
        decreaseBtn.addEventListener('click', ()=>clickQtyBtn(Math.max(parseInt(qtyInput.value, 10) - 1, 0)));
        increaseBtn.addEventListener('click', ()=>clickQtyBtn(parseInt(qtyInput.value, 10) + 1));
        removeBtn.addEventListener('click', removeItem);
    };
    /**
   * Init
   */ init();
});



var $289c3358a13c9d74$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)((node)=>{
    /**
   * Functions
   */ const init = ()=>{
        node.addEventListener('click', ()=>{
            window.GorgiasChat?.open();
        });
    };
    /**
   * Init
   */ init();
});




var $7e39c79985cdf900$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const diagrams = node.querySelectorAll('.js-diagram');
    /**
   * Functions
   */ const init = ()=>{
        const update = (rect)=>{
            const inView = rect.top <= window.innerHeight * 0.75;
            if (inView) diagrams.forEach((diagram, index)=>{
                setTimeout(()=>{
                    diagram.style.height = '100%';
                }, index * 300);
            });
        };
        (0, $c0bd171aae5be854$export$2e2bcd8739ae039)(()=>{
            update(node.getBoundingClientRect());
            ctx.on('window:scroll', ()=>{
                update(node.getBoundingClientRect());
            });
        });
    };
    /**
   * Init
   */ init();
});



(0, $c0bd171aae5be854$export$2e2bcd8739ae039)(()=>{
    if (window.Confirmic) window.Confirmic('ConsentManager:onShow', ()=>{
        setTimeout(()=>{
            window.scrollTo(0, 0);
        }, 500);
    });
});



var $798fdc66f6c031c0$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)((node, ctx)=>{
    /**
   * Data + elements
   */ const flagIcon = node.querySelector('.js-flagIcon');
    /**
   * Functions
   */ const initFlagIcon = ()=>{
        const currentShop = window.theme.shops.find((shop)=>shop.shopifyDomain === Shopify.shop && shop.countryCode === Shopify.country);
        flagIcon.innerHTML = `<img src="${currentShop.flagIcon}" class="h-[16px]" loading="lazy">`;
    };
    const initBtn = ()=>{
        node.addEventListener('click', ()=>ctx.emit('countrySelector:open'));
    };
    const init = ()=>{
        initFlagIcon();
        initBtn();
    };
    /**
   * Init
   */ init();
});




var $b1391749b1fca322$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)((node, ctx)=>{
    /**
   * Data + elements
   */ const closeBtn = node.querySelector('.js-closeBtn');
    const shopList = node.querySelector('.js-shopList');
    let shopItems;
    const shopItemClass = 'country-selector__shop-item';
    const shopItemActiveClass = 'country-selector__shop-item--active';
    const shops = [
        ...window.theme.shops
    ];
    const currentShop = shops.find((shop)=>shop.shopifyDomain === Shopify.shop && shop.countryCode === Shopify.country);
    /**
   * Functions
   */ const initModal = ()=>{
        const modal = (0, $9eb1f8cc1de8b697$export$2e2bcd8739ae039)(node);
        ctx.on('countrySelector:open', ()=>modal.open());
        const close = ()=>{
            modal.close();
            sessionStorage.setItem('countrySelectorClosed', 'true');
        };
        closeBtn?.addEventListener('click', close);
        node.addEventListener('click', (event)=>{
            if (event.target === node) modal.close();
        });
        ctx.on('countrySelector:close', close);
    };
    const initShopList = ()=>{
        // Move current shop to front of array
        const currentShopIndex = shops.indexOf(currentShop); // eslint-disable-line
        if (currentShopIndex !== -1) {
            const currentShopEntry = shops.splice(currentShopIndex, 1);
            shops.unshift(currentShopEntry);
        }
        window.theme.shops.forEach((shop)=>{
            const listItem = document.createElement('li');
            shopList.appendChild(listItem);
            let itemClass = shopItemClass;
            if (shop.shopifyDomain === Shopify.shop && shop.countryCode === Shopify.country) itemClass += ` ${shopItemActiveClass}`;
            listItem.outerHTML = `<li class="${itemClass} js-shopItem" data-url="https://${shop.prettyUrl?.length ? shop.prettyUrl : shop.shopifyDomain}" ${shop === currentShop ? 'data-current="true"' : ''}>
          <img src="${shop.flagIcon}" class="country-selector__shop-item__flag-icon" loading="lazy">
          <p class="country-selector__shop-item__title">${shop.title}</p>
          <p class="country-selector__shop-item__currency">(${shop.currency})</p>
      </li>`;
        });
        shopItems = shopList.querySelectorAll('.js-shopItem');
    };
    const initShopItems = ()=>{
        shopItems.forEach((item)=>{
            item.addEventListener('click', ()=>{
                shopItems.forEach((i)=>{
                    i.classList[i === item ? 'add' : 'remove'](shopItemActiveClass);
                });
            });
        });
    };
    const initConfirmBtn = ()=>{
        shopItems.forEach((item)=>{
            item.addEventListener('click', ()=>{
                const activeItem = Array.from(shopItems).find((item)=>item.classList.contains(shopItemActiveClass)); // eslint-disable-line
                const activeIsCurrent = activeItem.dataset.current === 'true';
                if (activeIsCurrent) ctx.emit('countrySelector:close');
                else {
                    const { url: url } = activeItem.dataset;
                    window.location.href = url;
                }
            });
        });
    };
    const checkGeo = async ()=>{
        const { country_code: userCountryCode } = await fetch('https://get.geojs.io/v1/ip/geo.json').then((response)=>response.json()); // eslint-disable-line
        const match = userCountryCode.toLowerCase() === currentShop.countryCode.toLowerCase() || currentShop.countryCode.toLowerCase() === 'international'; // eslint-disable-line
        if (!match && !sessionStorage.getItem('countrySelectorClosed')) ctx.emit('countrySelector:open');
    };
    const init = ()=>{
        initModal();
        initShopList();
        initShopItems();
        initConfirmBtn();
        checkGeo();
    };
    /**
   * Init
   */ init();
});




var $cfdee5aa20126687$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const largeText = node.querySelector('.js-largeText');
    const list = node.querySelector('.js-list');
    /**
   * Functions
   */ const initLargeText = ()=>{
        if (largeText) ctx.on('window:scroll', ()=>{
            const rect = largeText.getBoundingClientRect();
            const isVisible = rect.top <= window.innerHeight * 0.85;
            if (isVisible) largeText.classList.add('feature-elements__large-text--visible');
        });
    };
    const initList = ()=>{
        if (list) ctx.on('window:scroll', ()=>{
            const rect = list.getBoundingClientRect();
            const isVisible = rect.top <= window.innerHeight * 0.65;
            const bottomVisible = rect.bottom <= window.innerHeight;
            if (isVisible) {
                list.classList.add('feature-elements__list--visible');
                if (largeText) largeText.classList.add('feature-elements__large-text--faded');
            }
            if (bottomVisible && largeText) largeText.classList.add('feature-elements__large-text--hidden');
        });
    };
    const init = ()=>{
        (0, $c0bd171aae5be854$export$2e2bcd8739ae039)(()=>{
            initLargeText();
            initList();
            window.dispatchEvent(new Event('scroll'));
        });
    };
    /**
   * Init
   */ init();
});



var $93d350277d7ce459$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const btn = node.querySelector('.js-btn');
    const content = node.querySelector('.js-content');
    /**
   * Functions
   */ const toggle = (node)=>{
        const anchorTarget = node.getAttribute('data-anchor-target');
        if (anchorTarget !== null && anchorTarget !== "" && anchorTarget !== undefined) {
            redirectToTargetSection(anchorTarget);
            return;
        }
        btn.classList.toggle('harmonica-item__button--active');
        if (content.hidden) content.hidden = false;
        else content.hidden = true;
    };
    const redirectToTargetSection = (anchorTarget)=>{
        window.location.href = `#${anchorTarget}`;
        setTimeout(()=>{
            history.replaceState(null, null, ' ');
            const element = document.querySelector(`[data-id="${anchorTarget}"]`);
            if (element) {
                const yOffset = -85;
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({
                    top: y,
                    behavior: 'smooth'
                });
            }
        }, 0);
    };
    const init = ()=>{
        btn.addEventListener('click', ()=>toggle(node));
    };
    /**
   * Init
   */ init();
});






var $427233ecea647b2e$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const topbar = document.querySelector('.js-topbar');
    const topbarCloseBtn = topbar?.querySelector('.js-topbarCloseBtn');
    const megamenus = node.querySelectorAll('.js-megamenu');
    const megamenuTriggers = node.querySelectorAll('.js-megamenuTrigger');
    let previousScrollPos = window.scrollY;
    const headerHeightMobile = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height--mobile'), 10);
    const headerHeightDesktop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height--desktop'), 10);
    let topbarHeight = 0;
    /**
   * Functions
   */ const initTopbar = ()=>{
        const closed = sessionStorage.getItem('topbar');
        // Update topbar height for use in handleScroll
        const updateHeight = ()=>{
            topbarHeight = topbar.getBoundingClientRect().height;
        };
        const close = ()=>{
            topbar.remove();
            window.dispatchEvent(new Event('resize'));
            if (!closed) sessionStorage.setItem('topbar', 'closed');
        };
        // Remove if already hidden
        if (closed) close();
        updateHeight();
        ctx.on('window:resize', updateHeight);
        topbarCloseBtn.addEventListener('click', close);
        const config = JSON.parse(topbar.dataset.config);
        const { productTitleMarkup: productTitleMarkup } = config;
        if (productTitleMarkup) {
            // Create blueprint for title element
            const blueprint = document.createElement('span');
            blueprint.classList.add('whitespace-nowrap', 'js-productTitle');
            blueprint.innerHTML = productTitleMarkup;
            topbar.appendChild(blueprint);
            const blueprintWidth = Math.ceil(blueprint.getBoundingClientRect().width);
            topbar.removeChild(blueprint);
            const updateTitles = ()=>{
                // Clear existing titles
                const existingTitles = topbar.querySelectorAll('.js-productTitle');
                existingTitles.forEach((title)=>{
                    title.remove();
                });
                // Calculate number of titles to add
                const topbarWidth = topbar.getBoundingClientRect().width;
                const topbarPadding = parseInt(getComputedStyle(topbar).getPropertyValue('padding'), 10) || 0;
                const topbarFreeSpace = topbarWidth - topbarPadding;
                const textElementWidth = Math.ceil(topbar.querySelector('.js-text')?.getBoundingClientRect().width) || 0;
                const freeSpace = Math.ceil(topbarFreeSpace - textElementWidth);
                const numberOfTitlePairs = Math.floor(freeSpace / ((blueprintWidth + 20) * 2));
                // Add title elements
                for(let i = 0; i < numberOfTitlePairs; i += 1){
                    const leftClone = blueprint.cloneNode(true);
                    const rightClone = blueprint.cloneNode(true);
                    leftClone.style.marginRight = '20px';
                    rightClone.style.marginLeft = '20px';
                    topbar.insertAdjacentElement('afterbegin', leftClone);
                    topbar.insertAdjacentElement('beforeend', rightClone);
                }
            };
            updateTitles();
            ctx.on('window:resize', updateTitles);
        }
    };
    const initMegamenus = ()=>{
        const showMegamenu = (trigger, megamenu)=>{
            node.classList.add('header--megamenu-open');
            megamenu.hidden = false;
            (0, $581e6c1bb6c96527$export$472761e5909fca2d)(megamenu);
            megamenu.classList.add('header__megamenu--active');
            const listItem = trigger.closest('.js-listItem');
            listItem.classList.add('header__nav__list-item--active');
            trigger.classList.add('open');
            if (megamenu.classList.contains('header__megamenu--active')) (0, $eddcbc136a01aca6$export$57bf213be019eeb0)();
            //close other menu
            const megamenuTriggers = document.querySelectorAll('.has-megamenu');
            const header = document.querySelector('.megamenu-header');
            megamenuTriggers.forEach(function(trigger) {
                const menuHandle = trigger.getAttribute('data-menu-handle');
                const megamenu = document.getElementById('megamenu-' + menuHandle);
                if (megamenu) {
                    megamenu.classList.remove('show');
                    header.classList.remove('design-white');
                    megamenu.classList.remove('design-white');
                    trigger.classList.remove('open');
                }
            });
        };
        const hideMegamenu = (trigger, megamenu)=>{
            megamenu.classList.remove('header__megamenu--active');
            const transitionDuration = parseInt(getComputedStyle(megamenu).getPropertyValue('transition-duration') || 0, 10);
            if (transitionDuration === 0) megamenu.hidden = true;
            else megamenu.addEventListener('transitionend', ()=>{
                if (!megamenu.classList.contains('header__megamenu--active')) megamenu.hidden = true;
            }, {
                once: true
            });
            const listItem = trigger.closest('.js-listItem');
            listItem.classList.remove('header__nav__list-item--active');
            trigger.classList.remove('open');
            const anyOpen = Array.from(megamenus).some((menu)=>menu.classList.contains('header__megamenu--active'));
            if (!anyOpen) {
                (0, $eddcbc136a01aca6$export$fe8985bb6374093c)();
                node.classList.remove('header--megamenu-open');
            }
        };
        let mouseoverTimeout;
        megamenuTriggers.forEach((trigger)=>{
            trigger.addEventListener('click', (event)=>{
                event.preventDefault();
                event.stopPropagation();
                clearTimeout(mouseoverTimeout);
                mouseoverTimeout = setTimeout(()=>{
                    megamenuTriggers.forEach((otherTrigger)=>{
                        const megamenu = otherTrigger.closest('.js-listItem')?.querySelector('.js-megamenu');
                        if (!megamenu) return;
                        if (otherTrigger === trigger) {
                            if (otherTrigger.classList.contains('cannot-be-opened')) return;
                            // if already open — close it
                            if (otherTrigger.classList.contains('open')) hideMegamenu(otherTrigger, megamenu);
                            else showMegamenu(otherTrigger, megamenu);
                        } else hideMegamenu(otherTrigger, megamenu);
                    });
                }, 100);
            });
        });
        document.addEventListener('click', (event)=>{
            const isTrigger = event.target.closest(megamenuTriggers[0]?.tagName?.toLowerCase() || null);
            const isMegamenu = event.target.closest('.js-megamenu');
            const isLink = event.target.closest('a');
            if (!isMegamenu && !isTrigger || isMegamenu && !isLink) megamenuTriggers.forEach((trigger)=>{
                const megamenu = trigger.parentElement.querySelector('.js-megamenu');
                hideMegamenu(trigger, megamenu);
            });
        });
        window.addEventListener('click', (event)=>{
            if (event.target.tagName === 'BUTTON' && !event.target.classList.contains('product__add-to-cart-button') && !event.target.classList.contains('js-fitSizeSelectionBtn')) {
                event.preventDefault();
                return;
            }
            let closeAll = true;
            if (Array.from(megamenus).find((megamenu)=>event.target === megamenu || megamenu.contains(event.target))) closeAll = false;
            if (Array.from(megamenuTriggers).find((trigger)=>trigger === event.target || trigger.contains(event.target))) closeAll = false;
            if (event.target?.matches('a.js-cart-btn') || event.target?.closest('a')?.matches('a.js-cart-btn')) closeAll = false;
            if (closeAll) {
                megamenuTriggers.forEach((trigger)=>{
                    const megamenu = trigger.parentElement.querySelector('.js-megamenu');
                    hideMegamenu(trigger, megamenu);
                    if (event.target.closest('#shopify-section-announcement') || event.target.closest('header.header') && !event.target.closest('header.header button[aria-label="Menu"]')) (0, $eddcbc136a01aca6$export$fe8985bb6374093c)();
                });
                node.classList.remove('header--megamenu-open');
            }
        });
    };
    const handleScroll = ()=>{
        const currentScrollPos = window.scrollY;
        const scrollingUp = currentScrollPos < previousScrollPos;
        previousScrollPos = currentScrollPos;
        const fixedThreshold = topbarHeight;
        if (currentScrollPos > fixedThreshold) {
            node.classList.add('header--fixed-desktop');
            document.body.classList.add('header-fixed--desktop');
        } else {
            node.classList.remove('header--fixed-desktop');
            node.classList.remove('header--transition-transform');
            document.body.classList.remove('header-fixed--desktop');
        }
        if (currentScrollPos > fixedThreshold && scrollingUp) {
            node.classList.add('header--show-desktop');
            node.classList.add('header--transition-transform');
            ctx.emit('mobileHeader:scrolled', {
                mobileHeaderVisible: true
            });
        } else {
            node.classList.remove('header--show-desktop');
            ctx.emit('mobileHeader:scrolled', {
                mobileHeaderVisible: false
            });
        }
    };
    const init = ()=>{
        if (topbar) initTopbar();
        initMegamenus();
        handleScroll();
        ctx.on('window:scroll', handleScroll);
    };
    init();
});




var $74a36c6e497ff295$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const diagrams = node.querySelectorAll('.js-diagram');
    /**
   * Functions
   */ const init = ()=>{
        const update = (rect)=>{
            const inView = rect.top <= window.innerHeight * 0.75;
            if (inView) diagrams.forEach((diagram, index)=>{
                setTimeout(()=>{
                    diagram.style.width = '100%';
                }, index * 300);
            });
        };
        (0, $c0bd171aae5be854$export$2e2bcd8739ae039)(()=>{
            update(node.getBoundingClientRect());
            ctx.on('window:scroll', ()=>{
                update(node.getBoundingClientRect());
            });
        });
    };
    /**
   * Init
   */ init();
});




var $9a08ee86f1eaef52$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const sliderElement = node.querySelector('.js-slider') ? node.querySelector('.js-slider') : node;
    const sliderPagination = node.querySelector('.js-sliderPagination') ? node.querySelector('.js-sliderPagination') : node;
    /**
   * Functions
   */ const initSlider = ()=>{
        (()=>new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(sliderElement, {
                modules: [
                    (0, $604711bfadd9afec$export$2e2bcd8739ae039)
                ],
                slidesPerView: 'auto',
                spaceBetween: 16,
                threshold: 5,
                lazy: true,
                grabCursor: true,
                pagination: {
                    el: sliderPagination,
                    type: 'bullets',
                    bulletClass: 'image-slider__page-bullet',
                    bulletActiveClass: 'image-slider__page-bullet--active'
                }
            }))();
    };
    const init = ()=>{
        initSlider();
    };
    /**
   * Init
   */ init();
});




var $d708a801dff12b59$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const tabBtns = node.querySelectorAll('.js-tabBtn');
    const imageElements = node.querySelectorAll('.js-image');
    const contentElements = node.querySelectorAll('.js-content');
    const desktopNavigationSliderElement = node.querySelector('.js-desktopNavigationSlider');
    const mobileNavigationSliderElement = node.querySelector('.js-mobileNavigationSlider');
    const config = JSON.parse(node.dataset.config);
    const { lastButtonIndex: lastButtonIndex, navigationStyle: navigationStyle } = config;
    const desktopNavigationSlider = desktopNavigationSliderElement ? new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(desktopNavigationSliderElement, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 60,
        initialSlide: lastButtonIndex,
        threshold: 5
    }) : null;
    const mobileNavigationSlider = new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(mobileNavigationSliderElement, {
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: navigationStyle === 'timeline' ? lastButtonIndex : 0,
        threshold: 5
    });
    /**
   * Functions
   */ const update = (index)=>{
        desktopNavigationSlider?.slideTo(index);
        mobileNavigationSlider.slideTo(index);
        tabBtns.forEach((btn)=>{
            btn.disabled = true;
            if (btn.dataset.index === index) btn.classList.add('image-tabs__button--active');
            else btn.classList.remove('image-tabs__button--active');
        });
        imageElements.forEach((image)=>{
            image.classList.remove('image-tabs__image--active');
        });
        const currentImages = Array.from(imageElements).filter((image)=>image.dataset.index === index); // eslint-disable-line
        currentImages.forEach((image)=>image.classList.add('image-tabs__image--active'));
        contentElements.forEach((content)=>{
            if (content.dataset.index === index) content.hidden = false;
            else content.hidden = true;
        });
        tabBtns.forEach((btn)=>{
            btn.disabled = false;
        });
    };
    const initTabBtns = ()=>{
        contentElements.forEach((element)=>{
            Array.from(element.children).forEach((child, index)=>{
                child.style.animationDelay = `${index * 300}ms`;
            });
        });
        tabBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>update(btn.dataset.index));
        });
    };
    /**
   * Init
   */ initTabBtns();
});



/*! @vimeo/player v2.29.5 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */ function $91ff85a144d02ea6$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $91ff85a144d02ea6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $91ff85a144d02ea6$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $91ff85a144d02ea6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $91ff85a144d02ea6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $91ff85a144d02ea6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $91ff85a144d02ea6$var$_regeneratorRuntime() {
    $91ff85a144d02ea6$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self1, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self1, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self1, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self1, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self1, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $91ff85a144d02ea6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $91ff85a144d02ea6$var$_asyncToGenerator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                $91ff85a144d02ea6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $91ff85a144d02ea6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $91ff85a144d02ea6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $91ff85a144d02ea6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $91ff85a144d02ea6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $91ff85a144d02ea6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $91ff85a144d02ea6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $91ff85a144d02ea6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $91ff85a144d02ea6$var$_defineProperty(obj, key, value) {
    key = $91ff85a144d02ea6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $91ff85a144d02ea6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $91ff85a144d02ea6$var$_setPrototypeOf(subClass, superClass);
}
function $91ff85a144d02ea6$var$_getPrototypeOf(o) {
    $91ff85a144d02ea6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $91ff85a144d02ea6$var$_getPrototypeOf(o);
}
function $91ff85a144d02ea6$var$_setPrototypeOf(o, p) {
    $91ff85a144d02ea6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $91ff85a144d02ea6$var$_setPrototypeOf(o, p);
}
function $91ff85a144d02ea6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $91ff85a144d02ea6$var$_construct(Parent, args, Class) {
    if ($91ff85a144d02ea6$var$_isNativeReflectConstruct()) $91ff85a144d02ea6$var$_construct = Reflect.construct.bind();
    else $91ff85a144d02ea6$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $91ff85a144d02ea6$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $91ff85a144d02ea6$var$_construct.apply(null, arguments);
}
function $91ff85a144d02ea6$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $91ff85a144d02ea6$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $91ff85a144d02ea6$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$91ff85a144d02ea6$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $91ff85a144d02ea6$var$_construct(Class, arguments, $91ff85a144d02ea6$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $91ff85a144d02ea6$var$_setPrototypeOf(Wrapper, Class);
    };
    return $91ff85a144d02ea6$var$_wrapNativeSuper(Class);
}
function $91ff85a144d02ea6$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $91ff85a144d02ea6$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $91ff85a144d02ea6$var$_assertThisInitialized(self1);
}
function $91ff85a144d02ea6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $91ff85a144d02ea6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $91ff85a144d02ea6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $91ff85a144d02ea6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $91ff85a144d02ea6$var$_possibleConstructorReturn(this, result);
    };
}
function $91ff85a144d02ea6$var$_slicedToArray(arr, i) {
    return $91ff85a144d02ea6$var$_arrayWithHoles(arr) || $91ff85a144d02ea6$var$_iterableToArrayLimit(arr, i) || $91ff85a144d02ea6$var$_unsupportedIterableToArray(arr, i) || $91ff85a144d02ea6$var$_nonIterableRest();
}
function $91ff85a144d02ea6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $91ff85a144d02ea6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $91ff85a144d02ea6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $91ff85a144d02ea6$var$_arrayLikeToArray(o, minLen);
}
function $91ff85a144d02ea6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $91ff85a144d02ea6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $91ff85a144d02ea6$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $91ff85a144d02ea6$var$_toPropertyKey(arg) {
    var key = $91ff85a144d02ea6$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
/**
 * @module lib/functions
 */ /**
 * Check to see this is a Node environment.
 * @type {boolean}
 */ /* global global */ var $91ff85a144d02ea6$var$isNode = typeof $parcel$global !== 'undefined' && ({}).toString.call($parcel$global) === '[object global]';
/**
 * Check to see if this is a Bun environment.
 * @see https://bun.sh/guides/util/detect-bun
 * @type {boolean}
 */ var $91ff85a144d02ea6$var$isBun = typeof Bun !== 'undefined';
/**
 * Check to see if this is a Deno environment.
 * @see https://docs.deno.com/api/deno/~/Deno
 * @type {boolean}
 */ var $91ff85a144d02ea6$var$isDeno = typeof Deno !== 'undefined';
/**
 * Check if this is a server runtime
 * @type {boolean}
 */ var $91ff85a144d02ea6$var$isServerRuntime = $91ff85a144d02ea6$var$isNode || $91ff85a144d02ea6$var$isBun || $91ff85a144d02ea6$var$isDeno;
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */ function $91ff85a144d02ea6$var$getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) return prop;
    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */ function $91ff85a144d02ea6$var$isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */ function $91ff85a144d02ea6$var$isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $91ff85a144d02ea6$var$isVimeoUrl(url) {
    return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(url);
}
/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $91ff85a144d02ea6$var$isVimeoEmbed(url) {
    var expr = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
    return expr.test(url);
}
function $91ff85a144d02ea6$var$getOembedDomain(url) {
    var match = (url || '').match(/^(?:https?:)?(?:\/\/)?([^/?]+)/);
    var domain = (match && match[1] || '').replace('player.', '');
    var customDomains = [
        '.videoji.hk',
        '.vimeo.work',
        '.videoji.cn'
    ];
    for(var _i = 0, _customDomains = customDomains; _i < _customDomains.length; _i++){
        var customDomain = _customDomains[_i];
        if (domain.endsWith(customDomain)) return domain;
    }
    return 'vimeo.com';
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */ function $91ff85a144d02ea6$var$getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;
    if (!idOrUrl) throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
    if ($91ff85a144d02ea6$var$isInteger(idOrUrl)) return "https://vimeo.com/".concat(idOrUrl);
    if ($91ff85a144d02ea6$var$isVimeoUrl(idOrUrl)) return idOrUrl.replace('http:', 'https:');
    if (id) throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}
/* eslint-disable max-params */ /**
 * A utility method for attaching and detaching event handlers
 *
 * @param {EventTarget} target
 * @param {string | string[]} eventName
 * @param {function} callback
 * @param {'addEventListener' | 'on'} onName
 * @param {'removeEventListener' | 'off'} offName
 * @return {{cancel: (function(): void)}}
 */ var $91ff85a144d02ea6$var$subscribe = function subscribe(target, eventName, callback) {
    var onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'addEventListener';
    var offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'removeEventListener';
    var eventNames = typeof eventName === 'string' ? [
        eventName
    ] : eventName;
    eventNames.forEach(function(evName) {
        target[onName](evName, callback);
    });
    return {
        cancel: function cancel() {
            return eventNames.forEach(function(evName) {
                return target[offName](evName, callback);
            });
        }
    };
};
/**
 * Find the iframe element that contains a specific source window
 *
 * @param {Window} sourceWindow The source window to find the iframe for
 * @param {Document} [doc=document] The document to search within
 * @return {HTMLIFrameElement|null} The iframe element if found, otherwise null
 */ function $91ff85a144d02ea6$var$findIframeBySourceWindow(sourceWindow) {
    var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    if (!sourceWindow || !doc || typeof doc.querySelectorAll !== 'function') return null;
    var iframes = doc.querySelectorAll('iframe');
    for(var i = 0; i < iframes.length; i++){
        if (iframes[i] && iframes[i].contentWindow === sourceWindow) return iframes[i];
    }
    return null;
}
var $91ff85a144d02ea6$var$arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
var $91ff85a144d02ea6$var$postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
if (!$91ff85a144d02ea6$var$isServerRuntime && (!$91ff85a144d02ea6$var$arrayIndexOfSupport || !$91ff85a144d02ea6$var$postMessageSupport)) throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
var $91ff85a144d02ea6$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $91ff85a144d02ea6$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */ (function(self1) {
    if (self1.WeakMap) return;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var hasDefine = Object.defineProperty && function() {
        try {
            // Avoid IE8's broken Object.defineProperty
            return Object.defineProperty({}, 'x', {
                value: 1
            }).x === 1;
        } catch (e) {}
    }();
    var defineProperty = function(object, name, value) {
        if (hasDefine) Object.defineProperty(object, name, {
            configurable: true,
            writable: true,
            value: value
        });
        else object[name] = value;
    };
    self1.WeakMap = function() {
        // ECMA-262 23.3 WeakMap Objects
        function WeakMap1() {
            if (this === void 0) throw new TypeError("Constructor WeakMap requires 'new'");
            defineProperty(this, '_id', genId('_WeakMap'));
            // ECMA-262 23.3.1.1 WeakMap([iterable])
            if (arguments.length > 0) // Currently, WeakMap `iterable` argument is not supported
            throw new TypeError('WeakMap iterable is not supported');
        }
        // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
        defineProperty(WeakMap1.prototype, 'delete', function(key) {
            checkInstance(this, 'delete');
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                delete key[this._id];
                return true;
            }
            return false;
        });
        // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
        defineProperty(WeakMap1.prototype, 'get', function(key) {
            checkInstance(this, 'get');
            if (!isObject(key)) return void 0;
            var entry = key[this._id];
            if (entry && entry[0] === key) return entry[1];
            return void 0;
        });
        // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
        defineProperty(WeakMap1.prototype, 'has', function(key) {
            checkInstance(this, 'has');
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) return true;
            return false;
        });
        // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
        defineProperty(WeakMap1.prototype, 'set', function(key, value) {
            checkInstance(this, 'set');
            if (!isObject(key)) throw new TypeError('Invalid value used as weak map key');
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                entry[1] = value;
                return this;
            }
            defineProperty(key, this._id, [
                key,
                value
            ]);
            return this;
        });
        function checkInstance(x, methodName) {
            if (!isObject(x) || !hasOwnProperty.call(x, '_id')) throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
        }
        function genId(prefix) {
            return prefix + '_' + rand() + '.' + rand();
        }
        function rand() {
            return Math.random().toString().substring(2);
        }
        defineProperty(WeakMap1, '_polyfill', true);
        return WeakMap1;
    }();
    function isObject(x) {
        return Object(x) === x;
    }
})(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $91ff85a144d02ea6$var$commonjsGlobal !== 'undefined' ? $91ff85a144d02ea6$var$commonjsGlobal : $91ff85a144d02ea6$var$commonjsGlobal);
var $91ff85a144d02ea6$var$npo_src = $91ff85a144d02ea6$var$createCommonjsModule(function(module) {
    /*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/ (function UMD(name, context, definition) {
        // special form of UMD for polyfilling across evironments
        context[name] = context[name] || definition();
        if (module.exports) module.exports = context[name];
    })("Promise", typeof $91ff85a144d02ea6$var$commonjsGlobal != "undefined" ? $91ff85a144d02ea6$var$commonjsGlobal : $91ff85a144d02ea6$var$commonjsGlobal, function DEF() {
        var builtInProp, cycle, scheduling_queue, ToString = Object.prototype.toString, timer = typeof setImmediate != "undefined" ? function timer(fn) {
            return setImmediate(fn);
        } : setTimeout;
        // dammit, IE8.
        try {
            Object.defineProperty({}, "x", {});
            builtInProp = function builtInProp(obj, name, val, config) {
                return Object.defineProperty(obj, name, {
                    value: val,
                    writable: true,
                    configurable: config !== false
                });
            };
        } catch (err) {
            builtInProp = function builtInProp(obj, name, val) {
                obj[name] = val;
                return obj;
            };
        }
        // Note: using a queue instead of array for efficiency
        scheduling_queue = function Queue() {
            var first, last, item;
            function Item(fn, self1) {
                this.fn = fn;
                this.self = self1;
                this.next = void 0;
            }
            return {
                add: function add(fn, self1) {
                    item = new Item(fn, self1);
                    if (last) last.next = item;
                    else first = item;
                    last = item;
                    item = void 0;
                },
                drain: function drain() {
                    var f = first;
                    first = last = cycle = void 0;
                    while(f){
                        f.fn.call(f.self);
                        f = f.next;
                    }
                }
            };
        }();
        function schedule(fn, self1) {
            scheduling_queue.add(fn, self1);
            if (!cycle) cycle = timer(scheduling_queue.drain);
        }
        // promise duck typing
        function isThenable(o) {
            var _then, o_type = typeof o;
            if (o != null && (o_type == "object" || o_type == "function")) _then = o.then;
            return typeof _then == "function" ? _then : false;
        }
        function notify() {
            for(var i = 0; i < this.chain.length; i++)notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
            this.chain.length = 0;
        }
        // NOTE: This is a separate function to isolate
        // the `try..catch` so that other code can be
        // optimized better
        function notifyIsolated(self1, cb, chain) {
            var ret, _then;
            try {
                if (cb === false) chain.reject(self1.msg);
                else {
                    if (cb === true) ret = self1.msg;
                    else ret = cb.call(void 0, self1.msg);
                    if (ret === chain.promise) chain.reject(TypeError("Promise-chain cycle"));
                    else if (_then = isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
                    else chain.resolve(ret);
                }
            } catch (err) {
                chain.reject(err);
            }
        }
        function resolve(msg) {
            var _then, self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            try {
                if (_then = isThenable(msg)) schedule(function() {
                    var def_wrapper = new MakeDefWrapper(self1);
                    try {
                        _then.call(msg, function $resolve$() {
                            resolve.apply(def_wrapper, arguments);
                        }, function $reject$() {
                            reject.apply(def_wrapper, arguments);
                        });
                    } catch (err) {
                        reject.call(def_wrapper, err);
                    }
                });
                else {
                    self1.msg = msg;
                    self1.state = 1;
                    if (self1.chain.length > 0) schedule(notify, self1);
                }
            } catch (err) {
                reject.call(new MakeDefWrapper(self1), err);
            }
        }
        function reject(msg) {
            var self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            self1.msg = msg;
            self1.state = 2;
            if (self1.chain.length > 0) schedule(notify, self1);
        }
        function iteratePromises(Constructor, arr, resolver, rejecter) {
            for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
                Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
                    resolver(idx, msg);
                }, rejecter);
            })(idx);
        }
        function MakeDefWrapper(self1) {
            this.def = self1;
            this.triggered = false;
        }
        function MakeDef(self1) {
            this.promise = self1;
            this.state = 0;
            this.triggered = false;
            this.chain = [];
            this.msg = void 0;
        }
        function Promise1(executor) {
            if (typeof executor != "function") throw TypeError("Not a function");
            if (this.__NPO__ !== 0) throw TypeError("Not a promise");
            // instance shadowing the inherited "brand"
            // to signal an already "initialized" promise
            this.__NPO__ = 1;
            var def = new MakeDef(this);
            this["then"] = function then(success, failure) {
                var o = {
                    success: typeof success == "function" ? success : true,
                    failure: typeof failure == "function" ? failure : false
                };
                // Note: `then(..)` itself can be borrowed to be used against
                // a different promise constructor for making the chained promise,
                // by substituting a different `this` binding.
                o.promise = new this.constructor(function extractChain(resolve, reject) {
                    if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                    o.resolve = resolve;
                    o.reject = reject;
                });
                def.chain.push(o);
                if (def.state !== 0) schedule(notify, def);
                return o.promise;
            };
            this["catch"] = function $catch$(failure) {
                return this.then(void 0, failure);
            };
            try {
                executor.call(void 0, function publicResolve(msg) {
                    resolve.call(def, msg);
                }, function publicReject(msg) {
                    reject.call(def, msg);
                });
            } catch (err) {
                reject.call(def, err);
            }
        }
        var PromisePrototype = builtInProp({}, "constructor", Promise1, /*configurable=*/ false);
        // Note: Android 4 cannot use `Object.defineProperty(..)` here
        Promise1.prototype = PromisePrototype;
        // built-in "brand" to signal an "uninitialized" promise
        builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/ false);
        builtInProp(Promise1, "resolve", function Promise$resolve(msg) {
            var Constructor = this;
            // spec mandated checks
            // note: best "isPromise" check that's practical for now
            if (msg && typeof msg == "object" && msg.__NPO__ === 1) return msg;
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                resolve(msg);
            });
        });
        builtInProp(Promise1, "reject", function Promise$reject(msg) {
            return new this(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                reject(msg);
            });
        });
        builtInProp(Promise1, "all", function Promise$all(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            if (arr.length === 0) return Constructor.resolve([]);
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                var len = arr.length, msgs = Array(len), count = 0;
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    msgs[idx] = msg;
                    if (++count === len) resolve(msgs);
                }, reject);
            });
        });
        builtInProp(Promise1, "race", function Promise$race(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    resolve(msg);
                }, reject);
            });
        });
        return Promise1;
    });
});
/**
 * @module lib/callbacks
 */ var $91ff85a144d02ea6$var$callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */ function $91ff85a144d02ea6$var$storeCallback(player, name, callback) {
    var playerCallbacks = $91ff85a144d02ea6$var$callbackMap.get(player.element) || {};
    if (!(name in playerCallbacks)) playerCallbacks[name] = [];
    playerCallbacks[name].push(callback);
    $91ff85a144d02ea6$var$callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */ function $91ff85a144d02ea6$var$getCallbacks(player, name) {
    var playerCallbacks = $91ff85a144d02ea6$var$callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */ function $91ff85a144d02ea6$var$removeCallback(player, name, callback) {
    var playerCallbacks = $91ff85a144d02ea6$var$callbackMap.get(player.element) || {};
    if (!playerCallbacks[name]) return true;
    // If no callback is passed, remove all callbacks for the event
    if (!callback) {
        playerCallbacks[name] = [];
        $91ff85a144d02ea6$var$callbackMap.set(player.element, playerCallbacks);
        return true;
    }
    var index = playerCallbacks[name].indexOf(callback);
    if (index !== -1) playerCallbacks[name].splice(index, 1);
    $91ff85a144d02ea6$var$callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */ function $91ff85a144d02ea6$var$shiftCallbacks(player, name) {
    var playerCallbacks = $91ff85a144d02ea6$var$getCallbacks(player, name);
    if (playerCallbacks.length < 1) return false;
    var callback = playerCallbacks.shift();
    $91ff85a144d02ea6$var$removeCallback(player, name, callback);
    return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */ function $91ff85a144d02ea6$var$swapCallbacks(oldElement, newElement) {
    var playerCallbacks = $91ff85a144d02ea6$var$callbackMap.get(oldElement);
    $91ff85a144d02ea6$var$callbackMap.set(newElement, playerCallbacks);
    $91ff85a144d02ea6$var$callbackMap.delete(oldElement);
}
/**
 * @module lib/postmessage
 */ /**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */ function $91ff85a144d02ea6$var$parseMessageData(data) {
    if (typeof data === 'string') try {
        data = JSON.parse(data);
    } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
    }
    return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {string|number|object|Array|undefined} params The parameters to send to the player.
 * @return {void}
 */ function $91ff85a144d02ea6$var$postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) return;
    var message = {
        method: method
    };
    if (params !== undefined) message.value = params;
    // IE 8 and 9 do not support passing messages, so stringify them
    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
    if (ieVersion >= 8 && ieVersion < 10) message = JSON.stringify(message);
    player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */ function $91ff85a144d02ea6$var$processData(player, data) {
    data = $91ff85a144d02ea6$var$parseMessageData(data);
    var callbacks = [];
    var param;
    if (data.event) {
        if (data.event === 'error') {
            var promises = $91ff85a144d02ea6$var$getCallbacks(player, data.data.method);
            promises.forEach(function(promise) {
                var error = new Error(data.data.message);
                error.name = data.data.name;
                promise.reject(error);
                $91ff85a144d02ea6$var$removeCallback(player, data.data.method, promise);
            });
        }
        callbacks = $91ff85a144d02ea6$var$getCallbacks(player, "event:".concat(data.event));
        param = data.data;
    } else if (data.method) {
        var callback = $91ff85a144d02ea6$var$shiftCallbacks(player, data.method);
        if (callback) {
            callbacks.push(callback);
            param = data.value;
        }
    }
    callbacks.forEach(function(callback) {
        try {
            if (typeof callback === 'function') {
                callback.call(player, param);
                return;
            }
            callback.resolve(param);
        } catch (e) {
        // empty
        }
    });
}
/**
 * @module lib/embed
 */ var $91ff85a144d02ea6$var$oEmbedParameters = [
    'airplay',
    'audio_tracks',
    'audiotrack',
    'autopause',
    'autoplay',
    'background',
    'byline',
    'cc',
    'chapter_id',
    'chapters',
    'chromecast',
    'color',
    'colors',
    'controls',
    'dnt',
    'end_time',
    'fullscreen',
    'height',
    'id',
    'initial_quality',
    'interactive_params',
    'keyboard',
    'loop',
    'maxheight',
    'max_quality',
    'maxwidth',
    'min_quality',
    'muted',
    'play_button_position',
    'playsinline',
    'portrait',
    'preload',
    'progress_bar',
    'quality',
    'quality_selector',
    'responsive',
    'skipping_forward',
    'speed',
    'start_time',
    'texttrack',
    'thumbnail_id',
    'title',
    'transcript',
    'transparent',
    'unmute_button',
    'url',
    'vimeo_logo',
    'volume',
    'watch_full_video',
    'width'
];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */ function $91ff85a144d02ea6$var$getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $91ff85a144d02ea6$var$oEmbedParameters.reduce(function(params, param) {
        var value = element.getAttribute("data-vimeo-".concat(param));
        if (value || value === '') params[param] = value === '' ? 1 : value;
        return params;
    }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */ function $91ff85a144d02ea6$var$createEmbed(_ref, element) {
    var html = _ref.html;
    if (!element) throw new TypeError('An element must be provided');
    if (element.getAttribute('data-vimeo-initialized') !== null) return element.querySelector('iframe');
    var div = document.createElement('div');
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute('data-vimeo-initialized', 'true');
    return element.querySelector('iframe');
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */ function $91ff85a144d02ea6$var$getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function(resolve, reject) {
        if (!$91ff85a144d02ea6$var$isVimeoUrl(videoUrl)) throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
        var domain = $91ff85a144d02ea6$var$getOembedDomain(videoUrl);
        var url = "https://".concat(domain, "/api/oembed.json?url=").concat(encodeURIComponent(videoUrl));
        for(var param in params)if (params.hasOwnProperty(param)) url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onload = function() {
            if (xhr.status === 404) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
                return;
            }
            if (xhr.status === 403) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                return;
            }
            try {
                var json = JSON.parse(xhr.responseText);
                // Check api response for 403 on oembed
                if (json.domain_status_code === 403) {
                    // We still want to create the embed to give users visual feedback
                    $91ff85a144d02ea6$var$createEmbed(json, element);
                    reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                    return;
                }
                resolve(json);
            } catch (error) {
                reject(error);
            }
        };
        xhr.onerror = function() {
            var status = xhr.status ? " (".concat(xhr.status, ")") : '';
            reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
        };
        xhr.send();
    });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $91ff85a144d02ea6$var$initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
    var handleError = function handleError(error) {
        if ('console' in window && console.error) console.error("There was an error creating an embed: ".concat(error));
    };
    elements.forEach(function(element) {
        try {
            // Skip any that have data-vimeo-defer
            if (element.getAttribute('data-vimeo-defer') !== null) return;
            var params = $91ff85a144d02ea6$var$getOEmbedParameters(element);
            var url = $91ff85a144d02ea6$var$getVimeoUrl(params);
            $91ff85a144d02ea6$var$getOEmbedData(url, params, element).then(function(data) {
                return $91ff85a144d02ea6$var$createEmbed(data, element);
            }).catch(handleError);
        } catch (error) {
            handleError(error);
        }
    });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $91ff85a144d02ea6$var$resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) return;
    window.VimeoPlayerResizeEmbeds_ = true;
    var onMessage = function onMessage(event) {
        if (!$91ff85a144d02ea6$var$isVimeoUrl(event.origin)) return;
        // 'spacechange' is fired only on embeds with cards
        if (!event.data || event.data.event !== 'spacechange') return;
        var senderIFrame = event.source ? $91ff85a144d02ea6$var$findIframeBySourceWindow(event.source, parent) : null;
        if (senderIFrame) {
            // Change padding-bottom of the enclosing div to accommodate
            // card carousel without distorting aspect ratio
            var space = senderIFrame.parentElement;
            space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
        }
    };
    window.addEventListener('message', onMessage);
}
/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $91ff85a144d02ea6$var$initAppendVideoMetadata() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoSeoMetadataAppended) return;
    window.VimeoSeoMetadataAppended = true;
    var onMessage = function onMessage(event) {
        if (!$91ff85a144d02ea6$var$isVimeoUrl(event.origin)) return;
        var data = $91ff85a144d02ea6$var$parseMessageData(event.data);
        if (!data || data.event !== 'ready') return;
        var senderIFrame = event.source ? $91ff85a144d02ea6$var$findIframeBySourceWindow(event.source, parent) : null;
        // Initiate appendVideoMetadata if iframe is a Vimeo embed
        if (senderIFrame && $91ff85a144d02ea6$var$isVimeoEmbed(senderIFrame.src)) {
            var player = new $91ff85a144d02ea6$var$Player(senderIFrame);
            player.callMethod('appendVideoMetadata', window.location.href);
        }
    };
    window.addEventListener('message', onMessage);
}
/**
 * Seek to time indicated by vimeo_t query parameter if present in URL
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $91ff85a144d02ea6$var$checkUrlTimeParam() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoCheckedUrlTimeParam) return;
    window.VimeoCheckedUrlTimeParam = true;
    var handleError = function handleError(error) {
        if ('console' in window && console.error) console.error("There was an error getting video Id: ".concat(error));
    };
    var onMessage = function onMessage(event) {
        if (!$91ff85a144d02ea6$var$isVimeoUrl(event.origin)) return;
        var data = $91ff85a144d02ea6$var$parseMessageData(event.data);
        if (!data || data.event !== 'ready') return;
        var senderIFrame = event.source ? $91ff85a144d02ea6$var$findIframeBySourceWindow(event.source, parent) : null;
        if (senderIFrame && $91ff85a144d02ea6$var$isVimeoEmbed(senderIFrame.src)) {
            var player = new $91ff85a144d02ea6$var$Player(senderIFrame);
            player.getVideoId().then(function(videoId) {
                var matches = new RegExp("[?&]vimeo_t_".concat(videoId, "=([^&#]*)")).exec(window.location.href);
                if (matches && matches[1]) {
                    var sec = decodeURI(matches[1]);
                    player.setCurrentTime(sec);
                }
                return;
            }).catch(handleError);
        }
    };
    window.addEventListener('message', onMessage);
}
/**
 * Updates iframe embeds to support DRM content playback by adding the 'encrypted-media' permission
 * to the iframe's allow attribute when DRM initialization fails. This function acts as a fallback
 * mechanism to enable playback of DRM-protected content in embeds that weren't properly configured.
 *
 * @return {void}
 */ function $91ff85a144d02ea6$var$updateDRMEmbeds() {
    if (window.VimeoDRMEmbedsUpdated) return;
    window.VimeoDRMEmbedsUpdated = true;
    /**
   * Handle message events for DRM initialization failures
   * @param {MessageEvent} event - The message event from the iframe
   */ var onMessage = function onMessage(event) {
        if (!$91ff85a144d02ea6$var$isVimeoUrl(event.origin)) return;
        var data = $91ff85a144d02ea6$var$parseMessageData(event.data);
        if (!data || data.event !== 'drminitfailed') return;
        var senderIFrame = event.source ? $91ff85a144d02ea6$var$findIframeBySourceWindow(event.source) : null;
        if (!senderIFrame) return;
        var currentAllow = senderIFrame.getAttribute('allow') || '';
        var allowSupportsDRM = currentAllow.includes('encrypted-media');
        if (!allowSupportsDRM) {
            // For DRM playback to successfully occur, the iframe `allow` attribute must include 'encrypted-media'.
            // If the video requires DRM but doesn't have the attribute, we try to add on behalf of the embed owner
            // as a temporary measure to enable playback until they're able to update their embeds.
            senderIFrame.setAttribute('allow', "".concat(currentAllow, "; encrypted-media"));
            var currentUrl = new URL(senderIFrame.getAttribute('src'));
            // Adding this forces the embed to reload once `allow` has been updated with `encrypted-media`.
            currentUrl.searchParams.set('forcereload', 'drm');
            senderIFrame.setAttribute('src', currentUrl.toString());
            return;
        }
    };
    window.addEventListener('message', onMessage);
}
/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */ function $91ff85a144d02ea6$var$initializeScreenfull() {
    var fn = function() {
        var val;
        var fnMap = [
            [
                'requestFullscreen',
                'exitFullscreen',
                'fullscreenElement',
                'fullscreenEnabled',
                'fullscreenchange',
                'fullscreenerror'
            ],
            // New WebKit
            [
                'webkitRequestFullscreen',
                'webkitExitFullscreen',
                'webkitFullscreenElement',
                'webkitFullscreenEnabled',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            // Old WebKit
            [
                'webkitRequestFullScreen',
                'webkitCancelFullScreen',
                'webkitCurrentFullScreenElement',
                'webkitCancelFullScreen',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            [
                'mozRequestFullScreen',
                'mozCancelFullScreen',
                'mozFullScreenElement',
                'mozFullScreenEnabled',
                'mozfullscreenchange',
                'mozfullscreenerror'
            ],
            [
                'msRequestFullscreen',
                'msExitFullscreen',
                'msFullscreenElement',
                'msFullscreenEnabled',
                'MSFullscreenChange',
                'MSFullscreenError'
            ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    var eventNameMap = {
        fullscreenchange: fn.fullscreenchange,
        fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
        request: function request(element) {
            return new Promise(function(resolve, reject) {
                var onFullScreenEntered = function onFullScreenEntered() {
                    screenfull.off('fullscreenchange', onFullScreenEntered);
                    resolve();
                };
                screenfull.on('fullscreenchange', onFullScreenEntered);
                element = element || document.documentElement;
                var returnPromise = element[fn.requestFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            });
        },
        exit: function exit() {
            return new Promise(function(resolve, reject) {
                if (!screenfull.isFullscreen) {
                    resolve();
                    return;
                }
                var onFullScreenExit = function onFullScreenExit() {
                    screenfull.off('fullscreenchange', onFullScreenExit);
                    resolve();
                };
                screenfull.on('fullscreenchange', onFullScreenExit);
                var returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            });
        },
        on: function on(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback);
        },
        off: function off(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback);
        }
    };
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get: function get() {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get: function get() {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get: function get() {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    return screenfull;
}
/** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */ /** @typedef {import('timing-object').ITimingObject} TimingObject */ /** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */ /** @typedef {(msg: string) => any} Logger */ /** @typedef {import('timing-object').TConnectionState} TConnectionState */ /**
 * @type {TimingSrcConnectorOptions}
 *
 * For details on these properties and their effects, see the typescript definition referenced above.
 */ var $91ff85a144d02ea6$var$defaultOptions = {
    role: 'viewer',
    autoPlayMuted: true,
    allowedDrift: 0.3,
    maxAllowedDrift: 1,
    minCheckInterval: 0.1,
    maxRateAdjustment: 0.2,
    maxTimeToCatchUp: 1
};
/**
 * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
 *
 * Proposed spec: https://webtiming.github.io/timingobject/
 * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
 * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
 *
 * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
 *
 * There are 5 general responsibilities in TimingSrcConnector:
 *
 * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
 * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
 * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
 * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
 * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
 */ var $91ff85a144d02ea6$var$TimingSrcConnector = /*#__PURE__*/ function(_EventTarget) {
    $91ff85a144d02ea6$var$_inherits(TimingSrcConnector, _EventTarget);
    var _super = $91ff85a144d02ea6$var$_createSuper(TimingSrcConnector);
    /**
   * @param {PlayerControls} player
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   * @param {Logger} logger
   */ function TimingSrcConnector(_player, timingObject) {
        var _this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var logger = arguments.length > 3 ? arguments[3] : undefined;
        $91ff85a144d02ea6$var$_classCallCheck(this, TimingSrcConnector);
        _this = _super.call(this);
        $91ff85a144d02ea6$var$_defineProperty($91ff85a144d02ea6$var$_assertThisInitialized(_this), "logger", void 0);
        $91ff85a144d02ea6$var$_defineProperty($91ff85a144d02ea6$var$_assertThisInitialized(_this), "speedAdjustment", 0);
        /**
     * @param {PlayerControls} player
     * @param {number} newAdjustment
     * @return {Promise<void>}
     */ $91ff85a144d02ea6$var$_defineProperty($91ff85a144d02ea6$var$_assertThisInitialized(_this), "adjustSpeed", /*#__PURE__*/ function() {
            var _ref = $91ff85a144d02ea6$var$_asyncToGenerator(/*#__PURE__*/ $91ff85a144d02ea6$var$_regeneratorRuntime().mark(function _callee(player, newAdjustment) {
                var newPlaybackRate;
                return $91ff85a144d02ea6$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!(_this.speedAdjustment === newAdjustment)) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            _context.next = 4;
                            return player.getPlaybackRate();
                        case 4:
                            _context.t0 = _context.sent;
                            _context.t1 = _this.speedAdjustment;
                            _context.t2 = _context.t0 - _context.t1;
                            _context.t3 = newAdjustment;
                            newPlaybackRate = _context.t2 + _context.t3;
                            _this.log("New playbackRate:  ".concat(newPlaybackRate));
                            _context.next = 12;
                            return player.setPlaybackRate(newPlaybackRate);
                        case 12:
                            _this.speedAdjustment = newAdjustment;
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.logger = logger;
        _this.init(timingObject, _player, $91ff85a144d02ea6$var$_objectSpread2($91ff85a144d02ea6$var$_objectSpread2({}, $91ff85a144d02ea6$var$defaultOptions), options));
        return _this;
    }
    $91ff85a144d02ea6$var$_createClass(TimingSrcConnector, [
        {
            key: "disconnect",
            value: function disconnect() {
                this.dispatchEvent(new Event('disconnect'));
            }
        },
        {
            key: "init",
            value: function() {
                var _init = $91ff85a144d02ea6$var$_asyncToGenerator(/*#__PURE__*/ $91ff85a144d02ea6$var$_regeneratorRuntime().mark(function _callee2(timingObject, player, options) {
                    var _this2 = this;
                    var playerUpdater, positionSync, timingObjectUpdater;
                    return $91ff85a144d02ea6$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.waitForTOReadyState(timingObject, 'open');
                            case 2:
                                if (!(options.role === 'viewer')) {
                                    _context2.next = 10;
                                    break;
                                }
                                _context2.next = 5;
                                return this.updatePlayer(timingObject, player, options);
                            case 5:
                                playerUpdater = $91ff85a144d02ea6$var$subscribe(timingObject, 'change', function() {
                                    return _this2.updatePlayer(timingObject, player, options);
                                });
                                positionSync = this.maintainPlaybackPosition(timingObject, player, options);
                                this.addEventListener('disconnect', function() {
                                    positionSync.cancel();
                                    playerUpdater.cancel();
                                });
                                _context2.next = 14;
                                break;
                            case 10:
                                _context2.next = 12;
                                return this.updateTimingObject(timingObject, player);
                            case 12:
                                timingObjectUpdater = $91ff85a144d02ea6$var$subscribe(player, [
                                    'seeked',
                                    'play',
                                    'pause',
                                    'ratechange'
                                ], function() {
                                    return _this2.updateTimingObject(timingObject, player);
                                }, 'on', 'off');
                                this.addEventListener('disconnect', function() {
                                    return timingObjectUpdater.cancel();
                                });
                            case 14:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function init(_x3, _x4, _x5) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "updateTimingObject",
            value: function() {
                var _updateTimingObject = $91ff85a144d02ea6$var$_asyncToGenerator(/*#__PURE__*/ $91ff85a144d02ea6$var$_regeneratorRuntime().mark(function _callee3(timingObject, player) {
                    var _yield$Promise$all, _yield$Promise$all2, position, isPaused, playbackRate;
                    return $91ff85a144d02ea6$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 2;
                                return Promise.all([
                                    player.getCurrentTime(),
                                    player.getPaused(),
                                    player.getPlaybackRate()
                                ]);
                            case 2:
                                _yield$Promise$all = _context3.sent;
                                _yield$Promise$all2 = $91ff85a144d02ea6$var$_slicedToArray(_yield$Promise$all, 3);
                                position = _yield$Promise$all2[0];
                                isPaused = _yield$Promise$all2[1];
                                playbackRate = _yield$Promise$all2[2];
                                timingObject.update({
                                    position: position,
                                    velocity: isPaused ? 0 : playbackRate
                                });
                            case 8:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function updateTimingObject(_x6, _x7) {
                    return _updateTimingObject.apply(this, arguments);
                }
                return updateTimingObject;
            }()
        },
        {
            key: "updatePlayer",
            value: function() {
                var _updatePlayer = $91ff85a144d02ea6$var$_asyncToGenerator(/*#__PURE__*/ $91ff85a144d02ea6$var$_regeneratorRuntime().mark(function _callee5(timingObject, player, options) {
                    var _timingObject$query, position, velocity;
                    return $91ff85a144d02ea6$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _timingObject$query = timingObject.query(), position = _timingObject$query.position, velocity = _timingObject$query.velocity;
                                if (typeof position === 'number') player.setCurrentTime(position);
                                if (!(typeof velocity === 'number')) {
                                    _context5.next = 25;
                                    break;
                                }
                                if (!(velocity === 0)) {
                                    _context5.next = 11;
                                    break;
                                }
                                _context5.next = 6;
                                return player.getPaused();
                            case 6:
                                _context5.t0 = _context5.sent;
                                if (!(_context5.t0 === false)) {
                                    _context5.next = 9;
                                    break;
                                }
                                player.pause();
                            case 9:
                                _context5.next = 25;
                                break;
                            case 11:
                                if (!(velocity > 0)) {
                                    _context5.next = 25;
                                    break;
                                }
                                _context5.next = 14;
                                return player.getPaused();
                            case 14:
                                _context5.t1 = _context5.sent;
                                if (!(_context5.t1 === true)) {
                                    _context5.next = 19;
                                    break;
                                }
                                _context5.next = 18;
                                return player.play().catch(/*#__PURE__*/ function() {
                                    var _ref2 = $91ff85a144d02ea6$var$_asyncToGenerator(/*#__PURE__*/ $91ff85a144d02ea6$var$_regeneratorRuntime().mark(function _callee4(err) {
                                        return $91ff85a144d02ea6$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                                            while(true)switch(_context4.prev = _context4.next){
                                                case 0:
                                                    if (!(err.name === 'NotAllowedError' && options.autoPlayMuted)) {
                                                        _context4.next = 5;
                                                        break;
                                                    }
                                                    _context4.next = 3;
                                                    return player.setMuted(true);
                                                case 3:
                                                    _context4.next = 5;
                                                    return player.play().catch(function(err2) {
                                                        return console.error('Couldn\'t play the video from TimingSrcConnector. Error:', err2);
                                                    });
                                                case 5:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }, _callee4);
                                    }));
                                    return function(_x11) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }());
                            case 18:
                                this.updatePlayer(timingObject, player, options);
                            case 19:
                                _context5.next = 21;
                                return player.getPlaybackRate();
                            case 21:
                                _context5.t2 = _context5.sent;
                                _context5.t3 = velocity;
                                if (!(_context5.t2 !== _context5.t3)) {
                                    _context5.next = 25;
                                    break;
                                }
                                player.setPlaybackRate(velocity);
                            case 25:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updatePlayer(_x8, _x9, _x10) {
                    return _updatePlayer.apply(this, arguments);
                }
                return updatePlayer;
            }()
        },
        {
            key: "maintainPlaybackPosition",
            value: function maintainPlaybackPosition(timingObject, player, options) {
                var _this3 = this;
                var allowedDrift = options.allowedDrift, maxAllowedDrift = options.maxAllowedDrift, minCheckInterval = options.minCheckInterval, maxRateAdjustment = options.maxRateAdjustment, maxTimeToCatchUp = options.maxTimeToCatchUp;
                var syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
                var check = /*#__PURE__*/ function() {
                    var _ref3 = $91ff85a144d02ea6$var$_asyncToGenerator(/*#__PURE__*/ $91ff85a144d02ea6$var$_regeneratorRuntime().mark(function _callee6() {
                        var diff, diffAbs, min, max, adjustment;
                        return $91ff85a144d02ea6$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                            while(true)switch(_context6.prev = _context6.next){
                                case 0:
                                    _context6.t0 = timingObject.query().velocity === 0;
                                    if (_context6.t0) {
                                        _context6.next = 6;
                                        break;
                                    }
                                    _context6.next = 4;
                                    return player.getPaused();
                                case 4:
                                    _context6.t1 = _context6.sent;
                                    _context6.t0 = _context6.t1 === true;
                                case 6:
                                    if (!_context6.t0) {
                                        _context6.next = 8;
                                        break;
                                    }
                                    return _context6.abrupt("return");
                                case 8:
                                    _context6.t2 = timingObject.query().position;
                                    _context6.next = 11;
                                    return player.getCurrentTime();
                                case 11:
                                    _context6.t3 = _context6.sent;
                                    diff = _context6.t2 - _context6.t3;
                                    diffAbs = Math.abs(diff);
                                    _this3.log("Drift: ".concat(diff));
                                    if (!(diffAbs > maxAllowedDrift)) {
                                        _context6.next = 22;
                                        break;
                                    }
                                    _context6.next = 18;
                                    return _this3.adjustSpeed(player, 0);
                                case 18:
                                    player.setCurrentTime(timingObject.query().position);
                                    _this3.log('Resync by currentTime');
                                    _context6.next = 29;
                                    break;
                                case 22:
                                    if (!(diffAbs > allowedDrift)) {
                                        _context6.next = 29;
                                        break;
                                    }
                                    min = diffAbs / maxTimeToCatchUp;
                                    max = maxRateAdjustment;
                                    adjustment = min < max ? (max - min) / 2 : max;
                                    _context6.next = 28;
                                    return _this3.adjustSpeed(player, adjustment * Math.sign(diff));
                                case 28:
                                    _this3.log('Resync by playbackRate');
                                case 29:
                                case "end":
                                    return _context6.stop();
                            }
                        }, _callee6);
                    }));
                    return function check() {
                        return _ref3.apply(this, arguments);
                    };
                }();
                var interval = setInterval(function() {
                    return check();
                }, syncInterval);
                return {
                    cancel: function cancel() {
                        return clearInterval(interval);
                    }
                };
            }
        },
        {
            key: "log",
            value: function log(msg) {
                var _this$logger;
                (_this$logger = this.logger) === null || _this$logger === void 0 || _this$logger.call(this, "TimingSrcConnector: ".concat(msg));
            }
        },
        {
            key: "waitForTOReadyState",
            value: /**
     * @param {TimingObject} timingObject
     * @param {TConnectionState} state
     * @return {Promise<void>}
     */ function waitForTOReadyState(timingObject, state) {
                return new Promise(function(resolve) {
                    var check = function check() {
                        if (timingObject.readyState === state) resolve();
                        else timingObject.addEventListener('readystatechange', check, {
                            once: true
                        });
                    };
                    check();
                });
            }
        }
    ]);
    return TimingSrcConnector;
}(/*#__PURE__*/ $91ff85a144d02ea6$var$_wrapNativeSuper(EventTarget));
var $91ff85a144d02ea6$var$playerMap = new WeakMap();
var $91ff85a144d02ea6$var$readyMap = new WeakMap();
var $91ff85a144d02ea6$var$screenfull = {};
var $91ff85a144d02ea6$var$Player = /*#__PURE__*/ function() {
    /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */ function Player(element) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $91ff85a144d02ea6$var$_classCallCheck(this, Player);
        /* global jQuery */ if (window.jQuery && element instanceof jQuery) {
            if (element.length > 1 && window.console && console.warn) console.warn('A jQuery object with multiple elements was passed, using the first element.');
            element = element[0];
        }
        // Find an element by ID
        if (typeof document !== 'undefined' && typeof element === 'string') element = document.getElementById(element);
        // Not an element!
        if (!$91ff85a144d02ea6$var$isDomElement(element)) throw new TypeError('You must pass either a valid element or a valid id.');
        // Already initialized an embed in this div, so grab the iframe
        if (element.nodeName !== 'IFRAME') {
            var iframe = element.querySelector('iframe');
            if (iframe) element = iframe;
        }
        // iframe url is not a Vimeo url
        if (element.nodeName === 'IFRAME' && !$91ff85a144d02ea6$var$isVimeoUrl(element.getAttribute('src') || '')) throw new Error("The player element passed isn\u2019t a Vimeo embed.");
        // If there is already a player object in the map, return that
        if ($91ff85a144d02ea6$var$playerMap.has(element)) return $91ff85a144d02ea6$var$playerMap.get(element);
        this._window = element.ownerDocument.defaultView;
        this.element = element;
        this.origin = '*';
        var readyPromise = new $91ff85a144d02ea6$var$npo_src(function(resolve, reject) {
            _this._onMessage = function(event) {
                if (!$91ff85a144d02ea6$var$isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) return;
                if (_this.origin === '*') _this.origin = event.origin;
                var data = $91ff85a144d02ea6$var$parseMessageData(event.data);
                var isError = data && data.event === 'error';
                var isReadyError = isError && data.data && data.data.method === 'ready';
                if (isReadyError) {
                    var error = new Error(data.data.message);
                    error.name = data.data.name;
                    reject(error);
                    return;
                }
                var isReadyEvent = data && data.event === 'ready';
                var isPingResponse = data && data.method === 'ping';
                if (isReadyEvent || isPingResponse) {
                    _this.element.setAttribute('data-ready', 'true');
                    resolve();
                    return;
                }
                $91ff85a144d02ea6$var$processData(_this, data);
            };
            _this._window.addEventListener('message', _this._onMessage);
            if (_this.element.nodeName !== 'IFRAME') {
                var params = $91ff85a144d02ea6$var$getOEmbedParameters(element, options);
                var url = $91ff85a144d02ea6$var$getVimeoUrl(params);
                $91ff85a144d02ea6$var$getOEmbedData(url, params, element).then(function(data) {
                    var iframe = $91ff85a144d02ea6$var$createEmbed(data, element);
                    // Overwrite element with the new iframe,
                    // but store reference to the original element
                    _this.element = iframe;
                    _this._originalElement = element;
                    $91ff85a144d02ea6$var$swapCallbacks(element, iframe);
                    $91ff85a144d02ea6$var$playerMap.set(_this.element, _this);
                    return data;
                }).catch(reject);
            }
        });
        // Store a copy of this Player in the map
        $91ff85a144d02ea6$var$readyMap.set(this, readyPromise);
        $91ff85a144d02ea6$var$playerMap.set(this.element, this);
        // Send a ping to the iframe so the ready promise will be resolved if
        // the player is already ready.
        if (this.element.nodeName === 'IFRAME') $91ff85a144d02ea6$var$postMessage(this, 'ping');
        if ($91ff85a144d02ea6$var$screenfull.isEnabled) {
            var exitFullscreen = function exitFullscreen() {
                return $91ff85a144d02ea6$var$screenfull.exit();
            };
            this.fullscreenchangeHandler = function() {
                if ($91ff85a144d02ea6$var$screenfull.isFullscreen) $91ff85a144d02ea6$var$storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
                else $91ff85a144d02ea6$var$removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
                // eslint-disable-next-line
                _this.ready().then(function() {
                    $91ff85a144d02ea6$var$postMessage(_this, 'fullscreenchange', $91ff85a144d02ea6$var$screenfull.isFullscreen);
                });
            };
            $91ff85a144d02ea6$var$screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
        }
        return this;
    }
    /**
   * Check to see if the URL is a Vimeo URL.
   *
   * @param {string} url The URL string.
   * @return {boolean}
   */ $91ff85a144d02ea6$var$_createClass(Player, [
        {
            key: "callMethod",
            value: /**
     * Get a promise for a method.
     *
     * @param {string} name The API method to call.
     * @param {...(string|number|object|Array)} args Arguments to send via postMessage.
     * @return {Promise}
     */ function callMethod(name) {
                var _this2 = this;
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (name === undefined || name === null) throw new TypeError('You must pass a method name.');
                return new $91ff85a144d02ea6$var$npo_src(function(resolve, reject) {
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    return _this2.ready().then(function() {
                        $91ff85a144d02ea6$var$storeCallback(_this2, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        if (args.length === 0) args = {};
                        else if (args.length === 1) args = args[0];
                        $91ff85a144d02ea6$var$postMessage(_this2, name, args);
                    }).catch(reject);
                });
            }
        },
        {
            key: "get",
            value: function get(name) {
                var _this3 = this;
                return new $91ff85a144d02ea6$var$npo_src(function(resolve, reject) {
                    name = $91ff85a144d02ea6$var$getMethodName(name, 'get');
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    return _this3.ready().then(function() {
                        $91ff85a144d02ea6$var$storeCallback(_this3, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $91ff85a144d02ea6$var$postMessage(_this3, name);
                    }).catch(reject);
                });
            }
        },
        {
            key: "set",
            value: function set(name, value) {
                var _this4 = this;
                return new $91ff85a144d02ea6$var$npo_src(function(resolve, reject) {
                    name = $91ff85a144d02ea6$var$getMethodName(name, 'set');
                    if (value === undefined || value === null) throw new TypeError('There must be a value to set.');
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    return _this4.ready().then(function() {
                        $91ff85a144d02ea6$var$storeCallback(_this4, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $91ff85a144d02ea6$var$postMessage(_this4, name, value);
                    }).catch(reject);
                });
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!eventName) throw new TypeError('You must pass an event name.');
                if (!callback) throw new TypeError('You must pass a callback function.');
                if (typeof callback !== 'function') throw new TypeError('The callback must be a function.');
                var callbacks = $91ff85a144d02ea6$var$getCallbacks(this, "event:".concat(eventName));
                if (callbacks.length === 0) this.callMethod('addEventListener', eventName).catch(function() {
                // Ignore the error. There will be an error event fired that
                // will trigger the error callback if they are listening.
                });
                $91ff85a144d02ea6$var$storeCallback(this, "event:".concat(eventName), callback);
            }
        },
        {
            key: "off",
            value: function off(eventName, callback) {
                if (!eventName) throw new TypeError('You must pass an event name.');
                if (callback && typeof callback !== 'function') throw new TypeError('The callback must be a function.');
                var lastCallback = $91ff85a144d02ea6$var$removeCallback(this, "event:".concat(eventName), callback);
                // If there are no callbacks left, remove the listener
                if (lastCallback) this.callMethod('removeEventListener', eventName).catch(function(e) {
                // Ignore the error. There will be an error event fired that
                // will trigger the error callback if they are listening.
                });
            }
        },
        {
            key: "loadVideo",
            value: function loadVideo(options) {
                return this.callMethod('loadVideo', options);
            }
        },
        {
            key: "ready",
            value: function ready() {
                var readyPromise = $91ff85a144d02ea6$var$readyMap.get(this) || new $91ff85a144d02ea6$var$npo_src(function(resolve, reject) {
                    reject(new Error('Unknown player. Probably unloaded.'));
                });
                return $91ff85a144d02ea6$var$npo_src.resolve(readyPromise);
            }
        },
        {
            key: "addCuePoint",
            value: function addCuePoint(time) {
                var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.callMethod('addCuePoint', {
                    time: time,
                    data: data
                });
            }
        },
        {
            key: "removeCuePoint",
            value: function removeCuePoint(id) {
                return this.callMethod('removeCuePoint', id);
            }
        },
        {
            key: "enableTextTrack",
            value: function enableTextTrack(language, kind) {
                if (!language) throw new TypeError('You must pass a language.');
                return this.callMethod('enableTextTrack', {
                    language: language,
                    kind: kind
                });
            }
        },
        {
            key: "disableTextTrack",
            value: function disableTextTrack() {
                return this.callMethod('disableTextTrack');
            }
        },
        {
            key: "pause",
            value: function pause() {
                return this.callMethod('pause');
            }
        },
        {
            key: "play",
            value: function play() {
                return this.callMethod('play');
            }
        },
        {
            key: "requestFullscreen",
            value: function requestFullscreen() {
                if ($91ff85a144d02ea6$var$screenfull.isEnabled) return $91ff85a144d02ea6$var$screenfull.request(this.element);
                return this.callMethod('requestFullscreen');
            }
        },
        {
            key: "exitFullscreen",
            value: function exitFullscreen() {
                if ($91ff85a144d02ea6$var$screenfull.isEnabled) return $91ff85a144d02ea6$var$screenfull.exit();
                return this.callMethod('exitFullscreen');
            }
        },
        {
            key: "getFullscreen",
            value: function getFullscreen() {
                if ($91ff85a144d02ea6$var$screenfull.isEnabled) return $91ff85a144d02ea6$var$npo_src.resolve($91ff85a144d02ea6$var$screenfull.isFullscreen);
                return this.get('fullscreen');
            }
        },
        {
            key: "requestPictureInPicture",
            value: function requestPictureInPicture() {
                return this.callMethod('requestPictureInPicture');
            }
        },
        {
            key: "exitPictureInPicture",
            value: function exitPictureInPicture() {
                return this.callMethod('exitPictureInPicture');
            }
        },
        {
            key: "getPictureInPicture",
            value: function getPictureInPicture() {
                return this.get('pictureInPicture');
            }
        },
        {
            key: "remotePlaybackPrompt",
            value: function remotePlaybackPrompt() {
                return this.callMethod('remotePlaybackPrompt');
            }
        },
        {
            key: "unload",
            value: function unload() {
                return this.callMethod('unload');
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this5 = this;
                return new $91ff85a144d02ea6$var$npo_src(function(resolve) {
                    $91ff85a144d02ea6$var$readyMap.delete(_this5);
                    $91ff85a144d02ea6$var$playerMap.delete(_this5.element);
                    if (_this5._originalElement) {
                        $91ff85a144d02ea6$var$playerMap.delete(_this5._originalElement);
                        _this5._originalElement.removeAttribute('data-vimeo-initialized');
                    }
                    if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
                        // If we've added an additional wrapper div, remove that from the DOM.
                        // If not, just remove the iframe element.
                        if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
                        else _this5.element.parentNode.removeChild(_this5.element);
                    }
                    // If the clip is private there is a case where the element stays the
                    // div element. Destroy should reset the div and remove the iframe child.
                    if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
                        _this5.element.removeAttribute('data-vimeo-initialized');
                        var iframe = _this5.element.querySelector('iframe');
                        if (iframe && iframe.parentNode) {
                            // If we've added an additional wrapper div, remove that from the DOM.
                            // If not, just remove the iframe element.
                            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) iframe.parentNode.parentNode.removeChild(iframe.parentNode);
                            else iframe.parentNode.removeChild(iframe);
                        }
                    }
                    _this5._window.removeEventListener('message', _this5._onMessage);
                    if ($91ff85a144d02ea6$var$screenfull.isEnabled) $91ff85a144d02ea6$var$screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
                    resolve();
                });
            }
        },
        {
            key: "getAutopause",
            value: function getAutopause() {
                return this.get('autopause');
            }
        },
        {
            key: "setAutopause",
            value: function setAutopause(autopause) {
                return this.set('autopause', autopause);
            }
        },
        {
            key: "getBuffered",
            value: function getBuffered() {
                return this.get('buffered');
            }
        },
        {
            key: "getCameraProps",
            value: function getCameraProps() {
                return this.get('cameraProps');
            }
        },
        {
            key: "setCameraProps",
            value: function setCameraProps(camera) {
                return this.set('cameraProps', camera);
            }
        },
        {
            key: "getChapters",
            value: function getChapters() {
                return this.get('chapters');
            }
        },
        {
            key: "getCurrentChapter",
            value: function getCurrentChapter() {
                return this.get('currentChapter');
            }
        },
        {
            key: "getColor",
            value: function getColor() {
                return this.get('color');
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return $91ff85a144d02ea6$var$npo_src.all([
                    this.get('colorOne'),
                    this.get('colorTwo'),
                    this.get('colorThree'),
                    this.get('colorFour')
                ]);
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                return this.set('color', color);
            }
        },
        {
            key: "setColors",
            value: function setColors(colors) {
                if (!Array.isArray(colors)) return new $91ff85a144d02ea6$var$npo_src(function(resolve, reject) {
                    return reject(new TypeError('Argument must be an array.'));
                });
                var nullPromise = new $91ff85a144d02ea6$var$npo_src(function(resolve) {
                    return resolve(null);
                });
                var colorPromises = [
                    colors[0] ? this.set('colorOne', colors[0]) : nullPromise,
                    colors[1] ? this.set('colorTwo', colors[1]) : nullPromise,
                    colors[2] ? this.set('colorThree', colors[2]) : nullPromise,
                    colors[3] ? this.set('colorFour', colors[3]) : nullPromise
                ];
                return $91ff85a144d02ea6$var$npo_src.all(colorPromises);
            }
        },
        {
            key: "getCuePoints",
            value: function getCuePoints() {
                return this.get('cuePoints');
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                return this.get('currentTime');
            }
        },
        {
            key: "setCurrentTime",
            value: function setCurrentTime(currentTime) {
                return this.set('currentTime', currentTime);
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return this.get('duration');
            }
        },
        {
            key: "getEnded",
            value: function getEnded() {
                return this.get('ended');
            }
        },
        {
            key: "getLoop",
            value: function getLoop() {
                return this.get('loop');
            }
        },
        {
            key: "setLoop",
            value: function setLoop(loop) {
                return this.set('loop', loop);
            }
        },
        {
            key: "setMuted",
            value: function setMuted(muted) {
                return this.set('muted', muted);
            }
        },
        {
            key: "getMuted",
            value: function getMuted() {
                return this.get('muted');
            }
        },
        {
            key: "getPaused",
            value: function getPaused() {
                return this.get('paused');
            }
        },
        {
            key: "getPlaybackRate",
            value: function getPlaybackRate() {
                return this.get('playbackRate');
            }
        },
        {
            key: "setPlaybackRate",
            value: function setPlaybackRate(playbackRate) {
                return this.set('playbackRate', playbackRate);
            }
        },
        {
            key: "getPlayed",
            value: function getPlayed() {
                return this.get('played');
            }
        },
        {
            key: "getQualities",
            value: function getQualities() {
                return this.get('qualities');
            }
        },
        {
            key: "getQuality",
            value: function getQuality() {
                return this.get('quality');
            }
        },
        {
            key: "setQuality",
            value: function setQuality(quality) {
                return this.set('quality', quality);
            }
        },
        {
            key: "getRemotePlaybackAvailability",
            value: function getRemotePlaybackAvailability() {
                return this.get('remotePlaybackAvailability');
            }
        },
        {
            key: "getRemotePlaybackState",
            value: function getRemotePlaybackState() {
                return this.get('remotePlaybackState');
            }
        },
        {
            key: "getSeekable",
            value: function getSeekable() {
                return this.get('seekable');
            }
        },
        {
            key: "getSeeking",
            value: function getSeeking() {
                return this.get('seeking');
            }
        },
        {
            key: "getTextTracks",
            value: function getTextTracks() {
                return this.get('textTracks');
            }
        },
        {
            key: "getVideoEmbedCode",
            value: function getVideoEmbedCode() {
                return this.get('videoEmbedCode');
            }
        },
        {
            key: "getVideoId",
            value: function getVideoId() {
                return this.get('videoId');
            }
        },
        {
            key: "getVideoTitle",
            value: function getVideoTitle() {
                return this.get('videoTitle');
            }
        },
        {
            key: "getVideoWidth",
            value: function getVideoWidth() {
                return this.get('videoWidth');
            }
        },
        {
            key: "getVideoHeight",
            value: function getVideoHeight() {
                return this.get('videoHeight');
            }
        },
        {
            key: "getVideoUrl",
            value: function getVideoUrl() {
                return this.get('videoUrl');
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.get('volume');
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                return this.set('volume', volume);
            }
        },
        {
            key: "setTimingSrc",
            value: function() {
                var _setTimingSrc = $91ff85a144d02ea6$var$_asyncToGenerator(/*#__PURE__*/ $91ff85a144d02ea6$var$_regeneratorRuntime().mark(function _callee(timingObject, options) {
                    var _this6 = this;
                    var connector;
                    return $91ff85a144d02ea6$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (timingObject) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new TypeError('A Timing Object must be provided.');
                            case 2:
                                _context.next = 4;
                                return this.ready();
                            case 4:
                                connector = new $91ff85a144d02ea6$var$TimingSrcConnector(this, timingObject, options);
                                $91ff85a144d02ea6$var$postMessage(this, 'notifyTimingObjectConnect');
                                connector.addEventListener('disconnect', function() {
                                    return $91ff85a144d02ea6$var$postMessage(_this6, 'notifyTimingObjectDisconnect');
                                });
                                return _context.abrupt("return", connector);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function setTimingSrc(_x, _x2) {
                    return _setTimingSrc.apply(this, arguments);
                }
                return setTimingSrc;
            }()
        }
    ], [
        {
            key: "isVimeoUrl",
            value: function isVimeoUrl$1(url) {
                return $91ff85a144d02ea6$var$isVimeoUrl(url);
            }
        }
    ]);
    return Player;
}(); // Setup embed only if this is not a server runtime
if (!$91ff85a144d02ea6$var$isServerRuntime) {
    $91ff85a144d02ea6$var$screenfull = $91ff85a144d02ea6$var$initializeScreenfull();
    $91ff85a144d02ea6$var$initializeEmbeds();
    $91ff85a144d02ea6$var$resizeEmbeds();
    $91ff85a144d02ea6$var$initAppendVideoMetadata();
    $91ff85a144d02ea6$var$checkUrlTimeParam();
    $91ff85a144d02ea6$var$updateDRMEmbeds();
}
var $91ff85a144d02ea6$export$2e2bcd8739ae039 = $91ff85a144d02ea6$var$Player;


var $90ea2cfff976321f$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const videoElements = node.querySelectorAll('.js-videoElement');
    const vimeoElements = node.querySelectorAll('.js-vimeoElement');
    /**
   * Functions
   */ const createVideoCursor = (element)=>{
        const cursor = element.querySelector('.js-videoCursor');
        const play = cursor.querySelector('.js-play');
        const pause = cursor.querySelector('.js-pause');
        element.addEventListener('mousemove', (event)=>{
            const { top: top, left: left } = element.getBoundingClientRect();
            cursor.style.top = `${event.clientY - Math.max(top, 0)}px`;
            cursor.style.left = `${event.clientX - Math.max(left, 0)}px`;
        });
        element.addEventListener('mouseenter', ()=>{
            cursor.classList.remove('lg:hidden');
        });
        element.addEventListener('mouseleave', ()=>{
            cursor.classList.add('lg:hidden');
        });
        return {
            play: play,
            pause: pause
        };
    };
    const initVideos = ()=>{
        videoElements.forEach((element)=>{
            const video = element.querySelector('video');
            const thumbnail = document.querySelectorAll('.thumbnail--image');
            let isPlaying = false;
            const cursor = createVideoCursor(element);
            video.addEventListener('playing', ()=>{
                isPlaying = true;
            });
            video.addEventListener('pause', ()=>{
                isPlaying = false;
            });
            const play = ()=>{
                video.play();
                cursor.play.hidden = true;
                cursor.pause.hidden = false;
                thumbnail.forEach((el)=>{
                    el.classList.add('hidden');
                });
                video.classList.remove('hidden');
            };
            const pause = ()=>{
                video.pause();
                cursor.play.hidden = false;
                cursor.pause.hidden = true;
                thumbnail.forEach((el)=>{
                    el.classList.remove('hidden');
                });
                video.classList.add('hidden');
            };
            const toggle = ()=>{
                if (isPlaying) pause();
                else play();
            };
            element.addEventListener('click', toggle);
        });
    };
    const initVimeoElements = ()=>{
        vimeoElements.forEach((element)=>{
            const iframe = element.querySelector('iframe');
            const player = new (0, $91ff85a144d02ea6$export$2e2bcd8739ae039)(iframe);
            const cursor = createVideoCursor(element);
            const play = ()=>{
                player.play();
                cursor.play.hidden = true;
                cursor.pause.hidden = false;
            };
            const pause = ()=>{
                player.pause();
                cursor.play.hidden = false;
                cursor.pause.hidden = true;
            };
            const toggle = async ()=>{
                const isPaused = await player.getPaused();
                if (isPaused) play();
                else pause();
            };
            element.addEventListener('click', toggle);
            ctx.on('window:resize', async ()=>{
                const isPaused = await player.getPaused();
                if (!isPaused) pause();
            });
        });
    };
    const init = ()=>{
        initVideos();
        initVimeoElements();
    };
    /**
   * Init
   */ init();
});





var $f951053b947819a2$export$2e2bcd8739ae039 = (product)=>{
    const variant = product.variants[0];
    const tags = product.tags.split(',').map((tag)=>tag.trim());
    const getUrl = ()=>`/products/${product.handle}`;
    const getImages = ()=>{
        let markup = '';
        if (product.images[0]) markup += (0, $35e8efbb4fe4d154$export$2e2bcd8739ae039)(product.images[0], 0.8);
        if (product.images[1]) markup += (0, $35e8efbb4fe4d154$export$2e2bcd8739ae039)(product.images[1], 0.8);
        return markup;
    };
    const getLabel = ()=>{
        const labelTag = tags.find((tag)=>tag.includes('label_'));
        const labelValue = labelTag?.replace('label_', '') || null;
        const labelValueDowncased = labelValue?.toLowerCase() || null;
        let returnVal = '';
        if (labelValueDowncased === 'bestseller' || labelValueDowncased === 'new') returnVal = window.theme.strings.productItem[labelValueDowncased];
        else if (labelValue) returnVal = labelValue;
        return returnVal;
    };
    const getTitle = ()=>{
        let title = '';
        let hasThe = false;
        const splitTitle = product.title.split(' ');
        if (splitTitle[0].toLowerCase() === 'the') {
            hasThe = true;
            title = `<span class="the text-[0.75em] mr-[0.3em]">${splitTitle[0].slice(0, 1).toUpperCase()}${splitTitle[0].slice(1)}</span>`;
        }
        title += `<span class="font-semibold">${hasThe ? splitTitle.slice(1).join(' ') : product.title}</span>`;
        return title;
    };
    const getDetail = ()=>{
        const detailTag = tags.find((tag)=>tag.includes('detail-'));
        const detail = detailTag?.replace('detail-', '') || null;
        return detail ? `<p class="product-item__detail">${detail}</p>` : ''; // eslint-disable-line
    };
    const getCompareAtPrice = ()=>{
        let markup = '';
        if (parseInt(variant.compare_at_price, 10) > parseInt(variant.price, 10)) markup = `<del>${Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat)}</del>`;
        return markup;
    };
    const getPrice = ()=>`<span>${Shopify.formatMoney(variant.price, theme.moneyFormat)}</span>`;
    const getFits = ()=>{
        const fitOptionPosition = product.options.find((option)=>option.name.toLowerCase() === 'fit')?.position || null; // eslint-disable-line
        const fits = fitOptionPosition ? [
            ...new Set(product.variants.map((variant)=>variant[`option${fitOptionPosition}`]))
        ] : null; // eslint-disable-line
        return fits?.map((fit)=>`<li class="product-item__fit-item">${fit}</li>`).join('') || '';
    };
    return window.theme.templates.productItem.replaceAll('%url%', getUrl()).replaceAll('%productTitle%', product.title).replace('%images%', getImages()).replace('%label%', getLabel()).replace('%title%', getTitle()).replace('%detail%', getDetail()).replace('%compareAtPrice%', getCompareAtPrice()).replace('%price%', getPrice()).replace('%fits%', getFits());
};


var $5b12723247a1d1d4$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const output = node.querySelector('.js-output');
    const sliderElement = node.querySelector('.js-slider');
    /**
   * Functions
   */ const getProducts = ()=>new Promise((resolve)=>{
            const handles = localStorage.getItem('viewedProducts')?.split(',') || [];
            if (handles.length) {
                const fetches = handles.map((handle, index)=>fetch(`/products/${handle}.json`).then((response)=>{
                        if (response.status === 200) return response.json();
                        // If product has been removed from shop, remove it from localStorage as well
                        handles.splice(index, 1);
                        localStorage.setItem('viewedProducts', handles);
                        return null;
                    }).then((data)=>data?.product || null));
                Promise.all(fetches).then((data)=>{
                    // Only return actual data items (i.e. ones that are !== null)
                    resolve(data.filter((item)=>item));
                });
            } else resolve(handles);
        });
    const getMarkup = (products)=>products.map((product)=>`<li class="product-slider__item swiper-slide">
      ${(0, $f951053b947819a2$export$2e2bcd8739ae039)(product)}
    </li>`).join('');
    const init = async ()=>{
        const products = await getProducts();
        if (products.length) {
            output.innerHTML = getMarkup(products);
            (()=>new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(sliderElement, {
                    slidesPerView: 'auto',
                    grabCursor: true
                }))();
        } else node.remove();
    };
    /**
   * Init
   */ init();
});




var $77754c16dbdaa915$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)((node)=>{
    /**
   * Elements
   */ const sliderElement = node.querySelector('.js-slider');
    const sliderWrapper = node.querySelector('.js-sliderWrapper');
    /**
   * Functions
   */ const initSlider = ()=>{
        let slider;
        const reset = ()=>{
            if (slider?.destroy) slider.destroy();
            const isOverflowing = sliderElement.scrollWidth > sliderElement.getBoundingClientRect().width;
            sliderWrapper.classList[isOverflowing ? 'remove' : 'add']('justify-center');
            // TODO: Wait for https://github.com/nolimits4web/swiper/issues/5952 to get resolved.
            slider = new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(sliderElement, {
                modules: [
                    (0, $43bfed812a048812$export$2e2bcd8739ae039)
                ],
                slidesPerView: 2.5,
                spaceBetween: 35,
                speed: 8000,
                loop: true,
                centeredSlides: true,
                loopPreventsSlide: true,
                loopAdditionalSlides: 100,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false
                },
                breakpoints: {
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 50
                    },
                    1200: {
                        slidesPerView: 6,
                        spaceBetween: 75
                    }
                }
            });
        };
        reset();
        window.addEventListener('resize', reset);
    };
    const init = ()=>{
        initSlider();
    };
    init();
});







var $ebfc850aa40758b7$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Elements + data
   */ const closeBtns = node.querySelectorAll('.js-closeBtn');
    const submenus = node.querySelectorAll('.js-submenu');
    const submenuTriggers = node.querySelectorAll('.js-submenuTrigger');
    const submenuCloseBtns = node.querySelectorAll('.js-submenuCloseBtn');
    const colorSwatches = document.querySelectorAll('.color-swatch');
    const submenuTriggerActiveClass = 'menu__link--active';
    const submenuActiveClass = 'menu__submenu--active';
    /**
   * Functions
   */ const closeSubmenu = (submenu)=>{
        const trigger = Array.from(submenuTriggers).find((t)=>t.dataset.title === submenu.dataset.title);
        const indicator = trigger.querySelector('.js-indicator');
        trigger.classList.remove(submenuTriggerActiveClass);
        indicator.innerHTML = window.theme.templates.icons.plus;
        submenu.classList.remove(submenuActiveClass);
        const transitionDuration = parseFloat(getComputedStyle(submenu).getPropertyValue('transition-duration') || 0, 10);
        if (transitionDuration <= 0) submenu.hidden = true;
        else submenu.addEventListener('transitionend', ()=>{
            if (!submenu.classList.contains(submenuActiveClass)) submenu.hidden = true;
        }, {
            once: true
        });
    };
    const openSubmenu = (submenu)=>{
        const trigger = Array.from(submenuTriggers).find((t)=>t.dataset.title === submenu.dataset.title);
        const indicator = trigger.querySelector('.js-indicator');
        trigger.classList.remove(submenuTriggerActiveClass);
        indicator.innerHTML = window.theme.templates.icons.minus;
        trigger.classList.add(submenuTriggerActiveClass);
        submenus.forEach((s)=>{
            if (s !== submenu) closeSubmenu(s);
        });
        submenu.hidden = false;
        (0, $581e6c1bb6c96527$export$472761e5909fca2d)(submenu);
        submenu.classList.add(submenuActiveClass);
    };
    const toggleSubmenu = (submenu)=>{
        if (submenu.classList.contains(submenuActiveClass)) closeSubmenu(submenu);
        else openSubmenu(submenu);
    };
    const initDrawer = ()=>{
        const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(node);
        ctx.on('menu:open', ()=>{
            drawer.open();
            if (document.querySelector('header.header').classList.contains('header--megamenu-open')) document.querySelector('header.header').classList.remove('header--megamenu-open');
            document.querySelectorAll('.header__megamenu').forEach((el)=>{
                if (el.classList.contains('header__megamenu--active')) el.classList.remove('header__megamenu--active');
            });
            (0, $eddcbc136a01aca6$export$57bf213be019eeb0)();
        });
        const closeSubmenus = ()=>{
            submenus.forEach((submenu)=>{
                closeSubmenu(submenu);
            });
        };
        drawer.on('close', closeSubmenus);
        closeBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                closeSubmenus();
                drawer.close();
            });
        });
    };
    const initSubmenuTriggers = ()=>{
        submenuTriggers.forEach((trigger)=>{
            const submenu = Array.from(submenus).find((menu)=>menu.dataset.title === trigger.dataset.title);
            if (submenu) trigger.addEventListener('click', (event)=>{
                event.preventDefault();
                toggleSubmenu(submenu);
            });
        });
    };
    const initSubmenuCloseBtns = ()=>{
        submenuCloseBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const submenu = btn.closest('.js-submenu');
                toggleSubmenu(submenu);
            });
        });
    };
    const initColorSwatches = ()=>{
        colorSwatches.forEach((el, i, parent)=>{
            el.addEventListener('mouseover', (event)=>triggerColorSwatch(el, i, parent, event));
            el.addEventListener('mouseout', (event)=>colorSwatchAfterEffect(el, i, parent, event));
        });
    };
    const colorSwatchAfterEffect = (el, i, parent, event)=>{
        const currProductEl = el.closest(".nav-product__item");
        currProductEl.querySelector('[nav_product_item_image]').style.opacity = 1;
    };
    const triggerColorSwatch = (el, i, parent, event)=>{
        event.preventDefault();
        const currSwatchEl = el;
        const currHeaderMegaMenuEl = currSwatchEl.closest('.header__megamenu');
        let dataJsonArr = [];
        let currElementsArr = [];
        const currProductEls = currHeaderMegaMenuEl.querySelectorAll('.nav-product__item[default-product]');
        const currSwatchesWrapper = currSwatchEl.closest('.color-swatches__wrapper');
        currProductEls.forEach((el)=>{
            el.querySelector('[nav_product_item_image]').style.opacity = 0;
        });
        currSwatchesWrapper.querySelectorAll('div').forEach((el)=>el.classList.remove('current_tag'));
        currSwatchEl.classList.add('current_tag');
        const currDataTag = el.getAttribute("data-tag");
        const allCurrActiveSwatches = currHeaderMegaMenuEl.querySelectorAll(`[data-tag=${currDataTag}]`);
        allCurrActiveSwatches.forEach((el)=>{
            dataJsonArr.push(el.getAttribute('data-product-swatch'));
            currElementsArr.push(el);
        });
        try {
            // const dataJson = JSON.parse(getProductData); 
            currProductEls.forEach((currProductEl, index)=>{
                if (dataJsonArr[index] === undefined) {
                    currProductEl.classList.add('hidden');
                    return;
                }
                let currDataJson = JSON.parse(dataJsonArr[index]);
                let currElement = currElementsArr[index];
                // Updating image
                triggerImageUpdateFromByColorSwatch(currProductEl, currElement);
                // Updating price
                currProductEl.querySelector('[nav_product_item_price]').innerText = Shopify.formatMoney(currDataJson?.price, window.theme.moneyFormat);
                // Updating title
                triggerTitleUpdateFromByColorSwatch(currProductEl, currDataJson);
                // Updating handle 
                triggerHandleUpdateFromByColorSwatch(currProductEl, currDataJson);
                // Start color swatch flow
                triggerColorSwatchFlow(currSwatchEl, currHeaderMegaMenuEl, currDataJson);
            });
        } catch (ex) {
            console.log("error", ex);
        }
    };
    const triggerColorSwatchFlow = (currSwatchEl, currHeaderMegaMenuEl, dataJson)=>{
        const currColor = currSwatchEl.getAttribute('data-tag');
        triggerProductVisibility(currColor, currHeaderMegaMenuEl);
        triggerHeaderMenuImageFlow(currColor, currHeaderMegaMenuEl, dataJson);
        triggerHeaderMenuButtonFlow(currColor, currHeaderMegaMenuEl, dataJson);
        triggerHeaderMenuTextFlow(currColor, currHeaderMegaMenuEl, dataJson);
    };
    const triggerProductVisibility = (currColor, currHeaderMegaMenuEl)=>{
        const allVisibleProducts = currHeaderMegaMenuEl.querySelectorAll('li[product-color-type]');
        allVisibleProducts[0].setAttribute('product-color-type', currColor);
        allVisibleProducts.forEach(function(el) {
            if (currColor !== 'variant-white' && !el.hasAttribute('default-product')) el.classList.add('hidden');
            else el.classList.remove('hidden');
        });
    };
    const triggerHeaderMenuImageFlow = (currColor, currHeaderMegaMenuEl, dataJson)=>{
        let currMainImage = currHeaderMegaMenuEl.querySelector(`[mega_menu_main_img_wrapper] img.${currColor}`);
        const currActiveImg = currHeaderMegaMenuEl.querySelector('[mega_menu_main_img_wrapper] img.active-img');
        if (currActiveImg !== null) {
            currActiveImg.classList.add('hidden');
            currActiveImg.classList.remove('active-img');
        }
        if (currMainImage !== null) {
            currMainImage.classList.remove('hidden');
            currMainImage.classList.add('active-img');
        } else currHeaderMegaMenuEl.querySelectorAll('[mega_menu_main_img_wrapper] img').forEach((el)=>{
            el.classList.add('hidden');
        });
    };
    const triggerHeaderMenuButtonFlow = (currSwatchEl, currHeaderMegaMenuEl, dataJson)=>{
        let currBtn = currHeaderMegaMenuEl.querySelector(`[mega_menu_btn].active-btn`);
        let selectedBtn = currHeaderMegaMenuEl.querySelector(`[mega_menu_btn].${currSwatchEl}`);
        if (currBtn !== null) {
            currBtn.classList.add('hidden');
            currBtn.classList.remove('active-btn');
        }
        if (selectedBtn !== null) {
            selectedBtn.classList.remove('hidden');
            selectedBtn.classList.add('active-btn');
        } else currHeaderMegaMenuEl.querySelectorAll('[mega_menu_btn]').forEach((el)=>{
            el.classList.add('hidden');
        });
    };
    const triggerHeaderMenuTextFlow = (currSwatchEl, currHeaderMegaMenuEl, dataJson)=>{
        let currText = currHeaderMegaMenuEl.querySelector(`[mega_menu_text].active-text`);
        let selectedText = currHeaderMegaMenuEl.querySelector(`[mega_menu_text].${currSwatchEl}`);
        if (currText !== null) {
            currText.classList.add('hidden');
            currText.classList.remove('active-text');
        }
        if (selectedText !== null) {
            selectedText.classList.remove('hidden');
            selectedText.classList.add('active-text');
        } else currSwatchEl.querySelectorAll('[mega_menu_text]').forEach((el)=>{
            el.classList.add('hidden');
        });
    };
    const triggerImageUpdateFromByColorSwatch = (currProductEl, currSwatchEl)=>{
        if (currProductEl == null || currSwatchEl == null) return;
        const currProductImgWrapper = currProductEl.querySelector('[nav_product_item_image]');
        const currProductImg = currSwatchEl.querySelector('img');
        const currProductImgClonned = currProductImg.cloneNode(true);
        currProductImgClonned.classList.remove('hidden');
        currProductImgWrapper.querySelector('img').remove();
        currProductImgWrapper.append(currProductImgClonned);
        currProductEl.querySelector('[nav_product_item_image]').style.opacity = '1';
    };
    const triggerTitleUpdateFromByColorSwatch = (currProductEl, dataJson)=>{
        const productColorLabel = currProductEl.querySelector('[nav_product_item_title] > span');
        productColorLabel.classList.add("opacity-0");
        const title = dataJson.title;
        if (title.includes('|')) {
            const titleColor = title?.split('|')[1];
            if (titleColor === undefined) return;
            if (dataJson?.tags !== undefined) {
                const detail = dataJson.tags.find((el)=>el.includes('detail'));
                if (detail !== undefined) {
                    const productDetail = detail.split('-');
                    productColorLabel.innerText = productDetail[1];
                    productColorLabel.classList.remove("opacity-0");
                }
            }
        } else productColorLabel.classList.add("opacity-0");
    };
    const triggerHandleUpdateFromByColorSwatch = (currProductEl, dataJson)=>{
        const currProductLink = currProductEl.querySelector('a');
        currProductLink.setAttribute('href', `/products/${dataJson.handle}`);
    };
    const init = ()=>{
        (0, $c0bd171aae5be854$export$2e2bcd8739ae039)(()=>{
            initDrawer();
            initSubmenuTriggers();
            initSubmenuCloseBtns();
            initColorSwatches();
        });
    };
    /**
   * Init
   */ init();
});




var $91a51c535f1d37d2$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)((node)=>{
    if (!node) return;
    const sliderWrapper = node.querySelector('.swiper-wrapper');
    if (!sliderWrapper) return;
    const mobileMenuLoop = sliderWrapper.dataset.mobileMenuLoop === 'true';
    if (!mobileMenuLoop) return;
    const loopSpeedRaw = Number(sliderWrapper.dataset.mobileMenuLoopSpeed);
    const loopSpeed = !Number.isNaN(loopSpeedRaw) ? loopSpeedRaw * 1000 : 0;
    const isSliderOverflowing = node.scrollWidth > node.getBoundingClientRect().width;
    if (!isSliderOverflowing) return;
    let slider;
    let lastWidth = window.innerWidth;
    const THRESHOLD = 50;
    const initSlider = ()=>{
        const reset = ()=>{
            if (typeof slider !== 'undefined' && slider?.destroy) slider.destroy();
            sliderWrapper.classList[isSliderOverflowing ? 'remove' : 'add']('justify-center');
            slider = new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(node, {
                modules: [
                    (0, $43bfed812a048812$export$2e2bcd8739ae039)
                ],
                slidesPerView: 'auto',
                spaceBetween: 35,
                speed: loopSpeed,
                loop: true,
                centeredSlides: true,
                loopPreventsSlide: true,
                loopAdditionalSlides: 100,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: true,
                    reverseDirection: false
                },
                allowTouchMove: false
            });
        };
        const resizeHandler = ()=>{
            const currentWidth = window.innerWidth;
            if (Math.abs(currentWidth - lastWidth) >= THRESHOLD) {
                reset();
                lastWidth = currentWidth;
            }
        };
        reset();
        window.removeEventListener('resize', resizeHandler);
        window.addEventListener('resize', resizeHandler, {
            passive: true
        });
    };
    initSlider();
});



var $49a072da88f23a32$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const successMessage = node.querySelector('.js-successMessage');
    const config = JSON.parse(node.dataset.config);
    const { formSelector: formSelector } = config;
    const initForm = ()=>{
        const attachToForm = ()=>{
            window.KlaviyoSubscribe.attachToForms(formSelector, {
                hide_form_on_success: false,
                custom_success_message: true,
                success_message: successMessage
            });
        };
        if (window.KlaviyoSubscribe) attachToForm();
        else window.addEventListener('klaviyoSubscribe:loaded', attachToForm);
    };
    const init = ()=>{
        initForm();
    };
    /**
   * Init
   */ init();
});




var $bdb446488dab5a63$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const drawerElement = node.querySelector('.js-drawer');
    const drawerCloseBtn = node.querySelector('.js-closeBtn');
    const drawerBtn = node.querySelector('.js-drawerBtn');
    /**
   * Functions
   */ const initDrawer = ()=>{
        const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(drawerElement);
        drawerBtn?.addEventListener('click', (e)=>{
            e.preventDefault();
            drawer.open();
        });
        drawerCloseBtn.addEventListener('click', ()=>drawer.close());
    };
    const init = ()=>{
        initDrawer();
    };
    /**
   * Init
   */ init();
});




var $880c32aafadbcbeb$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const sliderElement = node.querySelector('.js-slider');
    const paginationElement = node.querySelector('.js-pagination');
    /**
   * Functions
   */ const initSlider = ()=>{
        (()=>new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(sliderElement, {
                modules: [
                    (0, $604711bfadd9afec$export$2e2bcd8739ae039)
                ],
                slidesPerView: 'auto',
                grabCursor: true,
                pagination: {
                    el: paginationElement,
                    type: 'bullets',
                    bulletClass: 'product-slider__pagination__bullet',
                    bulletActiveClass: 'product-slider__pagination__bullet--active'
                }
            }))();
    };
    const init = ()=>{
        initSlider();
    };
    /**
   * Init
   */ init();
});



var $2cf1c21f0a197c5b$export$2e2bcd8739ae039 = (obj, start, end, duration, format, currency, currencySuffix)=>{
    let startTimestamp = null;
    const step = (timestamp)=>{
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        let html = `${Math.floor(progress * (end - start) + start)}%`;
        if (format === 'money') html = Shopify.formatMoney(Math.floor(progress * (end * 100 - start) + start), theme.moneyFormat).toString().replace(currency, currencySuffix);
        obj.textContent = html;
        if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
};


var $808412f2d5cb9df2$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    const { apiKey: apiKey, spreadsheetId: spreadsheetId, currency: currency, currencySuffix: currencySuffix, range: range } = JSON.parse(node.querySelector('[data-config]').textContent);
    const fetchData = async ()=>{
        if (!apiKey || !spreadsheetId || !range) throw new Error('Missing config elements');
        const url = new URL(`https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${Object.values(range).join(':')}`);
        url.searchParams.append('key', apiKey);
        try {
            const response = await fetch(url.toString());
            const data = await response.json();
            return data.values[0];
        } catch (error) {
            throw new Error(error);
        }
    };
    const clamp = (num, min, max)=>Math.min(Math.max(num, min), max);
    const init = async ()=>{
        const [current, total] = await fetchData();
        const currentValue = parseInt(current, 10);
        const totalValue = parseInt(total, 10);
        const percentage = currentValue / totalValue * 100;
        const progressPercentage = clamp(percentage, 0, 100);
        const progressElement = node.querySelector('[data-progress]');
        const currentElement = progressElement.querySelector('[data-progress-current]');
        const goalElement = node.querySelector('[data-progress-goal]');
        const progressCountElement = node.querySelector('[data-progress-count]');
        const progressNumberElement = progressCountElement.querySelector('[data-progress-number]');
        if (progressPercentage < 25) currentElement.classList.add('right-aligned');
        if (progressPercentage < 5) currentElement.classList.add('extra-offset');
        document.addEventListener('readystatechange', ()=>{
            if (document.readyState === 'complete') {
                (0, $2cf1c21f0a197c5b$export$2e2bcd8739ae039)(currentElement, 0, current, 4000, 'money', currency, currencySuffix);
                (0, $2cf1c21f0a197c5b$export$2e2bcd8739ae039)(progressNumberElement, 0, progressPercentage, 4000);
                goalElement.textContent = Shopify.formatMoney(totalValue * 100, theme.moneyFormat).toString().replace(currency, currencySuffix);
                goalElement.style.opacity = progressPercentage > 85 ? '0' : '100';
                progressCountElement.style.opacity = '100';
                const distance = progressPercentage < 1 ? 9 : 13;
                progressCountElement.style.left = `calc(${progressPercentage}% - ${distance}px)`;
                progressElement.style.setProperty('--tw-translate-x', `${progressPercentage - 100}%`);
            }
        });
    };
    init();
});



var $4f6db326218ba88a$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)((node)=>{
    /**
   * Data + elements
   */ const shippingDateOutput = node.querySelector('.js-shippingDate');
    const config = JSON.parse(node.dataset.config);
    const { dailyShippingTime: dailyShippingTime, shippingDays: shippingDays, allowedWeekdays: allowedWeekdays, googleCalendarAPIKey: googleCalendarAPIKey, googleCalendarID: googleCalendarID, reverseDates: reverseDates } = config;
    const weekdayStrings = window.theme.strings.weekdays;
    /**
   * Functions
   */ const getGoogleData = ()=>new Promise((resolve)=>{
            window.gapi.load('client', ()=>{
                window.gapi.client.init({
                    apiKey: googleCalendarAPIKey,
                    discoveryDocs: [
                        'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'
                    ]
                }).then(()=>window.gapi.client.calendar.events.list({
                        calendarId: googleCalendarID,
                        singleEvents: true,
                        orderBy: 'startTime'
                    })).then((response)=>{
                    resolve(response.result.items);
                }).catch((error)=>{
                    console.error(error); // eslint-disable-line
                    resolve([]);
                });
            });
        });
    const setShippingDate = async ()=>{
        const googleData = await getGoogleData();
        const shippingDate = new Date();
        let daysAdded = 0;
        const getDatesBetween = (startDate, endDate)=>{
            const dates = [];
            let currentDate = startDate;
            while(currentDate <= endDate){
                dates.push(new Date(currentDate));
                currentDate = new Date(currentDate.valueOf());
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return dates;
        };
        const testDateAgainstCalendar = ()=>{
            const blockingItem = googleData.find((item)=>{
                const dates = getDatesBetween(new Date(item.start.dateTime), new Date(item.end.dateTime));
                return dates.find((date)=>date.toDateString() === shippingDate.toDateString());
            });
            return !blockingItem;
        };
        const tryAddDay = ()=>{
            shippingDate.setDate(shippingDate.getDate() + 1);
            if (allowedWeekdays.includes(shippingDate.getDay()) && testDateAgainstCalendar()) daysAdded += 1;
        };
        if (shippingDate.getHours() > dailyShippingTime || shippingDate.getHours === dailyShippingTime && shippingDate.getMinutes > 0) tryAddDay();
        while(daysAdded < shippingDays)tryAddDay();
        const date = shippingDate.getDate();
        const month = shippingDate.getMonth() + 1;
        const dateString = `${weekdayStrings[shippingDate.getDay()]} ${reverseDates ? month : date}/${reverseDates ? date : month}`; // eslint-disable-line
        shippingDateOutput.textContent = dateString;
    };
    const init = ()=>{
        if (window.gapi) setShippingDate();
        else window.addEventListener('googleApi:loaded', setShippingDate);
    };
    /**
   * Init
   */ init();
});



var $8fc32675a1894c88$export$2e2bcd8739ae039 = (btn, active)=>{
    btn.classList[active ? 'remove' : 'add']('animate-pulse');
    const icon = btn.querySelector('.icon');
    if (icon) icon.style.display = active ? '' : 'none';
    btn.querySelector('.load-ring').style.display = !active ? '' : 'none';
};



var $b1b880e41efce4f9$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)((node)=>{
    /**
   * Data + elements
   */ const addBtn = node.querySelector('.js-addBtn');
    const select = node.querySelector('.js-select');
    const { variantId: variantId } = node.dataset;
    /**
   * Functions
   */ if (addBtn) addBtn.addEventListener('click', ()=>{
        (0, $8fc32675a1894c88$export$2e2bcd8739ae039)(addBtn, false);
        (0, $92d139db6aba612b$export$509a42920845e675)({
            variantId: variantId,
            quantity: 1,
            callback: ()=>(0, $8fc32675a1894c88$export$2e2bcd8739ae039)(addBtn, true)
        });
    });
    if (select) {
        const label = node.querySelector('label');
        select.addEventListener('change', ()=>{
            select.classList.add('hidden');
            label.classList.remove('hidden');
            (0, $8fc32675a1894c88$export$2e2bcd8739ae039)(label, false);
            const { value: value } = select;
            (0, $92d139db6aba612b$export$509a42920845e675)({
                variantId: value,
                quantity: 1,
                callback: ()=>{
                    (0, $8fc32675a1894c88$export$2e2bcd8739ae039)(label, true);
                    label.classList.add('hidden');
                    select.classList.remove('hidden');
                }
            });
        });
    }
});


var $810790c606da41c6$exports = {};
const $810790c606da41c6$var$observer = new MutationObserver(()=>{
    const reviewLinks = document.querySelectorAll('.jdgm-rev__prod-link');
    if (reviewLinks.length) {
        for (const link of reviewLinks)link.removeAttribute('href');
        $810790c606da41c6$var$observer.disconnect(); // Stop observing once done
    }
});
$810790c606da41c6$var$observer.observe(document.body, {
    childList: true,
    subtree: true
});


const $86ccb4ff195e33b3$var$initGlobal = ()=>{
    (0, $0a3f002302d1a4d7$export$2e2bcd8739ae039)();
    (0, $09568495150d846b$export$2e2bcd8739ae039)();
};
(0, $c0bd171aae5be854$export$2e2bcd8739ae039)($86ccb4ff195e33b3$var$initGlobal);
const $86ccb4ff195e33b3$var$app = (0, $43e391a139e05df5$export$a69fbfbaf4cc7edc)({
    announcement: $fe0026821a8a8535$export$2e2bcd8739ae039,
    appearSection: $12b38cc5b301d542$export$2e2bcd8739ae039,
    backBtn: $a147a642930fb863$export$2e2bcd8739ae039,
    blogFeed: $b4e54990fb45238d$export$2e2bcd8739ae039,
    cartBtn: $17438218f14aff15$export$2e2bcd8739ae039,
    cartDrawer: $9333d437a18e3e69$export$2e2bcd8739ae039,
    cartItem: $7724971723f47526$export$2e2bcd8739ae039,
    chatBtn: $289c3358a13c9d74$export$2e2bcd8739ae039,
    columnDiagrams: $7e39c79985cdf900$export$2e2bcd8739ae039,
    countryBtn: $798fdc66f6c031c0$export$2e2bcd8739ae039,
    countrySelector: $b1391749b1fca322$export$2e2bcd8739ae039,
    featureElements: $cfdee5aa20126687$export$2e2bcd8739ae039,
    harmonicaItem: $93d350277d7ce459$export$2e2bcd8739ae039,
    horizontalDiagrams: $74a36c6e497ff295$export$2e2bcd8739ae039,
    header: $427233ecea647b2e$export$2e2bcd8739ae039,
    imageSlider: $9a08ee86f1eaef52$export$2e2bcd8739ae039,
    imageTabs: $d708a801dff12b59$export$2e2bcd8739ae039,
    largeMedia: $90ea2cfff976321f$export$2e2bcd8739ae039,
    lastViewedProducts: $5b12723247a1d1d4$export$2e2bcd8739ae039,
    logoSlider: $77754c16dbdaa915$export$2e2bcd8739ae039,
    menu: $ebfc850aa40758b7$export$2e2bcd8739ae039,
    menuSlider: $91a51c535f1d37d2$export$2e2bcd8739ae039,
    newsletter: $49a072da88f23a32$export$2e2bcd8739ae039,
    overlayDrawer: $bdb446488dab5a63$export$2e2bcd8739ae039,
    productSlider: $880c32aafadbcbeb$export$2e2bcd8739ae039,
    shippingDate: $4f6db326218ba88a$export$2e2bcd8739ae039,
    upsellItem: $b1b880e41efce4f9$export$2e2bcd8739ae039,
    progress: $808412f2d5cb9df2$export$2e2bcd8739ae039,
    campaignDrawer: $e77226b17f738052$export$2e2bcd8739ae039,
    JudgemeApp: (/*@__PURE__*/$parcel$interopDefault($810790c606da41c6$exports))
});
$86ccb4ff195e33b3$var$app.mount();
var $86ccb4ff195e33b3$export$2e2bcd8739ae039 = $86ccb4ff195e33b3$var$app;








var $c66c61209c4d8d2a$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const outputMobile = node.querySelector('.js-outputMobile');
    const outputDesktopOdd = node.querySelector('.js-outputDesktopOdd');
    const outputDesktopEven = node.querySelector('.js-outputDesktopEven');
    const submit = node.querySelector('button[type="submit"]');
    const resultCount = node.querySelector('.js-resultCount');
    const countOfTotal = node.querySelector('.js-countOfTotal');
    const loadMoreBtn = node.querySelector('.js-loadMoreBtn');
    const filterDrawer = node.querySelector('.js-filterDrawer');
    const filterDrawerBtns = node.querySelectorAll('.js-filterDrawerBtn');
    const filterBarScroll = node.querySelector('.js-filterBarScroll');
    const filterBarStatic = node.querySelector('.js-filterBarStatic');
    const filterBarActiveClass = 'collections__filter-bar--active';
    const filterBarHeaderActiveClass = 'collections__filter-bar--header-active';
    const { handle: currentHandle, pageSize: pageSize } = JSON.parse(node.querySelector('[data-config]').textContent);
    let data = {
        count: 0,
        articles: []
    };
    let currentPage = 1;
    const clamp = (num, min, max)=>Math.min(Math.max(num, min), max);
    const renderArticle = (index, article)=>{
        const itemMobile = document.createElement('li');
        outputMobile.appendChild(itemMobile);
        const itemDesktop = document.createElement('li');
        const indexIsOdd = (index + 1) % 2 !== 0;
        if (indexIsOdd) outputDesktopOdd.appendChild(itemDesktop);
        else outputDesktopEven.appendChild(itemDesktop);
        const markup = window.theme.templates.articleItem.replaceAll('%blogTitle%', article.blogTitle).replaceAll('%url%', article.url).replaceAll('%title%', article.title).replace('%image%', (0, $35e8efbb4fe4d154$export$2e2bcd8739ae039)(article.image)).replaceAll('%date%', article.date).replaceAll('%readingTime%', article.readingTime).replace('%author%', article.author);
        itemMobile.outerHTML = markup;
        itemDesktop.outerHTML = markup;
    };
    const updateCounts = (paginated)=>{
        const base = window.theme.strings.blog;
        if (resultCount) resultCount.textContent = base.viewResults.replace('%count%', data.count);
        countOfTotal.textContent = base.pagination.replace('%count%', paginated).replace('%total%', data.count);
    };
    const updateState = async ()=>{
        updateCounts(clamp(currentPage * pageSize, 0, data.count));
        if (data.count > pageSize) loadMoreBtn.hidden = false;
        else loadMoreBtn.hidden = true;
    };
    loadMoreBtn.addEventListener('click', ()=>{
        currentPage += 1;
        const render = data.articles.slice(pageSize * (currentPage - 1), clamp(pageSize * currentPage, 0, data.count));
        render.forEach((article, index)=>renderArticle(index, article));
        updateCounts(clamp(currentPage * pageSize, 0, data.count));
        if (pageSize * currentPage > data.count) loadMoreBtn.hidden = true;
    });
    const getArticles = async (categories)=>{
        if (!categories.length) return;
        data = {
            count: 0,
            articles: []
        };
        const promises = [];
        categories.forEach((category)=>{
            const promise = fetch(`/blogs/${category}?view=data`).then((response)=>response.json());
            promises.push(promise);
        });
        const results = await Promise.all(promises);
        results.forEach((result)=>{
            data.count += result.count;
            data.articles = [
                ...data.articles,
                ...result.articles
            ];
        });
        data.articles.sort((a, b)=>b.publishedAt - a.publishedAt);
        if (submit) submit.disabled = false;
    };
    const handleChange = async ()=>{
        const categories = new FormData(filterDrawer).getAll('category');
        const params = new URLSearchParams();
        categories.forEach((category)=>params.append('category', category));
        const url = `/blogs/${currentHandle}${categories.length ? `?${params.toString()}` : ''}`;
        window.history.replaceState({}, '', url);
        await getArticles(categories);
        updateState();
    };
    const handleSubmit = async (event)=>{
        const params = new URLSearchParams(window.location.search);
        const categories = params.getAll('category');
        event.preventDefault();
        currentPage = 1;
        if (!categories.length) return;
        (0, $581e6c1bb6c96527$export$42ffd38884aecdac)(outputMobile);
        (0, $581e6c1bb6c96527$export$42ffd38884aecdac)(outputDesktopOdd);
        (0, $581e6c1bb6c96527$export$42ffd38884aecdac)(outputDesktopEven);
        const render = data.articles.slice(pageSize * (currentPage - 1), clamp(pageSize * currentPage, 0, data.count));
        render.forEach((article, index)=>renderArticle(index, article));
        updateState();
    };
    if (filterDrawer) {
        filterDrawer.addEventListener('change', ()=>{
            submit.disabled = true;
            (0, (/*@__PURE__*/$parcel$interopDefault($a3d7992b95643302$exports)))(()=>handleChange(), 750)();
        });
        filterDrawer.addEventListener('submit', handleSubmit);
    }
    const initFilterDrawer = ()=>{
        const closeBtns = filterDrawer.querySelectorAll('.js-closeBtn');
        const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(filterDrawer);
        filterDrawerBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>drawer.open());
        });
        closeBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>drawer.close());
        });
    };
    let previousScrollPos = window.scrollY;
    const handleScroll = ()=>{
        let scrollingUp = false;
        const currentScrollPos = window.scrollY;
        if (currentScrollPos < previousScrollPos) scrollingUp = true;
        previousScrollPos = currentScrollPos;
        if (!filterBarStatic || !filterBarScroll) return;
        const scrolledPastFilterBarStatic = filterBarStatic.getBoundingClientRect().bottom < 0;
        if (scrolledPastFilterBarStatic) {
            filterBarScroll.classList.add(filterBarActiveClass);
            filterBarScroll.classList.add(filterBarHeaderActiveClass);
        } else {
            filterBarScroll.classList.remove(filterBarActiveClass);
            filterBarScroll.classList.remove(filterBarHeaderActiveClass);
        }
        if (scrollingUp && scrolledPastFilterBarStatic) filterBarScroll.classList.add(filterBarHeaderActiveClass);
    };
    const updateActiveItems = (categories)=>{
        const allCategories = filterDrawer.querySelectorAll('[name="category"]');
        const allCategoryNames = [
            ...allCategories
        ].map((category)=>category.value);
        const validCategories = allCategoryNames.filter((category)=>categories.includes(category));
        allCategories.forEach((category)=>{
            category.checked = false;
        });
        validCategories.forEach((category)=>{
            const item = filterDrawer.querySelector(`#category-${category}`);
            item.checked = true;
        });
    };
    const initFilter = async ()=>{
        const params = new URLSearchParams(window.location.search);
        let categories = params.getAll('category');
        if (!categories.length) {
            const checkedCategories = new FormData(filterDrawer).getAll('category');
            if (checkedCategories.length) categories = checkedCategories;
            else categories = [
                currentHandle
            ];
        }
        await getArticles(categories);
        updateActiveItems(categories);
        updateState();
        (0, $581e6c1bb6c96527$export$42ffd38884aecdac)(outputMobile);
        (0, $581e6c1bb6c96527$export$42ffd38884aecdac)(outputDesktopOdd);
        (0, $581e6c1bb6c96527$export$42ffd38884aecdac)(outputDesktopEven);
        const render = data.articles.slice(pageSize * (currentPage - 1), clamp(pageSize * currentPage, 0, data.count));
        render.forEach((article, index)=>renderArticle(index, article));
    };
    ctx.on('window:scroll', handleScroll);
    handleScroll();
    if (filterDrawer) initFilterDrawer();
    initFilter();
});


(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).add({
    blogArticles: $c66c61209c4d8d2a$export$2e2bcd8739ae039
});
(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).mount();






var $5eee263a8bf68bda$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const modelToggles = node.querySelectorAll(' .js-modelToggle');
    const productItems = node.querySelectorAll(' .js-productItem');
    const filterDrawer = node.querySelector(' .js-filterDrawer');
    const filterDrawerBtns = node.querySelectorAll('.js-filterDrawerBtn');
    const infoDrawers = node.querySelectorAll('.js-infoDrawer');
    const infoDrawerTriggers = node.querySelectorAll('.js-infoDrawerTrigger');
    const filterBarScroll = node.querySelector('.js-filterBarScroll');
    const filterBarStatic = node.querySelector('.js-filterBarStatic');
    const filters = node.querySelectorAll('.js-filter');
    const collectionItems = node.querySelectorAll('.js-collectionItem');
    const productListItems = node.querySelectorAll('.js-productListItem');
    const filterLists = node.querySelectorAll('.js-filterList');
    const clearFilterBtns = node.querySelectorAll('.js-clearFilterBtn');
    const resultCount = node.querySelector('.js-resultCount');
    const filterCounts = node.querySelectorAll('.js-filterCount');
    const filterDesktop = document.querySelector('.js-filterDesktop');
    const header = document.querySelector(".header");
    const sliderElement = node.querySelector('.collections__info-drawer .js-slider');
    const sliderPagination = node.querySelector('.collections__info-drawer .js-sliderPagination');
    const mediaSliderPrevBtn = node.querySelector('.collections__info-drawer .js-mediaSliderPrevBtn');
    const mediaSliderNextBtn = node.querySelector('.collections__info-drawer .js-mediaSliderNextBtn');
    const swiperWrapper = node.querySelector('.collections__info-drawer .swiper');
    const filterBarActiveClass = 'collections__filter-bar--active';
    const filterBarHeaderActiveClass = 'collections__filter-bar--header-active';
    const modelToggleActiveClass = 'collections__model-toggle--active';
    const productItemToggledClass = 'product-item--toggled';
    const strings = window.theme.strings.collection;
    let previousScrollPos = window.scrollY;
    let slider;
    /**
   * Functions
   */ const initSlider = ()=>{
        const reset = ()=>{
            if (slider?.destroy) slider.destroy();
            slider = new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(sliderElement, {
                modules: [
                    (0, $604711bfadd9afec$export$2e2bcd8739ae039),
                    (0, $a9e908ce9608037f$export$2e2bcd8739ae039)
                ],
                effect: 'coverflow',
                pagination: {
                    el: sliderPagination,
                    type: 'bullets',
                    bulletClass: 'image-slider__page-bullet',
                    bulletActiveClass: 'image-slider__page-bullet--active'
                },
                navigation: {
                    prevEl: mediaSliderPrevBtn,
                    nextEl: mediaSliderNextBtn
                },
                centeredSlides: true,
                slidesPerView: 'auto',
                speed: 1000,
                loop: true
            });
        };
        reset();
    };
    const initSliderArrows = ()=>{
        if (document.querySelector('.swiper-initialized')) {
            swiperWrapper?.addEventListener('mouseover', function(el) {
                mediaSliderNextBtn.style.transform = 'translateX(0)';
                mediaSliderPrevBtn.style.transform = 'translateX(0)';
            });
            swiperWrapper?.addEventListener('mouseout', function(el) {
                mediaSliderNextBtn.style.transform = 'translateX(28px)';
                mediaSliderPrevBtn.style.transform = 'translateX(-28px)';
            });
        }
    };
    const initFilters = ()=>{
        const clearFilterList = ()=>{
            const filterValues = node.querySelectorAll('.js-filterValueBtn');
            filterValues.forEach((value)=>value.remove());
        };
        const filterCollectionItems = (titles)=>{
            if (titles.length) {
                collectionItems.forEach((item)=>{
                    const { title: title } = JSON.parse(item.dataset.properties);
                    const products = item.querySelectorAll('.js-productItem');
                    if (titles.includes(title)) {
                        item.hidden = false;
                        products.forEach((product)=>{
                            product.hidden = false;
                        });
                    } else {
                        item.hidden = true;
                        products.forEach((product)=>{
                            product.hidden = true;
                        });
                    }
                });
                titles.forEach((title)=>{
                    filterLists.forEach((filterList)=>{
                        const button = document.createElement('button');
                        filterList.appendChild(button);
                        button.outerHTML = `<button type="button" class="collections__filter-value js-filterValueBtn" data-target="collection" data-property="title" data-value="${title}">
              <span>${title}</span>
              ${window.theme.templates.icons.closeSmall}
            </button>`;
                    });
                });
            } else collectionItems.forEach((item)=>{
                item.hidden = false;
                const products = item.querySelectorAll('.js-productItem');
                products.forEach((product)=>{
                    product.hidden = false;
                });
            });
        };
        const filterProductItems = (properties)=>{
            // Update filter counts
            filters.forEach((filter)=>{
                const { property: property } = filter.dataset;
                const count = filter.querySelector('.js-filterItemCount');
                if (!count) return;
                if (properties[property]) {
                    count.hidden = false;
                    count.innerText = `(${properties[property].length})`;
                } else {
                    count.hidden = true;
                    count.innerText = `(${0})`;
                }
            });
            // Update products items visibility
            if (Object.keys(properties).length) {
                // Create buttons
                Object.keys(properties).filter((key)=>key !== 'title' && key !== 'available').forEach((key)=>{
                    properties[key].forEach((value)=>{
                        filterLists.forEach((filterList)=>{
                            const button = document.createElement('button');
                            filterList.appendChild(button);
                            button.outerHTML = `<button type="button" class="collections__filter-value js-filterValueBtn" data-target="product" data-property="${key}" data-value="${value}">
                <span>${value}</span>
                ${window.theme.templates.icons.closeSmall}
              </button>`;
                        });
                    });
                });
                const optionKeys = [
                    ''
                ];
                const filteredProducts = [
                    ...productListItems
                ].filter((item)=>{
                    const itemPropertiesArray = JSON.parse(item.dataset.properties);
                    const itemPropertiesCombined = Object.assign({}, ...itemPropertiesArray);
                    const allMatches = Object.keys(properties).every((key)=>{
                        let newKey = key;
                        if (key === 'product_type') newKey = 'type';
                        else if (key === 'brand') newKey = 'vendor';
                        else if (key === 'shirt_type') newKey = 'model';
                        let requiredValues = properties[key];
                        if (requiredValues) requiredValues = requiredValues.map((value)=>value.toLowerCase());
                        let productValue = String(itemPropertiesCombined[newKey]);
                        productValue = productValue.toLowerCase();
                        if (newKey === 'size' && typeof productValue === 'string' || newKey === 'fit' && typeof productValue === 'string' || newKey === 'length' && typeof productValue === 'string') productValue = productValue.split(',').map((s)=>s.trim());
                        if (!Array.isArray(productValue)) productValue = [
                            productValue
                        ];
                        const hasOverlap = productValue.some((pValue)=>requiredValues.includes(pValue));
                        return hasOverlap;
                    });
                    return allMatches;
                });
                // eslint-disable-next-line
                productListItems.forEach((product)=>product.hidden = true);
                if (!Object.keys(properties).includes('available')) // eslint-disable-next-line
                filteredProducts.forEach((product)=>product.hidden = false);
                else {
                    // Exclude all but options when checking if in stock
                    const getProductEntries = Object.entries(properties).filter(([key])=>{
                        if (!optionKeys.includes(key)) return false;
                        return true;
                    });
                    const getProductValues = getProductEntries.map((arr)=>arr[1]);
                    // Can't create a variant yet
                    if (getProductValues.length <= 1) {
                        // eslint-disable-next-line
                        filteredProducts.forEach((product)=>product.hidden = false);
                        return;
                    }
                    // Setup all possible variant combinations based on filters (only works for 2 options)
                    const permutateArrays = (a, b)=>a.flatMap((c)=>b.map((d)=>[
                                    c,
                                    d
                                ].flat()));
                    const connect = (array)=>array.join(' / ');
                    const possibleVariants = getProductValues.reduce(permutateArrays).map(connect);
                    const checkAvailableProducts = filteredProducts.filter((product)=>{
                        const { title: title, color: color, variants: variants } = JSON.parse(product.dataset.properties);
                        // console.log('🚀 ~ title:', title, color);
                        if (Object.keys(properties).some((key)=>optionKeys.includes(key))) {
                            const hasAvailableVariants = variants.filter((variant)=>{
                                if (!variant.available) return false;
                                for (const possibleVariant of possibleVariants){
                                    const splittedPossibleVariants = possibleVariant.split(' / ');
                                    let isAvailable = true;
                                    for (const splittedPossibleVariant of splittedPossibleVariants)if (!variant.title.includes(splittedPossibleVariant)) isAvailable = false;
                                    if (isAvailable) return true;
                                }
                                return false;
                            });
                            if (hasAvailableVariants.length) return true;
                            return false;
                        }
                        return true;
                    });
                    // eslint-disable-next-line
                    checkAvailableProducts.forEach((product)=>product.hidden = false);
                }
            } else productListItems.forEach((item)=>{
                item.hidden = false;
            });
        };
        const initFilterValueBtns = ()=>{
            const btns = node.querySelectorAll('.js-filterValueBtn');
            btns.forEach((btn)=>{
                const { target: target, property: property, value: value } = btn.dataset;
                const filter = Array.from(filters).find((filter)=>filter.dataset.target === target && filter.dataset.property === property); // eslint-disable-line
                const matchingInput = Array.from(filter.querySelectorAll('.js-input')).find((input)=>input.dataset.value === value);
                btn.addEventListener('click', ()=>{
                    matchingInput.checked = false;
                    matchingInput.dispatchEvent(new Event('change'));
                });
            });
        };
        const toggleFilterList = ()=>{
            filterLists.forEach((filterList)=>{
                const filterValueBtns = filterList.querySelectorAll('.js-filterValueBtn');
                if (filterValueBtns.length) filterList.hidden = false;
                else filterList.hidden = true;
            });
        };
        const updateInfo = ()=>{
            const visibleProductItems = Array.from(productListItems).filter((item)=>item.offsetParent !== null); // eslint-disable-line
            resultCount.textContent = strings.viewResults.replace('%count%', visibleProductItems.length);
        };
        const getFilterProperties = ()=>{
            const collectionTitles = [];
            const productProperties = {};
            // Collect values
            filters.forEach((filter)=>{
                const { target: target } = filter.dataset;
                const activeInputs = Array.from(filter.querySelectorAll('.js-input')).filter((input)=>input.checked); // eslint-disable-line
                if (target === 'collection') {
                    const titles = activeInputs.map((input)=>input.dataset.value);
                    if (titles.length) collectionTitles.push(...titles);
                } else if (target === 'product') {
                    const { property: property } = filter.dataset;
                    const values = activeInputs.map((input)=>input.dataset.value);
                    if (values.length) productProperties[property] = values;
                }
            });
            return {
                collectionTitles: collectionTitles,
                productProperties: productProperties
            };
        };
        const updateURLParams = ()=>{
            const { collectionTitles: collectionTitles, productProperties: productProperties } = getFilterProperties();
            const dataset = {
                ...productProperties
            };
            if (collectionTitles.length) dataset.title = collectionTitles;
            const params = new URLSearchParams();
            Object.entries(dataset).forEach(([key, value])=>{
                params.set(key, value);
            });
            window.history.replaceState({}, '', `${window.location.pathname}${Object.keys(dataset).length ? `?${params.toString()}` : ''}`);
        };
        const readURLParams = ()=>{
            const params = new URLSearchParams(window.location.search);
            return Object.fromEntries(params);
        };
        const updateFilterStates = ()=>{
            const params = readURLParams();
            Object.values(params).forEach((values)=>{
                values.split(',').forEach((value)=>{
                    const input = document.querySelector(`.js-input[data-value="${value}"]`);
                    if (input) input.checked = true;
                });
            });
        };
        const updateValidFilterItems = ()=>{
            collectionItems.forEach((item)=>{
                const listItems = item.querySelectorAll('.js-productListItem');
                const allHidden = Array.from(listItems).every((listItem)=>listItem.hidden);
                if (allHidden) item.hidden = true;
            });
            filters.forEach((filter)=>{
                if (filter.dataset.property === 'available') return;
                const listItems = filter.querySelectorAll('li');
                const allHidden = Array.from(listItems).every((listItem)=>listItem.hidden);
                if (allHidden) filter.hidden = true;
                else filter.hidden = false;
            });
        };
        const runFilter = ()=>{
            const { collectionTitles: collectionTitles, productProperties: productProperties } = getFilterProperties();
            const totalCount = collectionTitles.length + Object.values(productProperties).length;
            filterCounts.forEach((filterCount)=>{
                filterCount.innerText = `(${totalCount})`;
                if (totalCount > 0) filterCount.hidden = false;
                else filterCount.hidden = true;
            });
            const dataset = {
                ...productProperties
            };
            if (collectionTitles.length) dataset.title = collectionTitles;
            clearFilterList();
            filterCollectionItems(collectionTitles);
            filterProductItems(dataset);
            updateValidFilterItems();
            initFilterValueBtns();
            toggleFilterList();
            updateInfo();
        };
        if (Object.values(readURLParams()).length) {
            updateFilterStates();
            runFilter();
        } else {
            runFilter();
            updateURLParams();
        }
        const clearFilter = ()=>{
            filters.forEach((filter)=>{
                const inputs = filter.querySelectorAll('.js-input');
                inputs.forEach((input)=>{
                    // Skip 'availability' filter, must not be reset
                    if (input.id === 'availability') return;
                    input.checked = false;
                });
            });
            runFilter();
            updateURLParams();
        };
        filters.forEach((filter)=>{
            const inputs = filter.querySelectorAll('.js-input');
            inputs.forEach((input)=>{
                input.addEventListener('change', ()=>{
                    runFilter();
                    updateURLParams();
                });
            });
        });
        clearFilterBtns.forEach((btn)=>{
            btn.addEventListener('click', clearFilter);
        });
    };
    const handleScroll = ()=>{
        let scrollingUp = false;
        const currentScrollPos = window.scrollY;
        const isDesktop = window.innerWidth >= 1024;
        if (currentScrollPos < previousScrollPos) scrollingUp = true;
        previousScrollPos = currentScrollPos;
        const scrolledPastFilterBarStatic = filterBarStatic.getBoundingClientRect().bottom < 0;
        if (scrolledPastFilterBarStatic) {
            filterBarScroll.classList.add(filterBarActiveClass);
            filterBarScroll.classList.add(filterBarHeaderActiveClass);
        } else {
            filterBarScroll.classList.remove(filterBarActiveClass);
            filterBarScroll.classList.remove(filterBarHeaderActiveClass);
        }
        if (scrollingUp && scrolledPastFilterBarStatic) filterBarScroll.classList.add(filterBarHeaderActiveClass);
        if (header && filterDesktop) {
            const headerHeight = header.offsetHeight;
            const filterBarTop = filterDesktop.getBoundingClientRect().top;
            if (filterBarTop <= headerHeight && isDesktop) filterDesktop.classList.add("sticky-filter");
            else filterDesktop.classList.remove("sticky-filter");
        }
    };
    const initModelToggle = ()=>{
        const toggleShowModel = ()=>{
            modelToggles.forEach((toggle)=>{
                toggle.classList.toggle(modelToggleActiveClass);
            });
            productItems.forEach((item)=>{
                let swiper = item.querySelector('.swiper') ? item.querySelector('.swiper').swiper : null;
                if (!swiper) return;
                if (modelToggles && typeof modelToggles == 'object' && modelToggles[0].classList.contains(modelToggleActiveClass)) swiper.slideTo(1);
                else swiper.slideTo(0);
            });
        };
        modelToggles.forEach((toggle)=>{
            toggle.addEventListener('click', ()=>toggleShowModel());
        });
    };
    const initFilterDrawer = ()=>{
        const closeBtns = filterDrawer.querySelectorAll('.js-closeBtn');
        const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(filterDrawer);
        filterDrawerBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>drawer.open());
        });
        closeBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>drawer.close());
        });
    };
    const initInfoDrawers = ()=>{
        infoDrawers.forEach((infoDrawer)=>{
            const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(infoDrawer);
            const closeBtn = infoDrawer.querySelector('.js-closeBtn');
            closeBtn.addEventListener('click', ()=>drawer.close());
            infoDrawerTriggers.forEach(function(infoDrawerTrigger) {
                infoDrawerTrigger.addEventListener('click', function() {
                    const currIndex = this.getAttribute('data-index');
                    const currId = this.getAttribute('data-id');
                    slider.slideTo(currIndex);
                    document.querySelectorAll(`.drawer__info [block-index]`).forEach((el)=>{
                        el.setAttribute('hidden', '');
                    });
                    document.querySelectorAll(`[block-index="${currIndex}"]`).forEach((el)=>{
                        el.removeAttribute('hidden');
                        if (el.classList.contains('fabric_description')) el.removeAttribute('hidden');
                    });
                    document.querySelectorAll(`[block-id="${currId}"]`).forEach((el)=>{
                        if (el.classList.contains('collections__info-drawer__fabric-item')) el.classList.add('font-semibold');
                    });
                    drawer.open();
                });
            });
        // closeBtn.addEventListener('click', () => drawer.close());
        });
    };
    const destroyInfoDrawers = ()=>{
        var observer = new MutationObserver(function(mutations) {
            // wait until drawer closes
            setTimeout(()=>{
                mutations.forEach(function(mutation) {
                    if (!mutation.target.classList.contains('overlay--active')) {
                        document.querySelectorAll('.drawer__header p').forEach(function(el) {
                            el.setAttribute('hidden', '');
                        });
                        document.querySelectorAll('p.fabric_description').forEach(function(el) {
                            el.setAttribute('hidden', '');
                        });
                        document.querySelectorAll('.collections__info-drawer__fabric-item').forEach(function(el) {
                            el.classList.remove('font-semibold');
                        });
                    }
                });
            }, 1000);
        });
        observer.observe(document.querySelector('.overlay'), {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
    };
    const init = ()=>{
        initFilters();
        initModelToggle();
        initFilterDrawer();
        initInfoDrawers();
        handleScroll();
        initSlider();
        initSliderArrows();
        destroyInfoDrawers();
        ctx.on('window:scroll', handleScroll);
    };
    /**
   * Init
   */ init();
});


(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).add({
    collectionsMain: $5eee263a8bf68bda$export$2e2bcd8739ae039
});
(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).mount();




var $a1ec5da3deb244bb$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const daysCount = node.querySelector('.js-daysCount');
    const hoursCount = node.querySelector('.js-hoursCount');
    const minutesCount = node.querySelector('.js-minutesCount');
    const secondsCount = node.querySelector('.js-secondsCount');
    const config = JSON.parse(node.dataset.config);
    /**
   * Functions
   */ const initCounter = ()=>{
        const { currentDateSource: currentDateSource, targetDateSource: targetDateSource } = config;
        const createDateFromSource = (source)=>{
            const [year, month, day, hours, minutes, seconds] = source.split('/');
            return new Date(year, month - 1, day, hours, minutes, seconds);
        };
        const currentDate = createDateFromSource(currentDateSource);
        const targetDate = createDateFromSource(targetDateSource);
        const oneDay = 86400000;
        const oneHour = 3600000;
        const oneMinute = 60000;
        const oneSecond = 1000;
        let interval;
        /* eslint-disable */ const update = ()=>{
            currentDate.setSeconds(currentDate.getSeconds() + 1);
            let timeDiff = targetDate.getTime() - currentDate.getTime();
            if (timeDiff < 0) return clearInterval(interval);
            const daysDiff = Math.floor(timeDiff / oneDay);
            timeDiff -= daysDiff * oneDay;
            const hoursDiff = Math.floor(timeDiff / oneHour);
            timeDiff -= hoursDiff * oneHour;
            const minutesDiff = Math.floor(timeDiff / oneMinute);
            timeDiff -= minutesDiff * oneMinute;
            const secondsDiff = Math.floor(timeDiff / oneSecond);
            daysCount.textContent = daysDiff;
            hoursCount.textContent = hoursDiff;
            minutesCount.textContent = minutesDiff;
            secondsCount.textContent = secondsDiff;
        };
        /* eslint-enable */ interval = setInterval(update, 1000);
    };
    const init = ()=>{
        if (config.showCounter) initCounter();
    };
    /**
   * Init
   */ init();
});



var $90967436c3c07c6d$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const signUpTitle = node.querySelector('#sign_up_title');
    const klaviyoEmailForm = node.querySelector('#klaviyo_email_form');
    const passwordWrapper = node.closest('[data-password-wrapper]');
    const mainElement = passwordWrapper?.closest('main');
    const passwordContentWrapper = mainElement?.querySelector('[data-password-content-wrapper]');
    const pagePasswordInput = node.querySelector('#page-password-input');
    const pagePasswordButton = node.querySelector('#page-password-button');
    /**
   * Functions
   */ const onPasswordInput = (input)=>{
        if (!pagePasswordInput && !pagePasswordButton) return;
        const password = input.value.trim();
        if (password.length === 0) return;
        try {
            localStorage.setItem('page-passwords', password);
            window.location.reload();
        } catch (error) {
            console.error('Failed to save to localStorage:', error);
        }
    };
    const displayKlaviyoEmailForm = ()=>{
        if (!signUpTitle && !klaviyoEmailForm) return;
        signUpTitle.addEventListener('click', function() {
            klaviyoEmailForm.classList.toggle('hidden');
            signUpTitle.classList.toggle('hidden');
        });
    };
    const checkPassword = ()=>{
        let password = localStorage.getItem('page-passwords') || '';
        if (theme.cacheId) {
            if (theme.cacheId === password) {
                passwordContentWrapper?.classList.remove('hidden');
                passwordWrapper?.classList.add('hidden');
            } else {
                passwordWrapper?.classList.remove('hidden');
                passwordContentWrapper?.classList.add('hidden');
            }
            localStorage.setItem('page-passwords', password);
        } else if (passwordWrapper) {
            passwordContentWrapper?.classList.remove('hidden');
            passwordWrapper?.classList.add('hidden');
        }
    };
    const submitPasswordForm = ()=>{
        if (!pagePasswordInput && !pagePasswordButton) return;
        pagePasswordButton.addEventListener('click', function() {
            onPasswordInput(pagePasswordInput);
        });
        pagePasswordInput.addEventListener('keypress', function(e) {
            if (e.keyCode == 13) onPasswordInput(pagePasswordInput);
        });
    };
    const init = ()=>{
        checkPassword();
        displayKlaviyoEmailForm();
        submitPasswordForm();
    };
    /**
   * Init
   */ init();
});


(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).add({
    passwordMain: $a1ec5da3deb244bb$export$2e2bcd8739ae039,
    passwordForm: $90967436c3c07c6d$export$2e2bcd8739ae039
});
(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).mount();






var $3f5e45515c698c07$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const price = node.querySelector('.js-price');
    const selectedDenomination = node.querySelector('.js-selectedDenomination');
    const denominationSelectionBtn = node.querySelector('.js-denominationSelectionBtn');
    const denominationDrawerElement = node.querySelector('.js-denominationDrawer');
    const denominationValueBtns = node.querySelectorAll('.js-denominationValueBtn');
    const denominationDrawerCloseBtn = node.querySelector('.js-denominationDrawerCloseBtn');
    const form = node.querySelector('.js-form');
    const variantSelect = node.querySelector('.js-variantSelect');
    const addToCartBtn = node.querySelector('.js-addToCartBtn');
    const productData = JSON.parse(node.querySelector('.js-productData').innerHTML);
    const config = JSON.parse(node.dataset.config);
    const { denominationOptionPosition: denominationOptionPosition } = config;
    /**
   * Functions
   */ const initVariantSelection = ()=>{
        const selectedVariantCallback = (variant)=>{
            price.textContent = Shopify.formatMoney(variant.price, theme.moneyFormat);
        };
        const createShopifySelection = ()=>new Shopify.OptionSelectors(`product-${productData.id}`, {
                product: productData,
                onVariantSelected: selectedVariantCallback,
                enableHistoryState: true
            });
        createShopifySelection();
    };
    const initOptionSelection = ()=>{
        const denominationDrawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(denominationDrawerElement);
        denominationSelectionBtn.addEventListener('click', ()=>denominationDrawer.open());
        denominationDrawerCloseBtn.addEventListener('click', ()=>denominationDrawer.close());
        const trueOptionSelectors = node.querySelectorAll('.single-option-selector');
        const trueDenominationSelector = Array.from(trueOptionSelectors).find((selector)=>parseInt(selector.dataset.option.replace('option', ''), 10) === denominationOptionPosition);
        const selectDenomination = (btn)=>{
            const { value: value } = btn.dataset;
            selectedDenomination.textContent = value;
            selectedDenomination.dataset.value = value;
            trueDenominationSelector.value = selectedDenomination.dataset.value;
            trueOptionSelectors.forEach((selector)=>selector.dispatchEvent(new Event('change')));
            addToCartBtn.disabled = false;
            denominationDrawer.close();
        };
        denominationValueBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>selectDenomination(btn));
        });
        const updateSelectionFromVariantParam = ()=>{
            const params = new URLSearchParams(window.location.search);
            const variantParam = parseInt(params.get('variant'), 10);
            if (variantParam) {
                const variant = productData.variants.find((v)=>v.id === variantParam);
                const denomination = variant[`option${denominationOptionPosition}`];
                const matchingDenominationValueBtn = Array.from(denominationValueBtns).find((btn)=>btn.dataset.value === denomination);
                matchingDenominationValueBtn.click();
            }
        };
        updateSelectionFromVariantParam();
    };
    const initForm = ()=>{
        const toggleButton = (active)=>{
            addToCartBtn.classList[active ? 'remove' : 'add']('animate-pulse');
            addToCartBtn.querySelector('.icon').style.display = active ? '' : 'none';
            addToCartBtn.querySelector('.load-ring').style.display = !active ? '' : 'none';
        };
        form.addEventListener('submit', (event)=>{
            event.preventDefault();
            toggleButton(false);
            const variantId = variantSelect.value;
            (0, $92d139db6aba612b$export$509a42920845e675)({
                variantId: variantId,
                quantity: 1,
                callback: ()=>toggleButton(true)
            });
        });
    };
    const init = ()=>{
        initVariantSelection();
        initOptionSelection();
        initForm();
    };
    /**
   * Init
   */ init();
});



function $7f076074b24c0325$export$ec068583843480e7(e, t, n) {
    void 0 === n && (n = {});
    var r = Object.assign({}, n, {
        g: e,
        email: t
    }), s = Object.keys(r).reduce(function(e, t) {
        return e.append(t, r[t]), e;
    }, new URLSearchParams);
    return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
        method: "POST",
        headers: {
            "Access-Control-Allow-Headers": "*",
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
        },
        body: s
    }).then(function(e) {
        return e.json();
    });
}


var $5b5d2fe0f5fc56a4$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    const submit = node.querySelector('button[data-submit]');
    const emailField = node.querySelector('input');
    const { list: list } = node.dataset;
    const closeButton = node.querySelectorAll('[data-close]');
    const toggle = document.querySelector('[data-preorder-btn]');
    const successMessage = node.querySelector('[data-success]');
    closeButton.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            node.hidden = true;
        });
    });
    toggle.addEventListener('click', ()=>{
        node.hidden = false;
    });
    const validateEmail = (email)=>email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    emailField.addEventListener('focus', ()=>{
        emailField.style.borderColor = null;
    });
    submit.addEventListener('click', ()=>{
        if (validateEmail(emailField.value)) (0, $7f076074b24c0325$export$ec068583843480e7)(list, emailField.value).then((response)=>{
            if (response.success) {
                emailField.hidden = true;
                submit.hidden = true;
                successMessage.hidden = false;
            }
        });
        else emailField.style.borderColor = '#dc2626';
    });
});




class $276f9add5caaafd0$var$Tabs {
    constructor(element, config = {}){
        this.tabBtns = element.querySelectorAll('.js-tabBtn');
        this.tabs = element.querySelectorAll('.js-tab');
        this.classes = {
            tabBtnActive: config.tabBtnActiveClass || '',
            tabActive: config.tabActiveClass || ''
        };
        this.initTabBtns();
    }
    initTabBtns() {
        this.tabBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                this.tabBtns.forEach((otherBtn)=>{
                    if (otherBtn === btn) otherBtn.classList.add(this.classes.tabBtnActive);
                    else otherBtn.classList.remove(this.classes.tabBtnActive);
                });
                const { name: name } = btn.dataset;
                this.tabs.forEach((tab)=>{
                    if (tab.dataset.name === name) {
                        tab.hidden = false;
                        tab.classList.add(this.classes.tabActive);
                    } else {
                        tab.classList.remove(this.classes.tabActive);
                        tab.hidden = true;
                    }
                });
            });
        });
    }
}
var $276f9add5caaafd0$export$2e2bcd8739ae039 = (element, config)=>new $276f9add5caaafd0$var$Tabs(element, config);


var $80e22efde2dd20ce$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const parent = node.closest('ul');
    const drawerBtns = parent.querySelectorAll('.js-drawerBtn');
    /**
   * Functions
   */ const initTabs = ()=>{
        const nodeHasTabs = node.dataset.hasTabs;
        if (nodeHasTabs === 'true' && nodeHasTabs !== null) {
            const wrapper = node.closest('div[product-info]');
            (0, $276f9add5caaafd0$export$2e2bcd8739ae039)(wrapper, {
                tabBtnActiveClass: 'product__info__tab-button--active',
                tabActiveClass: 'product__info__tab--active'
            });
        }
    };
    const initDrawers = ()=>{
        const { index: index } = node.dataset;
        const drawerBtn = Array.from(drawerBtns).find((btn)=>btn.dataset.index === index);
        const closeBtn = node.querySelector('.js-closeBtn');
        document.body.appendChild(node);
        const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(node);
        drawerBtn.addEventListener('click', ()=>drawer.open());
        closeBtn.addEventListener('click', ()=>drawer.close());
    };
    const init = ()=>{
        initTabs();
        initDrawers();
    };
    /**
   * Init
   */ init();
});




const $fc5893d610fe9a1f$export$2713eb811c6b742f = ()=>{
    document.documentElement.style.overflow = 'hidden';
};
const $fc5893d610fe9a1f$export$d4e6206aa3a55537 = ()=>{
    document.documentElement.style.overflow = '';
};
var $fc5893d610fe9a1f$export$2e2bcd8739ae039 = {
    fixRoot: $fc5893d610fe9a1f$export$2713eb811c6b742f,
    unfixRoot: $fc5893d610fe9a1f$export$d4e6206aa3a55537
};



var $90f38608414c3c9a$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const mediaItems = node.querySelectorAll('.js-mediaItem');
    const mediaSliderElement = node.querySelector('.js-mediaSlider');
    const allowTouchMove = !mediaSliderElement.closest('.swiper .swiper'); // If the slider is inside another swiper, disable touch move
    const mediaSliderPrevBtn = node.querySelector('.js-mediaSliderPrevBtn');
    const mediaSliderNextBtn = node.querySelector('.js-mediaSliderNextBtn');
    const mediaSliderCount = node.querySelector('.js-mediaSliderCount');
    const mediaSliderPagination = node.querySelector('.js-mediaSliderPagination');
    const lightboxElement = node.querySelector('.js-lightbox');
    const lightboxSliderElement = node.querySelector('.js-lightboxSlider');
    const lightboxSliderCount = node.querySelector('.js-lightboxSliderCount');
    const lightboxSliderPrevBtn = node.querySelector('.js-lightboxSliderPrevBtn');
    const lightboxSliderNextBtn = node.querySelector('.js-lightboxSliderNextBtn');
    const lightboxMediaItems = node.querySelectorAll('.js-lightboxMediaItem');
    const lightboxDesktopNavItems = node.querySelectorAll('.js-lightboxDesktopNavItem');
    const lightboxCloseBtns = node.querySelectorAll('.js-lightboxCloseBtn');
    /**
   * Functions
   */ const openLightbox = (lightbox, slider, index = 0)=>{
        lightbox.open();
        slider.slideTo(index);
        (0, $fc5893d610fe9a1f$export$2713eb811c6b742f)();
    };
    const closeLightbox = (lightbox)=>{
        lightbox.close();
        (0, $fc5893d610fe9a1f$export$d4e6206aa3a55537)();
    };
    const createMediaSlider = ()=>(()=>new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(mediaSliderElement, {
                modules: [
                    (0, $a9e908ce9608037f$export$2e2bcd8739ae039),
                    (0, $604711bfadd9afec$export$2e2bcd8739ae039)
                ],
                slidesPerView: 'auto',
                allowTouchMove: allowTouchMove,
                navigation: {
                    prevEl: mediaSliderPrevBtn,
                    nextEl: mediaSliderNextBtn
                },
                pagination: {
                    el: mediaSliderPagination,
                    type: 'bullets',
                    bulletClass: 'product__media-slider__page-bullet',
                    bulletActiveClass: 'product__media-slider__page-bullet--active'
                },
                on: {
                    slideChange: (data)=>{
                        mediaSliderCount.textContent = data.activeIndex + 1;
                    }
                }
            }))();
    const createLightboxSlider = ()=>new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(lightboxSliderElement, {
            modules: [
                (0, $a9e908ce9608037f$export$2e2bcd8739ae039)
            ],
            slidesPerView: 'auto',
            navigation: {
                prevEl: lightboxSliderPrevBtn,
                nextEl: lightboxSliderNextBtn
            },
            on: {
                slideChange: (data)=>{
                    lightboxSliderCount.textContent = data.activeIndex + 1;
                    lightboxDesktopNavItems.forEach((item)=>{
                        if (parseInt(item.dataset.index, 10) === data.activeIndex) item.classList.add('product__lightbox__nav-item--active');
                        else item.classList.remove('product__lightbox__nav-item--active');
                    });
                }
            }
        });
    const initLightboxZoom = ()=>{
        lightboxMediaItems.forEach((item)=>{
            const mediaElement = item.querySelector('img,video');
            const cursor = item.querySelector('.js-lightboxCursor');
            mediaElement.addEventListener('mousemove', (event)=>{
                const { top: top } = mediaElement.getBoundingClientRect();
                cursor.style.top = `${event.clientY - Math.max(top, 0)}px`;
                cursor.style.left = `${event.clientX}px`;
            });
            mediaElement.addEventListener('mouseenter', ()=>{
                cursor.hidden = false;
            });
            mediaElement.addEventListener('mouseout', ()=>{
                cursor.hidden = true;
            });
            mediaElement.addEventListener('click', ()=>{
                item.classList.toggle('product__lightbox__media-item--zoomed');
            });
        });
    };
    const init = ()=>{
        createMediaSlider();
        const lightbox = (0, $9eb1f8cc1de8b697$export$2e2bcd8739ae039)(lightboxElement);
        const lightboxSlider = createLightboxSlider();
        mediaItems.forEach((item)=>{
            const index = parseInt(item.dataset.index, 10);
            item.addEventListener('click', ()=>{
                openLightbox(lightbox, lightboxSlider, index);
            });
        });
        lightboxDesktopNavItems.forEach((item)=>{
            const { index: index } = item.dataset;
            item.addEventListener('click', ()=>{
                lightboxSlider.slideTo(index);
            });
        });
        lightboxCloseBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>closeLightbox(lightbox));
        });
        initLightboxZoom();
    };
    /**
   * Init
   */ init();
});




var $c7539826986ca6c3$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    const drawerBtn = node.querySelector('.js-drawerBtn');
    const drawerElement = node.querySelector('.js-drawer');
    const closeBtn = drawerElement.querySelector('.js-closeBtn');
    const init = ()=>{
        document.body.appendChild(drawerElement);
        const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(drawerElement);
        drawerBtn.addEventListener('click', ()=>drawer.open());
        closeBtn.addEventListener('click', ()=>drawer.close());
    };
    init();
});





const $4ed1f457e1358e22$export$53a29ee4f7f84d31 = (string)=>{
    const parts = string.toLowerCase().split(' ').map((part)=>part.trim());
    return parts.join('-');
};
 // eslint-disable-line




var $52b17377c08e80fe$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node, ctx)=>{
    /**
   * Data + elements
   */ const BIS = node.querySelectorAll('.js-klaviyoBIS');
    const brandSizeTableSelect = node.querySelector('.js-brandSizeTableSelect');
    const brandSizeTables = node.querySelectorAll('.js-brandSizeTable');
    const compareAtPrice = node.querySelector('.js-compareAtPrice');
    const fitInfoBtn = node.querySelector('.js-fitInfoBtn');
    const fitInfoContainer = node.querySelector('.js-fitInfoContainer');
    const fitSelectionBtn = node.querySelector('.js-fitSelectionBtn');
    const fitSizeAddToCartBtn = node.querySelector('.js-fitSizeAddToCartBtn');
    const fitSizeSelectionBtn = node.querySelector('.js-fitSizeSelectionBtn');
    const fitSizeSelectionDrawer = node.querySelector('.js-fitSizeSelectionDrawer');
    const fitSizeSelectionDrawerCloseBtn = node.querySelector('.js-fitSizeSelectionDrawerCloseBtn');
    const fitValueBtns = node.querySelectorAll('.js-fitValueBtn');
    const form = node.querySelector('.js-form');
    const formAddToCartBtn = node.querySelector('.js-formAddToCartBtn');
    const lengthSelectionContainer = node.querySelector('.js-lengthSelectionContainer');
    const lengthValueBtns = node.querySelectorAll('.js-lengthValueBtn');
    const lengthValueBtnList = node.querySelectorAll('.js-lengthValueBtnListItem');
    const lengthValueTexts = node.querySelectorAll('.js-lengthValueText');
    const mouseOverChange = node.querySelectorAll('.js-mouseOverChange');
    const linkVariantName = node.querySelector('.js-linkVariantName');
    const mobileCta = node.querySelector('.js-mobileCta');
    const price = node.querySelector('.js-price');
    const redirectGen = node.querySelector('.js-RedirectGen');
    const reselectFlow = node.querySelector('.js-reselectFlow');
    const selectedFit = node.querySelector('.js-selectedFit');
    const selectedFitAndSize = node.querySelector('.js-selectedFitAndSize');
    const sizeGuideAddToCartBtns = node.querySelectorAll('.js-sizeGuideAddToCartBtn');
    const sizeGuideBtns = node.querySelectorAll('.js-sizeGuideBtn');
    const sizeGuideDrawer = node.querySelector('.js-sizeGuideDrawer');
    const sizeGuideDrawerCloseBtn = node.querySelector('.js-sizeGuideDrawerCloseBtn');
    const sizeGuideFitGroups = node.querySelectorAll('.js-sizeGuideFitGroup');
    const sizeGuideFitSelect = node.querySelector('.js-sizeGuideFitSelect');
    const sizeGuideTooltipBtns = node.querySelectorAll('.js-sizeGuideTooltipBtn');
    const sizeGuideTooltips = node.querySelectorAll('.js-sizeGuideTooltip');
    const storeTooltipsBtns = node.querySelectorAll('.js-storeTooltipBtn');
    const storeTooltips = node.querySelectorAll('.js-storeTooltip');
    const sizeSelectionBtn = node.querySelector('.js-sizeSelectionBtn');
    const sizeSelectionContainer = node.querySelector('.js-sizeSelectionContainer');
    const sizeSelectionList = node.querySelector('.js-sizeSelectionList');
    const stockInfo = node.querySelectorAll('.js-stockInfo');
    const stockInfoPickup = node.querySelectorAll('.js-stockInfo-pickup');
    const thumbnailBtns = node.querySelectorAll('.js-thumbnailBtn');
    const thumbnailDrawer = node.querySelector('.js-thumbnailDrawer');
    const thumbnailDrawerCloseBtn = node.querySelector('.js-thumbnailDrawerCloseBtn');
    const variantSelect = node.querySelector('.js-variantSelect');
    const productData = JSON.parse(node.querySelector('.js-productData').innerHTML);
    const variantData = JSON.parse(node.querySelector('.js-variantData').innerHTML);
    const config = JSON.parse(node.dataset.config);
    const { fitOptionPosition: fitOptionPosition, sizeOptionPosition: sizeOptionPosition, lengthOptionPosition: lengthOptionPosition, stockWarningLimit: stockWarningLimit, collectionHandle: collectionHandle, lengthOptionDefault: lengthOptionDefault, isProductEvent: isProductEvent, prelaunch: prelaunch } = config;
    const strings = window.theme.strings.product;
    const updateBackInStock = ({ available: available })=>{
        if (!BIS) return false;
        BIS.forEach((btn)=>{
            btn.hidden = available;
        });
        return true;
    };
    const updateAddToCartBtn = (variant)=>{
        const { available: available } = variant;
        if (new URLSearchParams(window.location.search).get('variant')) {
            // formAddToCartBtn.disabled = !available;
            fitSizeAddToCartBtn.disabled = !available;
            fitSizeAddToCartBtn.hidden = !available;
        } else {
            fitSizeAddToCartBtn.disabled = true;
            fitSizeAddToCartBtn.hidden = true;
        }
    };
    const findGen = (string, type)=>string.split(':')[0] === type.split(':')[0];
    const arrayIsEqual = (a, b)=>a.every((item)=>b.includes(item)) && b.every((item)=>a.includes(item));
    const findMatchingVariant = (data, variant, type)=>{
        let matchingVariant = false;
        const { options: options } = variant;
        const typeMatch = data.filter((item)=>item.handle !== productData.handle && findGen(item.tag, type));
        const findVariantItem = typeMatch.find((item)=>item.variants.filter((v)=>arrayIsEqual(v.options, options)));
        // eslint-disable-next-line no-shadow,consistent-return
        findVariantItem.variants.forEach((variant)=>{
            if (variant.available && arrayIsEqual(variant.options, options)) {
                matchingVariant = variant;
                return false;
            }
        });
        return matchingVariant;
    };
    const fetchData = async ()=>{
        const url = new URL(window.theme.routes.collectionsAll, window.location.origin);
        url.searchParams.set('view', 'data');
        return fetch(url.toString(), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>response.json()).then((data)=>data);
    };
    const updateRedirectGen = (variant)=>{
        const { available: available } = variant;
        if (available) {
            redirectGen.hidden = true;
            return;
        }
        const { type: type } = redirectGen.dataset;
        if (sessionStorage.getItem('redirectGen')) {
            const redirectGenParse = JSON.parse(sessionStorage.getItem('redirectGen'));
            const url = findMatchingVariant(redirectGenParse, variant, type);
            if (url) {
                redirectGen.href = url.url;
                redirectGen.hidden = false;
            } else redirectGen.hidden = true;
        } else fetchData().then((data)=>{
            sessionStorage.setItem('redirectGen', JSON.stringify(data));
            const url = findMatchingVariant(data, variant, type);
            if (url) {
                redirectGen.href = url.url;
                redirectGen.hidden = false;
            } else redirectGen.hidden = true;
        });
    };
    /**
   * Functions
   */ const displayFitInfo = ()=>{
        fitInfoContainer.classList.toggle('product__fit-info--active');
    };
    const initSwatches = ()=>{
        mouseOverChange.forEach((swatch)=>{
            // Show swatch title on mouse enter
            swatch.addEventListener('mouseenter', ()=>{
                const { name: name } = swatch.dataset;
                linkVariantName.textContent = name;
            });
            // Switch back to current title on mouse leave
            swatch.addEventListener('mouseleave', ()=>{
                linkVariantName.textContent = linkVariantName.dataset.initialName;
            });
        });
    };
    const getVariantInventoryQuantity = (variant)=>{
        if (variant.inventory_quantity) return variant.inventory_quantity;
        const { inventoryQuantity: inventoryQuantity } = variantData.find((v)=>v.id === variant.id);
        return inventoryQuantity;
    };
    const updateStockInfo = (variant, inventory)=>{
        let pickupStoreLevel, onlineStoreLevel;
        let onlyOneStore = false;
        inventory.forEach((inventoryVariant)=>{
            if (inventoryVariant.id.includes(variant.id)) {
                const warehouseInventory = inventoryVariant?.inventory_quantities?.find((i)=>i.name.includes("Warehouse"));
                onlineStoreLevel = warehouseInventory?.level;
                if (inventoryVariant.inventory_quantities.length == 1) onlyOneStore = true;
                else {
                    const pickupInventory = inventoryVariant?.inventory_quantities?.find((i)=>i.name.includes("Pilestr\xe6de"));
                    pickupStoreLevel = pickupInventory?.level;
                }
            }
        });
        replaceAvailabilityText(stockInfo, onlineStoreLevel, strings, false); // online store
        if (onlyOneStore) {
            stockInfoPickup.forEach((stockInfoNode)=>{
                stockInfoNode.style.display = "none";
            });
            return;
        }
        stockInfoPickup.forEach((stockInfoNode)=>{
            if (!pickupStoreLevel) stockInfoNode.classList.add("hidden");
            else stockInfoNode.classList.remove("hidden");
        });
        const availabilityStrings = {
            inStock: strings.inStockStore,
            soldOut: strings.soldOutStore,
            stockWarning: strings.stockWarningStore
        };
        replaceAvailabilityText(stockInfoPickup, pickupStoreLevel, availabilityStrings, true);
        function replaceAvailabilityText(container, inventoryQuantity, availabilityStrings, useSpan) {
            const soldOut = inventoryQuantity <= 0;
            const warn = inventoryQuantity <= stockWarningLimit;
            container.forEach((info)=>{
                if (soldOut) {
                    info.classList.remove('text-orange', 'text-green');
                    info.classList.add('text-red');
                } else {
                    info.classList.remove('text-red');
                    info.classList[warn ? 'add' : 'remove']('text-orange');
                    info.classList[warn ? 'remove' : 'add']('text-green');
                }
                let text = availabilityStrings.inStock;
                if (soldOut) text = availabilityStrings.soldOut;
                else if (warn) text = availabilityStrings.stockWarning.replace('%quantity%', inventoryQuantity);
                let infoText = info;
                if (useSpan) infoText = info.querySelector("span");
                infoText.innerHTML = `<div class="w-[14px] h-[14px] rounded-full bg-current"></div>
          <p class="text-black stock-text">${text}</p>`;
            });
        }
    };
    async function getInventory(productData) {
        const storeLang = window.theme.storeUrl.split('.')[window.theme.storeUrl.split('.').length - 1];
        const storeMap = {
            'se': 'barons-swe',
            'nl': 'barons-nl',
            'no': 'barons-no',
            'dk': 'barons-dk',
            'com': 'barons-dk'
        };
        const productId = productData.id;
        const variantCount = productData.variants.length;
        const inventoryEndpoint = `https://netlify.blacklemon.dk/.netlify/functions/getProductInventoryLevels?store=${storeMap[storeLang]}&prodId=${productId}&variantCount=${variantCount}`;
        try {
            const inventory = await fetch(inventoryEndpoint);
            const inventoryData = await inventory.json();
            return inventoryData;
        } catch (error) {
            console.error('Error fetching inventory', error);
        }
    }
    async function initVariantSelection() {
        const inventory = await getInventory(productData);
        const selectedVariantCallback = (variant)=>{
            if (variant) {
                if (compareAtPrice) {
                    if (variant.compare_at_price > variant.price) compareAtPrice.textContent = Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat); // eslint-disable-line
                    else compareAtPrice.textContent = '';
                }
                price.textContent = Shopify.formatMoney(variant.price, theme.moneyFormat);
                updateAddToCartBtn(variant);
                updateBackInStock(variant);
                const variantURL = new URLSearchParams(window.location.search).get('variant');
                if (variantURL) updateStockInfo(variant, inventory);
                if (redirectGen) updateRedirectGen(variant);
            }
        };
        const createShopifySelection = ()=>new Shopify.OptionSelectors(`product-${productData.id}`, {
                product: productData,
                onVariantSelected: selectedVariantCallback,
                enableHistoryState: true
            });
        createShopifySelection();
    }
    const initOptionSelection = ()=>{
        // Append drawer to body to reset z-index and position
        document.body.appendChild(fitSizeSelectionDrawer);
        const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(fitSizeSelectionDrawer);
        fitSizeSelectionBtn.addEventListener('click', ()=>drawer.open());
        fitSizeSelectionDrawerCloseBtn.addEventListener('click', ()=>drawer.close());
        sizeGuideBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>drawer.close());
        });
        const trueOptionSelectors = node.querySelectorAll('.single-option-selector');
        const trueFitSelector = Array.from(trueOptionSelectors).find((selector)=>parseInt(selector.dataset.option.replace('option', ''), 10) === fitOptionPosition);
        const trueSizeSelector = Array.from(trueOptionSelectors).find((selector)=>parseInt(selector.dataset.option.replace('option', ''), 10) === sizeOptionPosition);
        const trueLengthSelector = Array.from(trueOptionSelectors).find((selector)=>parseInt(selector.dataset.option.replace('option', ''), 10) === lengthOptionPosition);
        // Handle fit change to update available sizes and lengths
        if (trueFitSelector) trueFitSelector.addEventListener('change', ()=>{
            // Show length selection if the new fit has multiple lengths
            if (trueLengthSelector) {
                const hasMultipleLengths = new Set(fitVariants.map((v)=>v[`option${lengthOptionPosition}`])).size > 1;
                if (hasMultipleLengths) lengthSelectionContainer.classList.remove('hidden');
                else {
                    lengthSelectionContainer.classList.add('hidden');
                    // set length to standard if only one length option
                    trueLengthSelector.value = "Standard";
                    localStorage.setItem('selectedLength', 'Standard');
                    trueLengthSelector.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
            }
        });
        const selectSize = (btn)=>{
            const { value: value } = btn.dataset;
            trueSizeSelector.value = value;
            trueOptionSelectors.forEach((selector)=>selector.dispatchEvent(new Event('change', {
                    bubbles: true
                })));
            const sizeValueBtns = sizeSelectionList.querySelectorAll('.js-sizeValueBtn');
            sizeValueBtns.forEach((sizeValueBtn)=>{
                sizeValueBtn.classList[sizeValueBtn === btn ? 'add' : 'remove']('product__size-value-button--active');
            });
            selectedFitAndSize.textContent = `${trueFitSelector.value} ${trueSizeSelector.value} ${trueLengthSelector ? trueLengthSelector.value : ''}`;
            localStorage.setItem('selectedSize', value);
        };
        const updateSizeSelection = ()=>{
            const selectedFitValue = trueFitSelector.value;
            let matchingVariants = [];
            // First get all variants for the selected fit
            const fitVariants1 = window.theme.hasFit ? productData.variants.filter((variant)=>variant[`option${fitOptionPosition}`] === selectedFitValue) : productData.variants;
            // Check if the fit has multiple lengths
            const hasMultipleLengths = new Set(fitVariants1.map((v)=>v[`option${lengthOptionPosition}`])).size > 1;
            if (trueLengthSelector && hasMultipleLengths) {
                const selectedLengthValue = trueLengthSelector.value;
                matchingVariants = fitVariants1.filter((variant)=>variant[`option${lengthOptionPosition}`] === selectedLengthValue);
            } else // If no length selector or fit doesn't have multiple lengths, use all variants for the fit
            matchingVariants = fitVariants1;
            const uniqueMatchingVariants = [
                ...new Map(matchingVariants.map((item)=>[
                        item[`option${sizeOptionPosition}`],
                        item
                    ])).values()
            ];
            const currVariant = new URLSearchParams(window.location.search).get('variant') || '';
            let isDefaultVariantSelected = false;
            sizeSelectionList.innerHTML = uniqueMatchingVariants.map((variant, index)=>{
                const { inventoryQuantity: inventoryQuantity } = variantData.find((v)=>v.id === variant.id);
                const borderClass = index < uniqueMatchingVariants.length - 1 ? 'border-b border-grey-200' : '';
                const colorClass = !variant.available ? 'text-grey-200' : '';
                const sizeClass = !variant.available ? 'line-through' : '';
                const activeClass = 'product__size-value-button--active';
                const currentClass = variant.id.toString() === currVariant ? activeClass : '';
                let isDefaultAvailVariant = false;
                isDefaultAvailVariant = false;
                isDefaultVariantSelected = false;
                return `<li class="${borderClass} ${colorClass}">
          <button type="button" class="product__size-value-button js-sizeValueBtn ${isDefaultAvailVariant ? activeClass : currentClass}" data-value="${variant[`option${sizeOptionPosition}`]}" data-quantity="${inventoryQuantity}">
            <span class="${sizeClass}">${variant[`option${sizeOptionPosition}`]}</span>
            ${(()=>{
                    if (inventoryQuantity <= 0) return `<span class="product__size-value-button__stock-info font-normal text-grey-500">${strings.getNotified}</span>`;
                    return '';
                })()}
          </button>
        </li>`;
            /* eslint-enable */ }).join('');
            const sizeValueBtns = sizeSelectionList.querySelectorAll('.js-sizeValueBtn');
            sizeValueBtns.forEach((btn)=>{
                btn.addEventListener('click', ()=>{
                    selectSize(btn);
                    const matchingFitSizeVariant = productData.variants.filter((variant)=>variant.option1 === localStorage.getItem('selectedFit') && variant.option2 === localStorage.getItem('selectedSize'));
                    localStorage.removeItem('selectedLength');
                    if (localStorage.getItem('selectedSize') !== null && trueLengthSelector) {
                        if (matchingFitSizeVariant.length === 1) lengthSelectionContainer.classList.add('hidden');
                        else lengthSelectionContainer.classList.remove('hidden');
                    }
                    lengthValueTexts.forEach((lengthValueText)=>{
                        const matchingLengthVariant = matchingFitSizeVariant.find((variant)=>variant.option3 === lengthValueText.textContent && variant.available);
                        lengthValueText.classList[matchingLengthVariant ? 'remove' : 'add']('line-through');
                    });
                    lengthValueBtnList.forEach((lengthValueBtn)=>{
                        const matchingLengthVariant = matchingFitSizeVariant.find((variant)=>variant.option3 === lengthValueBtn.dataset.lengthValue);
                        lengthValueBtn.classList[matchingLengthVariant ? 'remove' : 'add']('hidden');
                        lengthValueBtn.classList[matchingFitSizeVariant.length === 1 ? 'add' : 'remove']('w-full');
                        lengthValueBtn.classList[matchingFitSizeVariant.length === 2 ? 'add' : 'remove']('w-1/2');
                        lengthValueBtn.classList[matchingFitSizeVariant.length === 3 ? 'add' : 'remove']('w-1/3');
                        lengthValueBtn.children[0].classList[matchingFitSizeVariant.length === 2 ? 'add' : 'remove']('aspect-ratio--3/2');
                        lengthValueBtn.children[0].classList[matchingFitSizeVariant.length === 3 ? 'add' : 'remove']('aspect-ratio--1/1');
                    });
                    // If only one length value is visible, select it
                    const visibleLengthValueBtns = Object.values(lengthValueBtnList).filter((btn)=>!btn.classList.contains('hidden'));
                    if (visibleLengthValueBtns.length == 1) visibleLengthValueBtns[0].click();
                    reselectFlow.classList.add('hidden');
                    reselectFlow.classList.remove('flex');
                    stockInfo.forEach((info)=>{
                        info.classList.remove('hidden');
                    });
                    stockInfoPickup.forEach((info)=>{
                        info.classList.remove('hidden');
                    });
                });
                if (localStorage.getItem('selectedSize') === btn.dataset.value && localStorage.getItem('selectedFit') === selectedFit.textContent) btn.click();
                if (localStorage.getItem('selectedSize') !== null) lengthSelectionContainer.classList.remove('hidden');
            });
        };
        const selectLength = (btn)=>{
            const { value: value } = btn.dataset;
            trueLengthSelector.value = value;
            trueOptionSelectors.forEach((selector)=>selector.dispatchEvent(new Event('change', {
                    bubbles: true
                })));
            lengthValueBtns.forEach((lengthValueBtn)=>{
                lengthValueBtn.classList[lengthValueBtn === btn ? 'add' : 'remove']('product__length-value-button--active');
            });
            localStorage.setItem('selectedLength', value);
        };
        const updateLengthSelection = ()=>{
            lengthValueBtns.forEach((btn)=>{
                btn.addEventListener('click', ()=>{
                    selectLength(btn);
                    updateSizeSelection();
                    // find the sizeValueBtns that matches the selected size
                    const currentSizeValueBtns = sizeSelectionList.querySelectorAll('.js-sizeValueBtn');
                    const matchingSizeValueBtn = Array.from(currentSizeValueBtns).find((sizeValueBtn)=>sizeValueBtn.dataset.value === localStorage.getItem('selectedSize'));
                    if (matchingSizeValueBtn) {
                        reselectFlow.classList.add('hidden');
                        reselectFlow.classList.remove('flex');
                        stockInfo.forEach((info)=>{
                            info.classList.remove('hidden');
                        });
                        stockInfoPickup.forEach((info)=>{
                            info.classList.remove('hidden');
                        });
                        if (matchingSizeValueBtn.dataset.quantity <= '0') fitSizeAddToCartBtn.hidden = true;
                        else fitSizeAddToCartBtn.hidden = false;
                    } else {
                        reselectFlow.classList.add('flex');
                        reselectFlow.classList.remove('hidden');
                        stockInfo.forEach((info)=>{
                            info.classList.add('hidden');
                        });
                        stockInfoPickup.forEach((info)=>{
                            info.classList.add('hidden');
                        });
                        fitSizeAddToCartBtn.hidden = true;
                    }
                });
                // Clicks on standard every time and redirects from any other length variant
                // if (localStorage.getItem('selectedLength') === null && btn.dataset.value === lengthOptionDefault) {
                //   btn.click();
                // }
                if (localStorage.getItem('selectedLength') === lengthOptionDefault && btn.dataset.value === lengthOptionDefault) btn.click();
            });
        };
        const removeVariantURLParam = ()=>{
            const url = new URL(window.location.href);
            const params = new URLSearchParams(window.location.search);
            params.delete('variant');
            url.search = params;
        // window.history.replaceState(null, '', url);
        };
        const selectFit = (btn)=>{
            const { value: value } = btn.dataset;
            trueFitSelector.value = value;
            selectedFit.textContent = strings.selectedFit.replace('%fit%', value);
            fitValueBtns.forEach((fitValueBtn)=>{
                fitValueBtn.classList[fitValueBtn === btn ? 'add' : 'remove']('product__fit-value-button--active');
            });
            // Get all variants for the new fit
            const newFitVariants = productData.variants.filter((variant)=>variant[`option${fitOptionPosition}`] === value);
            // Check if the new fit has multiple lengths
            const newFitLengths = [
                ...new Set(newFitVariants.map((v)=>v[`option${lengthOptionPosition}`]))
            ];
            const hasMultipleLengths = newFitLengths.length > 1;
            // Reset length selection if the new fit has multiple lengths
            if (trueLengthSelector) {
                if (hasMultipleLengths) {
                    // If the current length is not available in the new fit, reset it to the first available length
                    const currentLength = trueLengthSelector.value;
                    if (!newFitLengths.includes(currentLength)) {
                        const defaultLength = newFitLengths[0];
                        trueLengthSelector.value = defaultLength;
                        localStorage.setItem('selectedLength', defaultLength);
                    }
                    lengthSelectionContainer.classList.remove('hidden');
                } else {
                    // If the new fit has only one length, hide the length selector
                    lengthSelectionContainer.classList.add('hidden');
                    trueLengthSelector.value = "Standard";
                    localStorage.setItem('selectedLength', 'Standard');
                    trueLengthSelector.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
            }
            updateSizeSelection();
            updateLengthSelection();
            setTimeout(()=>{
                fitSelectionBtn.click();
            }, 300);
            sizeSelectionBtn.disabled = false;
            if (!sizeSelectionBtn.classList.contains('harmonica-item__button--active')) sizeSelectionBtn.click();
            removeVariantURLParam();
            (0, $581e6c1bb6c96527$export$42ffd38884aecdac)(stockInfo);
            (0, $581e6c1bb6c96527$export$42ffd38884aecdac)(stockInfoPickup);
            selectedFitAndSize.textContent = theme.has_fit ? strings.selectFitAndSize : strings.selectedSize;
            localStorage.setItem('selectedFit', value);
        };
        fitValueBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                localStorage.removeItem('selectedLength');
                selectFit(btn);
                if (localStorage.getItem('selectedFit') !== null) sizeSelectionContainer.classList.remove('hidden');
                if (!trueLengthSelector) lengthSelectionContainer.classList.add('hidden');
                lengthSelectionContainer.classList.add('hidden');
                fitSizeAddToCartBtn.hidden = true;
                BIS.forEach((bisBtn)=>{
                    bisBtn.hidden = true;
                });
                reselectFlow.classList.remove('hidden');
                reselectFlow.classList.add('flex');
                stockInfo.forEach((info)=>{
                    info.classList.add('hidden');
                });
                stockInfoPickup.forEach((info)=>{
                    info.classList.add('hidden');
                });
            });
            if (!trueLengthSelector) lengthSelectionContainer.classList.add('hidden');
            if (localStorage.getItem('selectedFit') !== null) sizeSelectionContainer.classList.remove('hidden');
            if (fitValueBtns.length === 1) btn.click();
        });
        const updateSelectionFromVariantParam = ()=>{
            const params = new URLSearchParams(window.location.search);
            const variantParam = parseInt(params.get('variant'), 10);
            if (variantParam) {
                const variant = productData.variants.find((v)=>v.id === variantParam);
                const fit = variant[`option${fitOptionPosition}`];
                const size = variant[`option${sizeOptionPosition}`];
                const length = variant[`option${lengthOptionPosition}`];
                const matchingFitValueBtn = Array.from(fitValueBtns).find((btn)=>btn.dataset.value === fit);
                matchingFitValueBtn.click();
                const matchingSizeValueBtn = Array.from(sizeSelectionList.querySelectorAll('.js-sizeValueBtn')).find((btn)=>btn.dataset.value === size);
                matchingSizeValueBtn.click();
                if (length) {
                    const matchingLengthValueBtn = Array.from(lengthValueBtns).find((btn)=>btn.dataset.value === length);
                    matchingLengthValueBtn.click();
                }
            }
        };
        updateSelectionFromVariantParam();
        fitSizeAddToCartBtn.addEventListener('click', ()=>formAddToCartBtn.click());
    };
    const preselectOptions = ()=>{
        // Preselect fit if within a fit collection
        fitValueBtns.forEach((fitValueBtn)=>{
            const { value: value } = fitValueBtn.dataset;
            const valueHandleized = (0, $4ed1f457e1358e22$export$53a29ee4f7f84d31)(value);
            if (valueHandleized === collectionHandle) fitValueBtn.click();
        });
        // Preselect fit if already previously selected by user
        fitValueBtns.forEach((fitValueBtn)=>{
            const { value: value } = fitValueBtn.dataset;
            if (localStorage.getItem('selectedFit') === value) fitValueBtn.click();
        });
        // Preselect size if already previously selected by user 
        const sizeValueBtns = sizeSelectionList.querySelectorAll('.js-sizeValueBtn');
        sizeValueBtns.forEach((sizeValueBtn)=>{
            const { value: value } = sizeValueBtn.dataset;
            if (localStorage.getItem('selectedSize') === value) sizeValueBtn.click();
        });
    };
    const toggleAllAddToCartBtns = (active)=>{
        [
            ...sizeGuideAddToCartBtns,
            formAddToCartBtn,
            fitSizeAddToCartBtn
        ].forEach((btn)=>{
            (0, $8fc32675a1894c88$export$2e2bcd8739ae039)(btn, active);
        });
    };
    const initThumbnailDrawer = ()=>{
        if (thumbnailDrawer) {
            document.body.appendChild(thumbnailDrawer);
            const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(thumbnailDrawer);
            thumbnailBtns.forEach((btn)=>{
                btn.addEventListener('click', ()=>drawer.open());
            });
            thumbnailDrawerCloseBtn.addEventListener('click', ()=>drawer.close());
        }
    };
    const initSizeGuide = ()=>{
        document.body.appendChild(sizeGuideDrawer);
        const drawer = (0, $7d34f06a6f1944e4$export$2e2bcd8739ae039)(sizeGuideDrawer);
        sizeGuideBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>drawer.open());
        });
        sizeGuideDrawerCloseBtn.addEventListener('click', ()=>drawer.close());
        sizeGuideFitSelect.addEventListener('change', ()=>{
            sizeGuideFitGroups.forEach((group)=>{
                group.hidden = group.dataset.fit !== sizeGuideFitSelect.value;
            });
        });
        sizeGuideAddToCartBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                // Temporarily set variant select value, fake click on form submit, then switch back
                const { variantId: variantId } = btn.dataset;
                const previousVariantId = variantSelect.value;
                // const wasDisabled = formAddToCartBtn.disabled;
                variantSelect.value = variantId;
                // formAddToCartBtn.disabled = false;
                formAddToCartBtn.click();
                variantSelect.value = previousVariantId;
            // formAddToCartBtn.disabled = wasDisabled;
            });
        });
        brandSizeTableSelect.addEventListener('change', ()=>{
            brandSizeTables.forEach((table)=>{
                table.hidden = table.dataset.brandName !== brandSizeTableSelect.value;
            });
        });
    };
    const initSizeGuideTooltips = ()=>{
        const openTooltip = (tooltip)=>{
            tooltip.hidden = false;
            const rect = tooltip.getBoundingClientRect();
            if (rect.left + rect.width > window.innerWidth) tooltip.classList.add('product__size-guide__tooltip--right');
        };
        const closeTooltip = (tooltip)=>{
            tooltip.hidden = true;
            tooltip.classList.remove('product__size-guide__tooltip--right');
        };
        sizeGuideTooltipBtns.forEach((btn)=>{
            const { index: index } = btn.dataset;
            const matchingTooltip = Array.from(sizeGuideTooltips).find((tooltip)=>tooltip.dataset.index === index);
            btn.addEventListener('click', ()=>{
                openTooltip(matchingTooltip);
            });
            window.addEventListener('click', (event)=>{
                if (!matchingTooltip.contains(event.target) && !btn.contains(event.target)) closeTooltip(matchingTooltip);
            });
        });
    };
    const initStoreTooltips = ()=>{
        const openTooltip = (tooltip)=>{
            tooltip.hidden = false;
            const rect = tooltip.getBoundingClientRect();
            if (rect.left + rect.width > window.innerWidth) tooltip.classList.add('product__size-guide__tooltip--right');
        };
        const closeTooltip = (tooltip)=>{
            tooltip.hidden = true;
            tooltip.classList.remove('product__size-guide__tooltip--right');
        };
        storeTooltipsBtns.forEach((btn)=>{
            const { index: index } = btn.dataset;
            const matchingTooltip = Array.from(storeTooltips).find((tooltip)=>tooltip.dataset.index === index);
            btn.addEventListener('mouseenter', ()=>{
                openTooltip(matchingTooltip);
            });
            window.addEventListener('mouseover', (event)=>{
                if (!matchingTooltip.contains(event.target) && !btn.contains(event.target)) closeTooltip(matchingTooltip);
            });
        });
    };
    const initForm = ()=>{
        form.addEventListener('submit', (event)=>{
            event.preventDefault();
            toggleAllAddToCartBtns(false);
            const variantId = variantSelect.value;
            // If size is not picked & size btn is disabled trigger "choose size" flow
            if (fitSizeAddToCartBtn.hasAttribute('hidden')) {
                fitSizeSelectionBtn.click();
                toggleAllAddToCartBtns(true);
                return;
            }
            (0, $92d139db6aba612b$export$509a42920845e675)({
                variantId: variantId,
                quantity: 1,
                callback: ()=>toggleAllAddToCartBtns(true)
            });
        });
    };
    const storeProduct = ()=>{
        const { handle: handle } = productData;
        const handles = localStorage.getItem('viewedProducts')?.split(',') || [];
        if (handles.includes(handle)) {
            const index = handles.indexOf(handle);
            handles.splice(index, 1);
        }
        handles.unshift(handle);
        localStorage.setItem('viewedProducts', handles);
    };
    const initMobileCta = ()=>{
        // Show and hide mobile CTA
        const observer = new IntersectionObserver((entries)=>{
            const rect = entries[0].boundingClientRect;
            const show = rect.y + rect.height < 0;
            mobileCta.classList[show ? 'add' : 'remove']('product__mobile-cta--active');
        });
        observer.observe(node);
        // Update mobile CTA top position based on header
        ctx.on('mobileHeader:scrolled', ({ mobileHeaderVisible: mobileHeaderVisible })=>{
            mobileCta.classList[mobileHeaderVisible ? 'add' : 'remove']('product__mobile-cta--offset');
        });
        mobileCta.addEventListener('click', ()=>fitSizeSelectionBtn.click());
    };
    async function init() {
        if (prelaunch === false && isProductEvent === false) {
            await initVariantSelection();
            initOptionSelection();
            preselectOptions();
            initSizeGuide();
            initSizeGuideTooltips();
            initStoreTooltips();
            initForm();
        }
        if (isProductEvent === true) initForm();
        fitInfoBtn.addEventListener('click', (e)=>{
            e.stopPropagation();
            displayFitInfo();
        });
        initSwatches();
        initThumbnailDrawer();
        storeProduct();
        initMobileCta();
        node.dispatchEvent(new Event('loaded', {
            bubbles: true
        }));
    }
    /**
   * Init
   */ await init();
});




var $c9afba975198ae4c$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    /**
   * Data + elements
   */ const config = JSON.parse(node.dataset.config);
    const { productID: productID, baseURL: baseURL, limit: limit } = config;
    const sliderElement = node.querySelector('.js-slider');
    const paginationElement = node.querySelector('.js-pagination');
    const output = node.querySelector('.js-output');
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            if (mutation.addedNodes.length > 0) {
                const newNodes = Array.from(mutation.addedNodes);
                const newMediaSliderElements = newNodes.filter((node)=>node.classList && node.classList.contains('product-slider__item'));
                if (newMediaSliderElements.length > 0) initializeProductCard(newMediaSliderElements);
            }
        });
    });
    const initializeProductCard = (newMediaSliderElements)=>{
        newMediaSliderElements.forEach((slider)=>{
            const swiperElement = slider.querySelector('.product__media-slider');
            swiperElement.setAttribute('navigation', true);
            const paginationElement = slider.querySelector('.js-pagination');
            new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(swiperElement.querySelector('.swiper'), {
                modules: [
                    (0, $a9e908ce9608037f$export$2e2bcd8739ae039),
                    (0, $604711bfadd9afec$export$2e2bcd8739ae039)
                ],
                slidesPerView: 'auto',
                grabCursor: false,
                allowTouchMove: false,
                navigation: {
                    prevEl: slider.querySelector('.js-mediaSliderPrevBtn'),
                    nextEl: slider.querySelector('.js-mediaSliderNextBtn')
                },
                pagination: {
                    el: paginationElement,
                    type: 'bullets',
                    bulletClass: 'product-slider__pagination__bullet',
                    bulletActiveClass: 'product-slider__pagination__bullet--active'
                }
            });
        });
    };
    observer.observe(node, {
        subtree: true,
        childList: true
    });
    /**
   * Functions
   */ const getMarkup = ()=>{
        const endpoint = `${baseURL}?section_id=product-related&product_id=${productID}&limit=${limit}`;
        return fetch(endpoint, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response)=>response.text());
    };
    const init = async ()=>{
        const markup = await getMarkup();
        const container = document.createElement('div');
        container.innerHTML = markup;
        output.innerHTML = container.querySelector('.js-output').innerHTML;
        (()=>new (0, $6a915eceb75a44a6$export$2e2bcd8739ae039)(sliderElement, {
                modules: [
                    (0, $604711bfadd9afec$export$2e2bcd8739ae039)
                ],
                slidesPerView: 'auto',
                grabCursor: true,
                pagination: {
                    el: paginationElement,
                    type: 'bullets',
                    bulletClass: 'product-slider__pagination__bullet',
                    bulletActiveClass: 'product-slider__pagination__bullet--active'
                }
            }))();
    };
    /**
   * Init
   */ init();
});







var $47620cc16e739764$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    const AddToCartBtn = node.querySelector('.js-formAddToCartBtn');
    const formAddToCartBtn = AddToCartBtn.closest('form');
    const fitSizeSelectionBtn = document.querySelector('.js-fitSizeSelectionBtn');
    const mainProductsection = document.querySelector('section.product');
    const productInfo = document.querySelector('[product-info]');
    const productSelection = document.querySelector('[product-selection]');
    const productSelectionInforWrapper = document.querySelector('.product__selection');
    const addProductToCart = (e)=>{
        e.preventDefault();
        (0, $8fc32675a1894c88$export$2e2bcd8739ae039)(AddToCartBtn, false);
        fitSizeSelectionBtn.click();
        (0, $8fc32675a1894c88$export$2e2bcd8739ae039)(AddToCartBtn, true);
    };
    const toggleSectionOnScroll = ()=>{
        const mainProductSectionHeight = parseFloat(mainProductsection.getBoundingClientRect().height);
        const productInfoHeight = parseFloat(productInfo.getBoundingClientRect().height);
        const productSelectionHeight = parseFloat(productSelection.getBoundingClientRect().height);
        const mainProductRightSectionHeight = productInfoHeight + productSelectionHeight;
        window.addEventListener('scroll', function() {
            const currentScrollPosY = window.scrollY;
            const screenWidth = screen.width;
            if (screenWidth > 767) {
                if (currentScrollPosY >= parseFloat(mainProductSectionHeight - mainProductRightSectionHeight)) {
                    node.classList.remove('opacity-0');
                    node.classList.add('opacity-1');
                } else {
                    node.classList.add('opacity-0');
                    node.classList.remove('opacity-1');
                }
            } else if (currentScrollPosY >= mainProductSectionHeight - productInfoHeight) {
                node.classList.remove('opacity-0');
                node.classList.add('opacity-1');
            } else {
                node.classList.add('opacity-0');
                node.classList.remove('opacity-1');
            }
        });
    };
    const init = ()=>{
        (0, $c0bd171aae5be854$export$2e2bcd8739ae039)(()=>{
            formAddToCartBtn.addEventListener('submit', (e)=>addProductToCart(e));
            toggleSectionOnScroll();
        });
    };
    init();
});



let $19e75c843ce54c97$var$G_SHEET_URL;
const $19e75c843ce54c97$var$G_SHEET_SHOPIFY_SETTING = window.sizeCalculatorUrl;
if ($19e75c843ce54c97$var$G_SHEET_SHOPIFY_SETTING) $19e75c843ce54c97$var$G_SHEET_URL = $19e75c843ce54c97$var$G_SHEET_SHOPIFY_SETTING;
else $19e75c843ce54c97$var$G_SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vS6a668y7GlbdUOvC-4He2pDCD2EYjDro8owAOOVU2bqAnZlnZoBW1IKs6uj82Q9KF1ngofPUaschum/pub?gid=1268245469&single=true&output=csv";
console.log($19e75c843ce54c97$var$G_SHEET_URL, $19e75c843ce54c97$var$G_SHEET_SHOPIFY_SETTING);
async function $19e75c843ce54c97$export$16ad050bd0ffb38f() {
    return $19e75c843ce54c97$var$csvToJson(await $19e75c843ce54c97$var$getData());
}
async function $19e75c843ce54c97$var$getData() {
    return await $19e75c843ce54c97$var$fetchGoogleSheetCSV($19e75c843ce54c97$var$G_SHEET_URL);
}
let $19e75c843ce54c97$var$csvData = undefined;
async function $19e75c843ce54c97$var$fetchGoogleSheetCSV(url) {
    if ($19e75c843ce54c97$var$csvData) return $19e75c843ce54c97$var$csvData;
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        $19e75c843ce54c97$var$csvData = await response.text();
        return $19e75c843ce54c97$var$csvData;
    } catch (error) {
        console.error('Fetching CSV failed:', error);
        return null;
    }
}
function $19e75c843ce54c97$var$csvToJson(csv) {
    if (!csv) return;
    const lines = csv.split("\n");
    const result = [];
    const headers = lines[0].split(",");
    for(let row = 1; row < lines.length; row++){
        const obj = {};
        const currentline = lines[row].split(",");
        for(let col = 0; col < headers.length; col++)obj[headers[col]] = currentline[col];
        result.push(obj);
    }
    return result;
}


async function $5d2c99cb84aed09f$export$2cd8252107eb640b(input) {
    if (!input.weight || !input.height || !input.prefFit) return undefined;
    let adjustedWeight = parseInt(input.weight);
    if (input.prefFit === "T\xe6t") adjustedWeight -= 5;
    else if (input.prefFit === "L\xf8st") adjustedWeight += 5;
    const sizesData = await (0, $19e75c843ce54c97$export$16ad050bd0ffb38f)();
    if (!sizesData) return undefined;
    const answer = sizesData.filter((row)=>row.height == input.height && row.weight == adjustedWeight);
    if (answer.length > 0) {
        const shirt = answer[0];
        const satisfaction = shirt.grade;
        const suggestionText = `Anbefaling: Pasform **${shirt.body_fit}** i st\xf8rrelse **${shirt.size}**.`;
        const satisfactionText = `Sikkerhed: ${satisfaction}`;
        const val1 = Math.round(shirt.height_avg * 10) / 10;
        const val2 = Math.round(shirt.weight_avg * 10) / 10;
        return {
            suggestionText: suggestionText,
            satisfactionText: satisfactionText,
            height: val1,
            weight: val2,
            shirt: shirt
        };
    } else return undefined;
}


var $06745ad64d763dd8$export$2e2bcd8739ae039 = (0, $43e391a139e05df5$export$d8556a2a8f973135)(async (node)=>{
    let inputHeight = "";
    let inputWeight = "";
    let inputAge = "";
    let inputFit = "";
    const sizeCalculator = node;
    const recommendationsContainer = sizeCalculator.querySelector('[data-recommendations]');
    const recommendationOptionTemplate = sizeCalculator.querySelector("#recommendation-template");
    const showYourSizeButton = ()=>{
        const yourSizeButton = document.querySelector(".js-yourSizeBtn");
        if (!yourSizeButton || !sessionStorage.getItem("calculatedShirtData")) return;
        yourSizeButton.removeAttribute("hidden");
        yourSizeButton.querySelector("[data-size]").textContent = JSON.parse(sessionStorage.getItem("calculatedShirtData")).selected;
    };
    const submitSize = (selectedShirt)=>{
        let selectedShirtData = selectedShirt;
        if (!selectedShirtData) {
            if (sessionStorage.getItem("calculatedShirtData")) selectedShirtData = JSON.parse(sessionStorage.getItem("calculatedShirtData")).selected;
        }
        if (!selectedShirtData) return;
        showYourSizeButton();
        let option1 = selectedShirtData.split('/')[0];
        let option2 = selectedShirtData.split('/')[1];
        let option3 = null;
        if (option1.includes('-')) {
            option3 = option1.split('-')[1];
            option1 = option1.split('-')[0];
        }
        if (option1) document.querySelectorAll(".js-fitValueBtn").forEach((btn)=>{
            if (btn.dataset.value.includes(option1)) btn.click();
        });
        if (option2) document.querySelectorAll(".js-sizeValueBtn").forEach((btn)=>{
            if (btn.dataset.value.split(" ")[0] == option2) btn.click();
        });
        if (option3) document.querySelectorAll(".js-lengthValueBtn").forEach((btn)=>{
            if (option3.toLowerCase().includes(btn.dataset.value.toLowerCase())) btn.click();
        });
        else document.querySelectorAll(".js-lengthValueBtn").forEach((btn)=>{
            if (btn.dataset.value.toLowerCase() == "standard") btn.click();
        });
    };
    const addCalculatedShirtOptions = (calculatedShirtData)=>{
        // clear
        recommendationsContainer.replaceChildren();
        const submitButton = sizeCalculator.querySelector("[data-submit]");
        submitButton.querySelector("span").textContent = "";
        submitButton.setAttribute("disabled", true);
        submitButton.classList.remove("button--filled-dark");
        submitButton.classList.add("button--outlined-dark");
        sizeCalculator.querySelector("[data-no-options]").setAttribute("hidden", true);
        // failure
        if (!calculatedShirtData) {
            sizeCalculator.querySelector("[data-no-options]").removeAttribute("hidden");
            return;
        }
        // add options html
        createShirtOption(recommendationOptionTemplate, calculatedShirtData.shirt.shirt_suggestion, Math.round(calculatedShirtData.shirt.weight_avg * 10) / 10, Math.round(calculatedShirtData.shirt.height_avg * 10) / 10, false);
        createShirtOption(recommendationOptionTemplate, calculatedShirtData.shirt.shirt_suggestion_2nd, Math.round(calculatedShirtData.shirt.weight_avg_2nd * 10) / 10, Math.round(calculatedShirtData.shirt.height_avg_2nd * 10) / 10, true);
        // add options events
        const options = recommendationsContainer.querySelectorAll("[data-option]");
        options.forEach((option)=>{
            option.addEventListener("click", function() {
                options.forEach((option)=>{
                    option.classList.remove("border-black", "border-2");
                    option.classList.add("border-grey-200", "border");
                    option.querySelector("[data-checkbox]").classList.remove("bg-black");
                    option.removeAttribute("selected");
                });
                option.classList.add("border-black", "border-2");
                option.classList.remove("border-grey-200", "border");
                option.querySelector("[data-checkbox]").classList.add("bg-black");
                option.setAttribute("selected", true);
                submitButton.querySelector("span").textContent = option.querySelector("[data-title]").textContent;
                submitButton.removeAttribute("disabled");
                submitButton.classList.add("button--filled-dark");
                submitButton.classList.remove("button--outlined-dark");
                calculatedShirtData.selected = option.querySelector("[data-title]").textContent;
                sessionStorage.setItem("calculatedShirtData", JSON.stringify(calculatedShirtData));
            });
        });
        submitButton.addEventListener("click", function() {
            submitSize(calculatedShirtData.selected);
        });
        function createShirtOption(template, title, weight, height, alternative) {
            const clone = template.content.cloneNode(true);
            const titleElement = clone.querySelector('[data-title]');
            const weightElement = clone.querySelector('[data-weight]');
            const heightElement = clone.querySelector('[data-height]');
            if (alternative) {
                clone.querySelector('[data-alternative]').removeAttribute("hidden");
                clone.querySelector('[data-best]').setAttribute("hidden", true);
            }
            titleElement.textContent = title;
            weightElement.value = parseInt(weight) + " kg";
            heightElement.value = parseInt(height) + " cm";
            recommendationsContainer.appendChild(clone);
        }
    };
    const addStepChangeEvents = (steps)=>{
        function hideAllSteps() {
            steps.forEach((step)=>step.setAttribute("hidden", true));
        }
        function showNextStep(step) {
            step.nextElementSibling?.removeAttribute("hidden");
        }
        function showPreviousStep(step) {
            step.previousElementSibling?.removeAttribute("hidden");
        }
        steps.forEach((step)=>{
            const advanceButton = step.querySelector("[data-advance]");
            const backButton = step.querySelector("[data-back]");
            advanceButton?.addEventListener("click", ()=>{
                hideAllSteps();
                showNextStep(step);
            });
            backButton?.addEventListener("click", ()=>{
                hideAllSteps();
                showPreviousStep(step);
            });
        });
    };
    const addStep1InputEvents = (step)=>{
        const inputs = step.querySelectorAll("input");
        const nextButton = step.querySelector("[data-advance]");
        // if all inputs are filled out, enable the next button
        inputs.forEach((input)=>{
            input.addEventListener("input", ()=>{
                const allFilled = [
                    ...inputs
                ].every((input)=>input.value !== "");
                if (allFilled) {
                    nextButton.removeAttribute("disabled");
                    nextButton.classList.remove("pointer-events-none", "button--outlined-dark");
                    nextButton.classList.add("button--filled-dark");
                } else {
                    nextButton.setAttribute("disabled", true);
                    nextButton.classList.add("pointer-events-none", "button--outlined-dark");
                    nextButton.classList.remove("button--filled-dark");
                }
            });
        });
        // if one of the inputs focused, click next button on pressing enter    
        inputs.forEach((input)=>{
            input.addEventListener("keydown", (e)=>{
                if (e.key === "Enter") nextButton.click();
            });
        });
        // get input data
        nextButton.addEventListener("click", function() {
            inputHeight = sizeCalculator.querySelector("[data-height]").value;
            inputWeight = sizeCalculator.querySelector("[data-weight]").value;
            inputAge = sizeCalculator.querySelector("[data-age]").value;
        });
    };
    const addStep2InputEvents = (step)=>{
        const optionButtons = step.querySelectorAll("[data-option]");
        const nextButton = step.querySelector("[data-advance]");
        // option select
        optionButtons.forEach((option)=>{
            option.addEventListener("click", ()=>{
                // unselect buttons
                optionButtons.forEach((option)=>{
                    option.classList.add("border-grey-200", "border");
                    option.removeAttribute("selected");
                });
                option.classList.remove("border-grey-200", "border");
                option.setAttribute("selected", true);
            });
        });
        // if one of the options selected, click next button when pressing enter
        optionButtons.forEach((option)=>{
            option.addEventListener("keydown", (e)=>{
                if (e.key === "Enter") nextButton.click();
            });
        });
        // enable next button
        optionButtons.forEach((option)=>{
            option.addEventListener("click", ()=>{
                const selected = [
                    ...optionButtons
                ].some((option)=>option.getAttribute("selected") === "true");
                if (selected) {
                    nextButton.removeAttribute("disabled");
                    nextButton.classList.remove("pointer-events-none", "button--outlined-dark");
                    nextButton.classList.add("button--filled-dark");
                } else {
                    nextButton.setAttribute("disabled", true);
                    nextButton.classList.add("pointer-events-none", "button--outlined-dark");
                    nextButton.classList.remove("button--filled-dark");
                }
            });
        });
        // next button event
        nextButton.addEventListener("click", async function() {
            inputFit = [
                ...optionButtons
            ].filter((btn)=>btn.hasAttribute("selected"))[0]?.value;
            const input = {
                weight: inputWeight,
                height: inputHeight,
                age: inputAge,
                prefFit: inputFit
            };
            // *** Calculate shirt *** 
            const calculatedShirtData = await $5d2c99cb84aed09f$export$2cd8252107eb640b(input);
            addCalculatedShirtOptions(calculatedShirtData);
        });
    };
    const showStep = (steps, step)=>{
        steps.forEach((step)=>step.setAttribute("hidden", true));
        steps[step].removeAttribute("hidden");
    };
    const init = ()=>{
        const steps = sizeCalculator.querySelectorAll('[data-step]');
        addStepChangeEvents(steps);
        addStep1InputEvents(steps[0]);
        addStep2InputEvents(steps[1]);
        document.querySelector("[product-selection]")?.addEventListener("loaded", function() {
            submitSize();
            if (sessionStorage.getItem("calculatedShirtData")) {
                const calculatedShirtData = JSON.parse(sessionStorage.getItem("calculatedShirtData"));
                addCalculatedShirtOptions(calculatedShirtData);
                showStep(steps, 2);
            }
        });
    };
    init();
});


(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).add({
    giftCardSelection: $3f5e45515c698c07$export$2e2bcd8739ae039,
    productMedia: $90f38608414c3c9a$export$2e2bcd8739ae039,
    productSelection: $52b17377c08e80fe$export$2e2bcd8739ae039,
    productInfodrawer: $80e22efde2dd20ce$export$2e2bcd8739ae039,
    relatedProducts: $c9afba975198ae4c$export$2e2bcd8739ae039,
    preorder: $5b5d2fe0f5fc56a4$export$2e2bcd8739ae039,
    productReviews: $c7539826986ca6c3$export$2e2bcd8739ae039,
    productSticky: $47620cc16e739764$export$2e2bcd8739ae039,
    sizeCalculator: $06745ad64d763dd8$export$2e2bcd8739ae039
});
(0, $86ccb4ff195e33b3$export$2e2bcd8739ae039).mount();


parcelRequire("eY55m");
document.addEventListener('DOMContentLoaded', function() {
    const toggleButton = document.getElementById('toggleButton');
    const table = document.getElementById('ordersTable');
    const tbody = table.querySelector('tbody');
    const allRows = tbody.querySelectorAll('tr');
    if (!toggleButton || !table || !tbody) return;
    let showingAll = false;
    function getVisibleRowCount() {
        return window.innerWidth >= 990 ? 5 : 1;
    }
    function updateRowVisibility() {
        const maxVisibleRows = showingAll ? allRows.length : getVisibleRowCount();
        const isWideScreen = window.innerWidth >= 990;
        allRows.forEach((row, index)=>{
            row.style.display = index < maxVisibleRows ? isWideScreen ? 'table-row' : 'flex' : 'none';
        });
        const textNode = toggleButton.childNodes[0];
        textNode.nodeValue = showingAll ? "Se f\xe6rre ordre" : 'Se alle ordre';
    }
    updateRowVisibility();
    toggleButton.addEventListener('click', function() {
        showingAll = !showingAll;
        updateRowVisibility();
    });
    window.addEventListener('resize', function() {
        if (!showingAll) updateRowVisibility();
    });
});


document.addEventListener('DOMContentLoaded', function() {
    const megamenuTriggers = document.querySelectorAll('.has-megamenu');
    const header = document.querySelector('.megamenu-header');
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    let currentMegamenu = null;
    let currentTrigger = null;
    // Desktop megamenu
    megamenuTriggers.forEach(function(trigger) {
        const menuHandle = trigger.getAttribute('data-menu-handle');
        const megamenu = document.getElementById('megamenu-' + menuHandle);
        if (megamenu) trigger.addEventListener('click', function(e) {
            e.preventDefault();
            if (currentMegamenu === megamenu) {
                megamenu.classList.remove('show');
                header.classList.remove('design-white');
                megamenu.classList.remove('design-white');
                html.classList.remove('overflow-hidden');
                body.classList.remove('overflow-hidden');
                currentMegamenu = null;
                currentTrigger = null;
                trigger.classList.remove('open');
                document.removeEventListener('click', closeMegamenuOnOutsideClick);
                document.removeEventListener('keydown', closeMegamenuOnEscape);
            } else {
                document.querySelectorAll('.megamenu').forEach(function(m) {
                    m.classList.remove('show');
                    m.classList.remove('design-white');
                });
                document.querySelectorAll('.has-megamenu').forEach(function(t) {
                    t.classList.remove('open');
                });
                megamenu.classList.add('show');
                trigger.classList.add('open');
                header.classList.add('design-white');
                megamenu.classList.add('design-white');
                html.classList.add('overflow-hidden');
                body.classList.add('overflow-hidden');
                currentMegamenu = megamenu;
                currentTrigger = trigger;
                setTimeout(()=>{
                    document.addEventListener('click', closeMegamenuOnOutsideClick);
                    document.addEventListener('keydown', closeMegamenuOnEscape);
                }, 5);
                hideMegamenu();
                hideOverlay();
            }
        });
    });
    function closeMegamenuOnOutsideClick(e) {
        if (!currentMegamenu) return;
        const isClickInsideMegamenu = currentMegamenu.contains(e.target);
        const isClickOnTrigger = currentTrigger && currentTrigger.contains(e.target);
        const isClickOnLink = e.target.closest('a');
        const clickedOutsideMegamenu = !isClickInsideMegamenu;
        const clickedInsideButNotOnLink = isClickInsideMegamenu && !isClickOnLink;
        const shouldCloseMegamenu = (clickedOutsideMegamenu || clickedInsideButNotOnLink) && !isClickOnTrigger;
        if (shouldCloseMegamenu) {
            currentMegamenu.classList.remove('show');
            currentTrigger.classList.remove('open');
            header.classList.remove('design-white');
            currentMegamenu.classList.remove('design-white');
            html.classList.remove('overflow-hidden');
            body.classList.remove('overflow-hidden');
            document.removeEventListener('click', closeMegamenuOnOutsideClick);
            document.removeEventListener('keydown', closeMegamenuOnEscape);
            currentMegamenu = null;
            currentTrigger = null;
        }
    }
    function closeMegamenuOnEscape(e) {
        if (e.key === 'Escape' && currentMegamenu) {
            currentMegamenu.classList.remove('show');
            currentTrigger.classList.remove('open');
            header.classList.remove('design-white');
            currentMegamenu.classList.remove('design-white');
            html.classList.remove('overflow-hidden');
            body.classList.remove('overflow-hidden');
            document.removeEventListener('click', closeMegamenuOnOutsideClick);
            document.removeEventListener('keydown', closeMegamenuOnEscape);
            currentMegamenu = null;
            currentTrigger = null;
        }
    }
    // Mobile menu
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenuToggleOffButtons = document.querySelectorAll('.mobile-menu-toggle-off');
    const mobileMenu = document.querySelector('.mobile-menu');
    const mobileMenuMain = document.querySelector('.mobile-menu-main');
    if (mobileMenuToggle && mobileMenu && mobileMenuMain) {
        // Toggle mobile menu
        mobileMenuToggle.addEventListener('click', function(e) {
            e.stopPropagation();
            const isOpen = mobileMenu.classList.contains('open');
            if (isOpen) {
                mobileMenuToggle.classList.remove('active');
                mobileMenu.classList.remove('open');
                header.classList.remove('mobile-menu-active');
                document.body.classList.remove('mobile-menu-open');
                setTimeout(function() {
                    mobileMenuMain.classList.remove('slide-left');
                    document.querySelectorAll('.mobile-menu-submenu').forEach(function(submenu) {
                        submenu.classList.remove('active');
                    });
                    document.querySelectorAll('.mobile-submenu-item').forEach(function(item) {
                        item.classList.remove('active');
                    });
                }, 200);
            } else {
                mobileMenuToggle.classList.add('active');
                mobileMenu.classList.add('open');
                header.classList.add('mobile-menu-active');
                document.body.classList.add('mobile-menu-open');
            }
        });
        mobileMenuToggleOffButtons.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.stopPropagation();
                const isOpen = mobileMenu.classList.contains('open');
                if (isOpen) {
                    mobileMenuToggle.classList.remove('active');
                    mobileMenu.classList.remove('open');
                    header.classList.remove('mobile-menu-active');
                    document.body.classList.remove('mobile-menu-open');
                    setTimeout(function() {
                        mobileMenuMain.classList.remove('slide-left');
                        document.querySelectorAll('.mobile-menu-submenu').forEach(function(submenu) {
                            submenu.classList.remove('active');
                        });
                        document.querySelectorAll('.mobile-submenu-item').forEach(function(item) {
                            item.classList.remove('active');
                        });
                    }, 200);
                } else {
                    mobileMenuToggle.classList.add('active');
                    mobileMenu.classList.add('open');
                    header.classList.add('mobile-menu-active');
                    document.body.classList.add('mobile-menu-open');
                }
            });
        });
        // Click on main link in mobile
        const mainTriggers = document.querySelectorAll('.mobile-menu-trigger.has-submenu');
        mainTriggers.forEach(function(trigger) {
            trigger.addEventListener('click', function(e) {
                e.preventDefault();
                const menuHandle = trigger.getAttribute('data-menu');
                const submenu = document.getElementById('mobile-submenu-' + menuHandle);
                if (submenu) {
                    mobileMenuMain.classList.add('slide-left');
                    submenu.classList.add('active');
                }
            });
        });
        // Back button
        const backButtons = document.querySelectorAll('.mobile-menu-back');
        backButtons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                mobileMenuMain.classList.remove('slide-left');
                document.querySelectorAll('.mobile-menu-submenu').forEach(function(submenu) {
                    submenu.classList.remove('active');
                });
                document.querySelectorAll('.mobile-submenu-item').forEach(function(item) {
                    item.classList.remove('active');
                });
            });
        });
        // Accordion in submenu
        const submenuTriggers = document.querySelectorAll('.mobile-submenu-trigger');
        submenuTriggers.forEach(function(trigger) {
            trigger.addEventListener('click', function(e) {
                e.preventDefault();
                const parent = trigger.closest('.mobile-submenu-item');
                const isActive = parent?.classList.contains('active');
                parent?.classList.toggle('active', !isActive);
            });
        });
    }
});
function $326ed403f3531261$var$adjustContentHeight() {
    const container = document.querySelector('.megamenu-section');
    const header = document.querySelector('.megamenu-header');
    const contents = document.querySelectorAll('.megamenu');
    const mobilemenu = document.querySelector('.mobile-menu');
    const announcement = document.getElementById('shopify-section-announcement');
    const mobilemenuheader = document.querySelector('.mobile-menu-header');
    const mobilemenuinner = document.querySelectorAll('.mobile-menu-inner');
    // safety check
    if (!container || !header || !mobilemenu || !contents.length || !mobilemenuheader) return;
    const containerTop = container.getBoundingClientRect().top;
    const headerHeight = header.offsetHeight;
    const announcementHeight = announcement ? announcement.offsetHeight : 0;
    const mobilemenuheaderHeight = mobilemenuheader ? mobilemenuheader.offsetHeight : 0;
    contents.forEach((content)=>{
        content.style.height = `calc(100vh - ${containerTop + headerHeight}px)`;
    });
    mobilemenu.style.height = `calc(100vh - ${announcementHeight}px)`;
    mobilemenu.style.top = `0px`;
    mobilemenuinner.forEach((mobilemenuinneritem)=>{
        mobilemenuinneritem.style.height = `calc(100dvh - ${mobilemenuheaderHeight + announcementHeight}px)`;
    });
}
function $326ed403f3531261$var$positionMegamenu() {
    const menus = document.querySelectorAll(".js-megamenu");
    const header = document.querySelector(".megamenu-header");
    if (!header) return;
    const isFixedMobile = header.classList.contains("header--fixed-mobile");
    const isFixedDesktop = header.classList.contains("header--fixed-desktop");
    const headerHeight = header.offsetHeight;
    menus.forEach((menu)=>{
        menu.classList.add("w-screen", "absolute");
        // if header fixed
        if (isFixedMobile || isFixedDesktop) menu.style.top = "36px";
        else if (window.innerWidth < 1450) menu.style.top = "80px";
        else menu.style.top = "36px";
        // left offset
        const navParent = menu.closest(".megamenu-part");
        if (!navParent) return;
        const parentRect = navParent.getBoundingClientRect();
        const leftOffset = parentRect.left;
        menu.style.left = `-${leftOffset}px`;
    });
}
window.addEventListener('DOMContentLoaded', $326ed403f3531261$var$adjustContentHeight);
let $326ed403f3531261$var$lastWidth = window.innerWidth;
let $326ed403f3531261$var$lastHeight = window.innerHeight;
window.addEventListener('resize', function() {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;
    const widthDiff = Math.abs(currentWidth - $326ed403f3531261$var$lastWidth);
    const heightDiff = Math.abs(currentHeight - $326ed403f3531261$var$lastHeight);
    const RESIZE_THRESHOLD = 20;
    if (widthDiff >= RESIZE_THRESHOLD || heightDiff >= RESIZE_THRESHOLD) {
        $326ed403f3531261$var$adjustContentHeight();
        $326ed403f3531261$var$positionMegamenu();
        $326ed403f3531261$var$lastWidth = currentWidth;
        $326ed403f3531261$var$lastHeight = currentHeight;
    }
});
window.addEventListener("DOMContentLoaded", $326ed403f3531261$var$positionMegamenu);
const $326ed403f3531261$var$SCROLL_THRESHOLD = 800;
window.addEventListener("scroll", function() {
    const scrollPosition = window.scrollY || window.pageYOffset;
    const isNearTop = scrollPosition < $326ed403f3531261$var$SCROLL_THRESHOLD;
    if (isNearTop) {
        $326ed403f3531261$var$adjustContentHeight();
        $326ed403f3531261$var$positionMegamenu();
    }
});
const $326ed403f3531261$var$initializedElements = new WeakSet();
const $326ed403f3531261$var$DRAG_THRESHOLD = 5;
function $326ed403f3531261$var$initSingleElement(scrollContainer) {
    if ($326ed403f3531261$var$initializedElements.has(scrollContainer)) return;
    const width = scrollContainer.offsetWidth;
    const scrollWidth = scrollContainer.scrollWidth;
    const hasOverflow = scrollWidth > width;
    let isDown = false;
    let startX;
    let startY;
    let scrollLeft;
    let hasMoved = false;
    scrollContainer.addEventListener('mousedown', (e)=>{
        isDown = true;
        hasMoved = false;
        scrollContainer.style.cursor = 'grabbing';
        scrollContainer.classList.add('is-dragging');
        startX = e.pageX - scrollContainer.offsetLeft;
        startY = e.pageY;
        scrollLeft = scrollContainer.scrollLeft;
        e.preventDefault();
    });
    scrollContainer.addEventListener('mouseleave', ()=>{
        isDown = false;
        scrollContainer.style.cursor = 'grab';
        scrollContainer.classList.remove('is-dragging');
    });
    scrollContainer.addEventListener('mouseup', ()=>{
        isDown = false;
        scrollContainer.style.cursor = 'grab';
        scrollContainer.classList.remove('is-dragging');
    });
    scrollContainer.addEventListener('mousemove', (e)=>{
        if (!isDown) return;
        const x = e.pageX - scrollContainer.offsetLeft;
        const y = e.pageY;
        const distanceX = Math.abs(x - startX);
        const distanceY = Math.abs(y - startY);
        if (distanceX > $326ed403f3531261$var$DRAG_THRESHOLD || distanceY > $326ed403f3531261$var$DRAG_THRESHOLD) hasMoved = true;
        e.preventDefault();
        const walk = (x - startX) * 2;
        const newScrollLeft = scrollLeft - walk;
        scrollContainer.scrollLeft = newScrollLeft;
    });
    scrollContainer.addEventListener('click', (e)=>{
        if (hasMoved) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }, true);
    const links = scrollContainer.querySelectorAll('a');
    links.forEach((link)=>{
        link.addEventListener('dragstart', (e)=>{
            e.preventDefault();
        });
    });
    $326ed403f3531261$var$initializedElements.add(scrollContainer);
}
function $326ed403f3531261$var$checkAndInitElements() {
    const scrollContainers = document.querySelectorAll('.scrollable-products-4-plus');
    scrollContainers.forEach((container, index)=>{
        if (!$326ed403f3531261$var$initializedElements.has(container) && container.offsetWidth > 0) $326ed403f3531261$var$initSingleElement(container, index);
    });
}
const $326ed403f3531261$var$observer = new MutationObserver((mutations)=>{
    $326ed403f3531261$var$checkAndInitElements();
});
$326ed403f3531261$var$observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
        'class',
        'style'
    ]
});
document.addEventListener('mouseenter', (e)=>{
    if (e?.target?.classList?.contains('scrollable-products-4-plus')) {
        const containers = Array.from(document.querySelectorAll('.scrollable-products-4-plus'));
        const index = containers.indexOf(e.target);
        $326ed403f3531261$var$initSingleElement(e.target, index);
    }
}, true);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
    $326ed403f3531261$var$checkAndInitElements();
});
else $326ed403f3531261$var$checkAndInitElements();


if (document.querySelectorAll(".countdown").length > 0) {
    //document.querySelectorAll(".countdown").forEach(element => {
    //    element.style.visibility = "hidden"; // Example: hide all elements with the class
    //  });
    let textToUpdate = "";
    let interval;
    function startCountdown(endDateTime) {
        document.querySelectorAll(".countdown").forEach((element)=>{
            element.style.visibility = "visible"; // Example: hide all elements with the class
        });
        const countdownElements = document.querySelectorAll(".countdown");
        if (countdownElements.length === 0) {
            console.error("No elements with the class 'countdown' found in the DOM.");
            return;
        }
        const [year, month, day, hour, minute] = endDateTime.split(",").map(Number);
        const endDate = new Date(year, month - 1, day, hour, minute);
        function updateCountdown() {
            const now = new Date();
            const timeDifference = endDate - now;
            let countdownText;
            if (timeDifference <= 0) {
                countdownText = "00:00:00";
                clearInterval(interval);
            } else {
                const totalSeconds = Math.floor(timeDifference / 1000);
                const totalHours = Math.floor(totalSeconds / 3600);
                const andText = window.translations.counter.and;
                // When more than 24 hours left: show days, hours, and minutes
                if (totalHours >= 24) {
                    const days = Math.floor(totalHours / 24);
                    const hours = totalHours % 24;
                    const minutes = Math.floor(totalSeconds % 3600 / 60);
                    const daysText = days === 1 ? window.translations.counter.day : window.translations.counter.days;
                    const hoursText = hours === 1 ? window.translations.counter.hour : window.translations.counter.hours;
                    const minutesText = minutes === 1 ? window.translations.counter.minute : window.translations.counter.minutes;
                    countdownText = `<strong>${days}</strong> ${daysText}, <strong>${hours}</strong> ${hoursText} ${andText} <strong>${minutes}</strong> ${minutesText}`;
                } else {
                    // When less than 24 hours left: show hours, minutes, and seconds
                    const hours = totalHours;
                    const minutes = Math.floor(totalSeconds % 3600 / 60);
                    const seconds = totalSeconds % 60;
                    const hoursText = hours === 1 ? window.translations.counter.hour : window.translations.counter.hours;
                    const minutesText = minutes === 1 ? window.translations.counter.minute : window.translations.counter.minutes;
                    const secondsText = seconds === 1 ? window.translations.counter.second : window.translations.counter.seconds;
                    countdownText = `<strong>${hours}</strong> ${hoursText}, <strong>${minutes}</strong> ${minutesText} ${andText} <strong>${seconds}</strong> ${secondsText}`;
                }
            }
            if (textToUpdate === '') textToUpdate = "$counter";
            countdownElements.forEach((element)=>{
                const updatedText = element.innerHTML.replace(textToUpdate, countdownText);
                element.innerHTML = updatedText;
            });
            textToUpdate = countdownText;
        }
        updateCountdown();
        interval = setInterval(updateCountdown, 1000);
    }
    window.onload = function() {
        const swiperElement = document.getElementById("swiper");
        startCountdown(swiperElement.dataset.dateto);
    };
}


parcelRequire("izvSC");

})();
//# sourceMappingURL=parcel_scripts.js.map
